(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire0a55"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire0a55"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1DJsI", function(module, exports) {

var $Jm0Yx = parcelRequire("Jm0Yx");
var $131cb2cf5f9464a2$var$hasWindow = typeof window !== "undefined";
function $131cb2cf5f9464a2$var$createScheduler() {
    var scheduler;
    if ($131cb2cf5f9464a2$var$hasWindow) {
        if (!window._nanoScheduler) window._nanoScheduler = new $131cb2cf5f9464a2$var$NanoScheduler(true);
        scheduler = window._nanoScheduler;
    } else scheduler = new $131cb2cf5f9464a2$var$NanoScheduler();
    return scheduler;
}
function $131cb2cf5f9464a2$var$NanoScheduler(hasWindow) {
    this.hasWindow = hasWindow;
    this.hasIdle = this.hasWindow && window.requestIdleCallback;
    this.method = this.hasIdle ? window.requestIdleCallback.bind(window) : this.setTimeout;
    this.scheduled = false;
    this.queue = [];
}
$131cb2cf5f9464a2$var$NanoScheduler.prototype.push = function(cb) {
    $Jm0Yx.equal(typeof cb, "function", "nanoscheduler.push: cb should be type function");
    this.queue.push(cb);
    this.schedule();
};
$131cb2cf5f9464a2$var$NanoScheduler.prototype.schedule = function() {
    if (this.scheduled) return;
    this.scheduled = true;
    var self = this;
    this.method(function(idleDeadline) {
        var cb;
        while(self.queue.length && idleDeadline.timeRemaining() > 0){
            cb = self.queue.shift();
            cb(idleDeadline);
        }
        self.scheduled = false;
        if (self.queue.length) self.schedule();
    });
};
$131cb2cf5f9464a2$var$NanoScheduler.prototype.setTimeout = function(cb) {
    setTimeout(cb, 0, {
        timeRemaining: function() {
            return 1;
        }
    });
};
module.exports = $131cb2cf5f9464a2$var$createScheduler;

});
parcelRegister("Jm0Yx", function(module, exports) {
$088547c056753fbd$var$assert.notEqual = $088547c056753fbd$var$notEqual;
$088547c056753fbd$var$assert.notOk = $088547c056753fbd$var$notOk;
$088547c056753fbd$var$assert.equal = $088547c056753fbd$var$equal;
$088547c056753fbd$var$assert.ok = $088547c056753fbd$var$assert;
module.exports = $088547c056753fbd$var$assert;
function $088547c056753fbd$var$equal(a, b, m) {
    $088547c056753fbd$var$assert(a == b, m) // eslint-disable-line eqeqeq
    ;
}
function $088547c056753fbd$var$notEqual(a, b, m) {
    $088547c056753fbd$var$assert(a != b, m) // eslint-disable-line eqeqeq
    ;
}
function $088547c056753fbd$var$notOk(t, m) {
    $088547c056753fbd$var$assert(!t, m);
}
function $088547c056753fbd$var$assert(t, m) {
    if (!t) throw new Error(m || "AssertionError");
}

});


parcelRegister("6HmnW", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $jgs6G = parcelRequire("jgs6G");
"use strict";
function $4e081f72cf8c421b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4e081f72cf8c421b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4e081f72cf8c421b$var$_typeof(o);
}
function $4e081f72cf8c421b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $4e081f72cf8c421b$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $4e081f72cf8c421b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $4e081f72cf8c421b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4e081f72cf8c421b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $4e081f72cf8c421b$var$_toPropertyKey(arg) {
    var key = $4e081f72cf8c421b$var$_toPrimitive(arg, "string");
    return $4e081f72cf8c421b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $4e081f72cf8c421b$var$_toPrimitive(input, hint) {
    if ($4e081f72cf8c421b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($4e081f72cf8c421b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $4e081f72cf8c421b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $98EGw = parcelRequire("98EGw");
var $4e081f72cf8c421b$var$_require$codes = $98EGw.codes, $4e081f72cf8c421b$var$ERR_AMBIGUOUS_ARGUMENT = $4e081f72cf8c421b$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $4e081f72cf8c421b$var$ERR_INVALID_ARG_TYPE = $4e081f72cf8c421b$var$_require$codes.ERR_INVALID_ARG_TYPE, $4e081f72cf8c421b$var$ERR_INVALID_ARG_VALUE = $4e081f72cf8c421b$var$_require$codes.ERR_INVALID_ARG_VALUE, $4e081f72cf8c421b$var$ERR_INVALID_RETURN_VALUE = $4e081f72cf8c421b$var$_require$codes.ERR_INVALID_RETURN_VALUE, $4e081f72cf8c421b$var$ERR_MISSING_ARGS = $4e081f72cf8c421b$var$_require$codes.ERR_MISSING_ARGS;

var $gULqW = parcelRequire("gULqW");

var $ersGt = parcelRequire("ersGt");
var $4e081f72cf8c421b$var$inspect = $ersGt.inspect;

var $ersGt = parcelRequire("ersGt");
var $4e081f72cf8c421b$require$_require$types = $ersGt.types;
var $4e081f72cf8c421b$var$isPromise = $4e081f72cf8c421b$require$_require$types.isPromise, $4e081f72cf8c421b$var$isRegExp = $4e081f72cf8c421b$require$_require$types.isRegExp;

var $4e081f72cf8c421b$var$objectAssign = (parcelRequire("1B01c"))();

var $4e081f72cf8c421b$var$objectIs = (parcelRequire("1IqFn"))();

var $4e081f72cf8c421b$var$RegExpPrototypeTest = (parcelRequire("6YhGh"))("RegExp.prototype.test");
var $4e081f72cf8c421b$var$errorCache = new Map();
var $4e081f72cf8c421b$var$isDeepEqual;
var $4e081f72cf8c421b$var$isDeepStrictEqual;
var $4e081f72cf8c421b$var$parseExpressionAt;
var $4e081f72cf8c421b$var$findNodeAround;
var $4e081f72cf8c421b$var$decoder;

function $4e081f72cf8c421b$var$lazyLoadComparison() {
    var comparison = (parcelRequire("CT6Uk"));
    $4e081f72cf8c421b$var$isDeepEqual = comparison.isDeepEqual;
    $4e081f72cf8c421b$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $4e081f72cf8c421b$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $4e081f72cf8c421b$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "",
    "",
    "\\u000b",
    "\\f",
    "",
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $4e081f72cf8c421b$var$escapeFn = function escapeFn(str) {
    return $4e081f72cf8c421b$var$meta[str.charCodeAt(0)];
};
var $4e081f72cf8c421b$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $4e081f72cf8c421b$var$assert = module.exports = $4e081f72cf8c421b$var$ok;
var $4e081f72cf8c421b$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $4e081f72cf8c421b$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $gULqW(obj);
}
function $4e081f72cf8c421b$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = "Failed";
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($4e081f72cf8c421b$var$warned === false) {
            $4e081f72cf8c421b$var$warned = true;
            var warn = $jgs6G.emitWarning ? $jgs6G.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", "DeprecationWarning", "DEP0094");
        }
        if (argsLen === 2) operator = "!=";
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? "fail" : operator,
        stackStartFn: stackStartFn || $4e081f72cf8c421b$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $gULqW(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$4e081f72cf8c421b$var$assert.fail = $4e081f72cf8c421b$var$fail;
// The AssertionError is defined in internal/error.
$4e081f72cf8c421b$var$assert.AssertionError = $gULqW;
function $4e081f72cf8c421b$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = "No value argument passed to `assert.ok()`";
        } else if (message instanceof Error) throw message;
        var err = new $gULqW({
            actual: value,
            expected: true,
            message: message,
            operator: "==",
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $4e081f72cf8c421b$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $4e081f72cf8c421b$var$innerOk.apply(void 0, [
        $4e081f72cf8c421b$var$ok,
        args.length
    ].concat(args));
}
$4e081f72cf8c421b$var$assert.ok = $4e081f72cf8c421b$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $4e081f72cf8c421b$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $4e081f72cf8c421b$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $4e081f72cf8c421b$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "==",
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$4e081f72cf8c421b$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $4e081f72cf8c421b$var$ERR_MISSING_ARGS("actual", "expected");
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $4e081f72cf8c421b$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "!=",
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$4e081f72cf8c421b$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $4e081f72cf8c421b$var$ERR_MISSING_ARGS("actual", "expected");
    if ($4e081f72cf8c421b$var$isDeepEqual === undefined) $4e081f72cf8c421b$var$lazyLoadComparison();
    if (!$4e081f72cf8c421b$var$isDeepEqual(actual, expected)) $4e081f72cf8c421b$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepEqual",
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$4e081f72cf8c421b$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $4e081f72cf8c421b$var$ERR_MISSING_ARGS("actual", "expected");
    if ($4e081f72cf8c421b$var$isDeepEqual === undefined) $4e081f72cf8c421b$var$lazyLoadComparison();
    if ($4e081f72cf8c421b$var$isDeepEqual(actual, expected)) $4e081f72cf8c421b$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepEqual",
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $4e081f72cf8c421b$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $4e081f72cf8c421b$var$ERR_MISSING_ARGS("actual", "expected");
    if ($4e081f72cf8c421b$var$isDeepEqual === undefined) $4e081f72cf8c421b$var$lazyLoadComparison();
    if (!$4e081f72cf8c421b$var$isDeepStrictEqual(actual, expected)) $4e081f72cf8c421b$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "deepStrictEqual",
        stackStartFn: deepStrictEqual
    });
};
$4e081f72cf8c421b$var$assert.notDeepStrictEqual = $4e081f72cf8c421b$var$notDeepStrictEqual;
function $4e081f72cf8c421b$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $4e081f72cf8c421b$var$ERR_MISSING_ARGS("actual", "expected");
    if ($4e081f72cf8c421b$var$isDeepEqual === undefined) $4e081f72cf8c421b$var$lazyLoadComparison();
    if ($4e081f72cf8c421b$var$isDeepStrictEqual(actual, expected)) $4e081f72cf8c421b$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notDeepStrictEqual",
        stackStartFn: $4e081f72cf8c421b$var$notDeepStrictEqual
    });
}
$4e081f72cf8c421b$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $4e081f72cf8c421b$var$ERR_MISSING_ARGS("actual", "expected");
    if (!$4e081f72cf8c421b$var$objectIs(actual, expected)) $4e081f72cf8c421b$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "strictEqual",
        stackStartFn: strictEqual
    });
};
$4e081f72cf8c421b$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $4e081f72cf8c421b$var$ERR_MISSING_ARGS("actual", "expected");
    if ($4e081f72cf8c421b$var$objectIs(actual, expected)) $4e081f72cf8c421b$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: "notStrictEqual",
        stackStartFn: notStrictEqual
    });
};
var $4e081f72cf8c421b$var$Comparison = /*#__PURE__*/ $4e081f72cf8c421b$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $4e081f72cf8c421b$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === "string" && $4e081f72cf8c421b$var$isRegExp(obj[key]) && $4e081f72cf8c421b$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $4e081f72cf8c421b$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$4e081f72cf8c421b$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $4e081f72cf8c421b$var$Comparison(actual, keys);
            var b = new $4e081f72cf8c421b$var$Comparison(expected, keys, actual);
            var err = new $gULqW({
                actual: a,
                expected: b,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $4e081f72cf8c421b$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $4e081f72cf8c421b$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== "function") {
        if ($4e081f72cf8c421b$var$isRegExp(expected)) return $4e081f72cf8c421b$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $4e081f72cf8c421b$var$ERR_INVALID_ARG_TYPE("expected", [
            "Function",
            "RegExp"
        ], expected);
        // Handle primitives properly.
        if ($4e081f72cf8c421b$var$_typeof(actual) !== "object" || actual === null) {
            var err = new $gULqW({
                actual: actual,
                expected: expected,
                message: msg,
                operator: "deepStrictEqual",
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push("name", "message");
        else if (keys.length === 0) throw new $4e081f72cf8c421b$var$ERR_INVALID_ARG_VALUE("error", expected, "may not be an empty object");
        if ($4e081f72cf8c421b$var$isDeepEqual === undefined) $4e081f72cf8c421b$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === "string" && $4e081f72cf8c421b$var$isRegExp(expected[key]) && $4e081f72cf8c421b$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $4e081f72cf8c421b$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $4e081f72cf8c421b$var$getActual(fn) {
    if (typeof fn !== "function") throw new $4e081f72cf8c421b$var$ERR_INVALID_ARG_TYPE("fn", "Function", fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $4e081f72cf8c421b$var$NO_EXCEPTION_SENTINEL;
}
function $4e081f72cf8c421b$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $4e081f72cf8c421b$var$isPromise(obj) || obj !== null && $4e081f72cf8c421b$var$_typeof(obj) === "object" && typeof obj.then === "function" && typeof obj.catch === "function";
}
function $4e081f72cf8c421b$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === "function") {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$4e081f72cf8c421b$var$checkIsPromise(resultPromise)) throw new $4e081f72cf8c421b$var$ERR_INVALID_RETURN_VALUE("instance of Promise", "promiseFn", resultPromise);
        } else if ($4e081f72cf8c421b$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $4e081f72cf8c421b$var$ERR_INVALID_ARG_TYPE("promiseFn", [
            "Function",
            "Promise"
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $4e081f72cf8c421b$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $4e081f72cf8c421b$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === "string") {
        if (arguments.length === 4) throw new $4e081f72cf8c421b$var$ERR_INVALID_ARG_TYPE("error", [
            "Object",
            "Error",
            "Function",
            "RegExp"
        ], error);
        if ($4e081f72cf8c421b$var$_typeof(actual) === "object" && actual !== null) {
            if (actual.message === error) throw new $4e081f72cf8c421b$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error message "'.concat(actual.message, '" is identical to the message.'));
        } else if (actual === error) throw new $4e081f72cf8c421b$var$ERR_AMBIGUOUS_ARGUMENT("error/message", 'The error "'.concat(actual, '" is identical to the message.'));
        message = error;
        error = undefined;
    } else if (error != null && $4e081f72cf8c421b$var$_typeof(error) !== "object" && typeof error !== "function") throw new $4e081f72cf8c421b$var$ERR_INVALID_ARG_TYPE("error", [
        "Object",
        "Error",
        "Function",
        "RegExp"
    ], error);
    if (actual === $4e081f72cf8c421b$var$NO_EXCEPTION_SENTINEL) {
        var details = "";
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "rejects" ? "rejection" : "exception";
        $4e081f72cf8c421b$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$4e081f72cf8c421b$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $4e081f72cf8c421b$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $4e081f72cf8c421b$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === "string") {
        message = error;
        error = undefined;
    }
    if (!error || $4e081f72cf8c421b$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : ".";
        var fnType = stackStartFn.name === "doesNotReject" ? "rejection" : "exception";
        $4e081f72cf8c421b$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + 'Actual message: "'.concat(actual && actual.message, '"'),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$4e081f72cf8c421b$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $4e081f72cf8c421b$var$expectsError.apply(void 0, [
        throws,
        $4e081f72cf8c421b$var$getActual(promiseFn)
    ].concat(args));
};
$4e081f72cf8c421b$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $4e081f72cf8c421b$var$waitForActual(promiseFn).then(function(result) {
        return $4e081f72cf8c421b$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$4e081f72cf8c421b$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $4e081f72cf8c421b$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $4e081f72cf8c421b$var$getActual(fn)
    ].concat(args));
};
$4e081f72cf8c421b$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $4e081f72cf8c421b$var$waitForActual(fn).then(function(result) {
        return $4e081f72cf8c421b$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$4e081f72cf8c421b$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = "ifError got unwanted exception: ";
        if ($4e081f72cf8c421b$var$_typeof(err) === "object" && typeof err.message === "string") {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $4e081f72cf8c421b$var$inspect(err);
        var newErr = new $gULqW({
            actual: err,
            expected: null,
            operator: "ifError",
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === "string") {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split("\n");
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split("\n");
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join("\n"), "\n").concat(tmp2.join("\n"));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $4e081f72cf8c421b$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$4e081f72cf8c421b$var$isRegExp(regexp)) throw new $4e081f72cf8c421b$var$ERR_INVALID_ARG_TYPE("regexp", "RegExp", regexp);
    var match = fnName === "match";
    if (typeof string !== "string" || $4e081f72cf8c421b$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== "string" ? 'The "string" argument must be of type string. Received type ' + "".concat($4e081f72cf8c421b$var$_typeof(string), " (").concat($4e081f72cf8c421b$var$inspect(string), ")") : (match ? "The input did not match the regular expression " : "The input was expected to not match the regular expression ") + "".concat($4e081f72cf8c421b$var$inspect(regexp), ". Input:\n\n").concat($4e081f72cf8c421b$var$inspect(string), "\n"));
        var err = new $gULqW({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$4e081f72cf8c421b$var$assert.match = function match(string, regexp, message) {
    $4e081f72cf8c421b$var$internalMatch(string, regexp, message, match, "match");
};
$4e081f72cf8c421b$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $4e081f72cf8c421b$var$internalMatch(string, regexp, message, doesNotMatch, "doesNotMatch");
};
// Expose a strict only variant of assert
function $4e081f72cf8c421b$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $4e081f72cf8c421b$var$innerOk.apply(void 0, [
        $4e081f72cf8c421b$var$strict,
        args.length
    ].concat(args));
}
$4e081f72cf8c421b$var$assert.strict = $4e081f72cf8c421b$var$objectAssign($4e081f72cf8c421b$var$strict, $4e081f72cf8c421b$var$assert, {
    equal: $4e081f72cf8c421b$var$assert.strictEqual,
    deepEqual: $4e081f72cf8c421b$var$assert.deepStrictEqual,
    notEqual: $4e081f72cf8c421b$var$assert.notStrictEqual,
    notDeepEqual: $4e081f72cf8c421b$var$assert.notDeepStrictEqual
});
$4e081f72cf8c421b$var$assert.strict.strict = $4e081f72cf8c421b$var$assert.strict;

});
parcelRegister("jgs6G", function(module, exports) {
// shim for using process in browser
var $e065505869f72d28$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $e065505869f72d28$var$cachedSetTimeout;
var $e065505869f72d28$var$cachedClearTimeout;
function $e065505869f72d28$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $e065505869f72d28$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $e065505869f72d28$var$cachedSetTimeout = setTimeout;
        else $e065505869f72d28$var$cachedSetTimeout = $e065505869f72d28$var$defaultSetTimout;
    } catch (e) {
        $e065505869f72d28$var$cachedSetTimeout = $e065505869f72d28$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $e065505869f72d28$var$cachedClearTimeout = clearTimeout;
        else $e065505869f72d28$var$cachedClearTimeout = $e065505869f72d28$var$defaultClearTimeout;
    } catch (e) {
        $e065505869f72d28$var$cachedClearTimeout = $e065505869f72d28$var$defaultClearTimeout;
    }
})();
function $e065505869f72d28$var$runTimeout(fun) {
    if ($e065505869f72d28$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($e065505869f72d28$var$cachedSetTimeout === $e065505869f72d28$var$defaultSetTimout || !$e065505869f72d28$var$cachedSetTimeout) && setTimeout) {
        $e065505869f72d28$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e065505869f72d28$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $e065505869f72d28$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $e065505869f72d28$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $e065505869f72d28$var$runClearTimeout(marker) {
    if ($e065505869f72d28$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($e065505869f72d28$var$cachedClearTimeout === $e065505869f72d28$var$defaultClearTimeout || !$e065505869f72d28$var$cachedClearTimeout) && clearTimeout) {
        $e065505869f72d28$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $e065505869f72d28$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $e065505869f72d28$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $e065505869f72d28$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $e065505869f72d28$var$queue = [];
var $e065505869f72d28$var$draining = false;
var $e065505869f72d28$var$currentQueue;
var $e065505869f72d28$var$queueIndex = -1;
function $e065505869f72d28$var$cleanUpNextTick() {
    if (!$e065505869f72d28$var$draining || !$e065505869f72d28$var$currentQueue) return;
    $e065505869f72d28$var$draining = false;
    if ($e065505869f72d28$var$currentQueue.length) $e065505869f72d28$var$queue = $e065505869f72d28$var$currentQueue.concat($e065505869f72d28$var$queue);
    else $e065505869f72d28$var$queueIndex = -1;
    if ($e065505869f72d28$var$queue.length) $e065505869f72d28$var$drainQueue();
}
function $e065505869f72d28$var$drainQueue() {
    if ($e065505869f72d28$var$draining) return;
    var timeout = $e065505869f72d28$var$runTimeout($e065505869f72d28$var$cleanUpNextTick);
    $e065505869f72d28$var$draining = true;
    var len = $e065505869f72d28$var$queue.length;
    while(len){
        $e065505869f72d28$var$currentQueue = $e065505869f72d28$var$queue;
        $e065505869f72d28$var$queue = [];
        while(++$e065505869f72d28$var$queueIndex < len)if ($e065505869f72d28$var$currentQueue) $e065505869f72d28$var$currentQueue[$e065505869f72d28$var$queueIndex].run();
        $e065505869f72d28$var$queueIndex = -1;
        len = $e065505869f72d28$var$queue.length;
    }
    $e065505869f72d28$var$currentQueue = null;
    $e065505869f72d28$var$draining = false;
    $e065505869f72d28$var$runClearTimeout(timeout);
}
$e065505869f72d28$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $e065505869f72d28$var$queue.push(new $e065505869f72d28$var$Item(fun, args));
    if ($e065505869f72d28$var$queue.length === 1 && !$e065505869f72d28$var$draining) $e065505869f72d28$var$runTimeout($e065505869f72d28$var$drainQueue);
};
// v8 likes predictible objects
function $e065505869f72d28$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$e065505869f72d28$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$e065505869f72d28$var$process.title = "browser";
$e065505869f72d28$var$process.browser = true;
$e065505869f72d28$var$process.env = {};
$e065505869f72d28$var$process.argv = [];
$e065505869f72d28$var$process.version = ""; // empty string to avoid regexp issues
$e065505869f72d28$var$process.versions = {};
function $e065505869f72d28$var$noop() {}
$e065505869f72d28$var$process.on = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.addListener = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.once = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.off = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.removeListener = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.removeAllListeners = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.emit = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.prependListener = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.prependOnceListener = $e065505869f72d28$var$noop;
$e065505869f72d28$var$process.listeners = function(name) {
    return [];
};
$e065505869f72d28$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$e065505869f72d28$var$process.cwd = function() {
    return "/";
};
$e065505869f72d28$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$e065505869f72d28$var$process.umask = function() {
    return 0;
};

});

parcelRegister("98EGw", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $6a746b988f908180$export$e45cb6485273080e; }, function (v) { return $6a746b988f908180$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $6a746b988f908180$export$e45cb6485273080e;
"use strict";
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $6a746b988f908180$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6a746b988f908180$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6a746b988f908180$var$_typeof(o);
}
function $6a746b988f908180$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $6a746b988f908180$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $6a746b988f908180$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $6a746b988f908180$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $6a746b988f908180$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $6a746b988f908180$var$_toPropertyKey(arg) {
    var key = $6a746b988f908180$var$_toPrimitive(arg, "string");
    return $6a746b988f908180$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6a746b988f908180$var$_toPrimitive(input, hint) {
    if ($6a746b988f908180$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6a746b988f908180$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6a746b988f908180$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6a746b988f908180$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $6a746b988f908180$var$_setPrototypeOf(subClass, superClass);
}
function $6a746b988f908180$var$_setPrototypeOf(o, p) {
    $6a746b988f908180$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6a746b988f908180$var$_setPrototypeOf(o, p);
}
function $6a746b988f908180$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $6a746b988f908180$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $6a746b988f908180$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $6a746b988f908180$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $6a746b988f908180$var$_possibleConstructorReturn(this, result);
    };
}
function $6a746b988f908180$var$_possibleConstructorReturn(self, call) {
    if (call && ($6a746b988f908180$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $6a746b988f908180$var$_assertThisInitialized(self);
}
function $6a746b988f908180$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $6a746b988f908180$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $6a746b988f908180$var$_getPrototypeOf(o) {
    $6a746b988f908180$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $6a746b988f908180$var$_getPrototypeOf(o);
}
var $6a746b988f908180$var$codes = {};
// Lazy loaded
var $6a746b988f908180$var$assert;
var $6a746b988f908180$var$util;
function $6a746b988f908180$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $6a746b988f908180$var$_inherits(NodeError, _Base);
        var _super = $6a746b988f908180$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $6a746b988f908180$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $6a746b988f908180$var$_createClass(NodeError);
    }(Base);
    $6a746b988f908180$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $6a746b988f908180$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $6a746b988f908180$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $6a746b988f908180$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $6a746b988f908180$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$6a746b988f908180$var$createErrorType("ERR_AMBIGUOUS_ARGUMENT", 'The "%s" argument is ambiguous. %s', TypeError);

$6a746b988f908180$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    if ($6a746b988f908180$var$assert === undefined) $6a746b988f908180$var$assert = (parcelRequire("6HmnW"));
    $6a746b988f908180$var$assert(typeof name === "string", "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $6a746b988f908180$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($6a746b988f908180$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($6a746b988f908180$var$oneOf(expected, "type"));
    else {
        var type = $6a746b988f908180$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($6a746b988f908180$var$oneOf(expected, "type"));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($6a746b988f908180$var$_typeof(actual));
    return msg;
}, TypeError);

$6a746b988f908180$var$createErrorType("ERR_INVALID_ARG_VALUE", function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "is invalid";
    if ($6a746b988f908180$var$util === undefined) $6a746b988f908180$var$util = (parcelRequire("ersGt"));
    var inspected = $6a746b988f908180$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$6a746b988f908180$var$createErrorType("ERR_INVALID_RETURN_VALUE", function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($6a746b988f908180$var$_typeof(value));
    return "Expected ".concat(input, ' to be returned from the "').concat(name, '"') + " function but got ".concat(type, ".");
}, TypeError);

$6a746b988f908180$var$createErrorType("ERR_MISSING_ARGS", function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($6a746b988f908180$var$assert === undefined) $6a746b988f908180$var$assert = (parcelRequire("6HmnW"));
    $6a746b988f908180$var$assert(args.length > 0, "At least one arg needs to be specified");
    var msg = "The ";
    var len = args.length;
    args = args.map(function(a) {
        return '"'.concat(a, '"');
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(", ");
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$6a746b988f908180$export$e45cb6485273080e = $6a746b988f908180$var$codes;

});
parcelRegister("ersGt", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $jgs6G = parcelRequire("jgs6G");
var $a839d65a800ee544$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $a839d65a800ee544$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$a839d65a800ee544$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($a839d65a800ee544$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($a839d65a800ee544$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($a839d65a800ee544$var$isNull(x) || !$a839d65a800ee544$var$isObject(x)) str += " " + x;
    else str += " " + $a839d65a800ee544$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    if (typeof $jgs6G !== "undefined" && $jgs6G.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $jgs6G === "undefined") return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($jgs6G.throwDeprecation) throw new Error(msg);
            else if ($jgs6G.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $a839d65a800ee544$var$debugs = {};
var $a839d65a800ee544$var$debugEnvRegex = /^$/;
var $a839d65a800ee544$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$a839d65a800ee544$var$debugs[set]) {
        if ($a839d65a800ee544$var$debugEnvRegex.test(set)) {
            var pid = $jgs6G.pid;
            $a839d65a800ee544$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $a839d65a800ee544$var$debugs[set] = function() {};
    }
    return $a839d65a800ee544$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $a839d65a800ee544$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $a839d65a800ee544$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($a839d65a800ee544$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($a839d65a800ee544$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($a839d65a800ee544$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($a839d65a800ee544$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($a839d65a800ee544$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $a839d65a800ee544$var$stylizeWithColor;
    return $a839d65a800ee544$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $a839d65a800ee544$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$a839d65a800ee544$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$a839d65a800ee544$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $a839d65a800ee544$var$stylizeWithColor(str, styleType) {
    var style = $a839d65a800ee544$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $a839d65a800ee544$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $a839d65a800ee544$var$inspect.colors[style][1] + "m";
    else return str;
}
function $a839d65a800ee544$var$stylizeNoColor(str, styleType) {
    return str;
}
function $a839d65a800ee544$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $a839d65a800ee544$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $a839d65a800ee544$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$a839d65a800ee544$var$isString(ret)) ret = $a839d65a800ee544$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $a839d65a800ee544$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $a839d65a800ee544$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($a839d65a800ee544$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $a839d65a800ee544$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($a839d65a800ee544$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($a839d65a800ee544$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($a839d65a800ee544$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($a839d65a800ee544$var$isError(value)) return $a839d65a800ee544$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($a839d65a800ee544$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($a839d65a800ee544$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($a839d65a800ee544$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($a839d65a800ee544$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($a839d65a800ee544$var$isError(value)) base = " " + $a839d65a800ee544$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($a839d65a800ee544$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $a839d65a800ee544$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $a839d65a800ee544$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $a839d65a800ee544$var$reduceToSingleString(output, base, braces);
}
function $a839d65a800ee544$var$formatPrimitive(ctx, value) {
    if ($a839d65a800ee544$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($a839d65a800ee544$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($a839d65a800ee544$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($a839d65a800ee544$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($a839d65a800ee544$var$isNull(value)) return ctx.stylize("null", "null");
}
function $a839d65a800ee544$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $a839d65a800ee544$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($a839d65a800ee544$var$hasOwnProperty(value, String(i))) output.push($a839d65a800ee544$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($a839d65a800ee544$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $a839d65a800ee544$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$a839d65a800ee544$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($a839d65a800ee544$var$isNull(recurseTimes)) str = $a839d65a800ee544$var$formatValue(ctx, desc.value, null);
            else str = $a839d65a800ee544$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($a839d65a800ee544$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $a839d65a800ee544$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("3uObA"));
function $a839d65a800ee544$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $a839d65a800ee544$var$isArray;
function $a839d65a800ee544$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
module.exports.isBoolean = $a839d65a800ee544$var$isBoolean;
function $a839d65a800ee544$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $a839d65a800ee544$var$isNull;
function $a839d65a800ee544$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $a839d65a800ee544$var$isNullOrUndefined;
function $a839d65a800ee544$var$isNumber(arg) {
    return typeof arg === "number";
}
module.exports.isNumber = $a839d65a800ee544$var$isNumber;
function $a839d65a800ee544$var$isString(arg) {
    return typeof arg === "string";
}
module.exports.isString = $a839d65a800ee544$var$isString;
function $a839d65a800ee544$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
module.exports.isSymbol = $a839d65a800ee544$var$isSymbol;
function $a839d65a800ee544$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $a839d65a800ee544$var$isUndefined;
function $a839d65a800ee544$var$isRegExp(re) {
    return $a839d65a800ee544$var$isObject(re) && $a839d65a800ee544$var$objectToString(re) === "[object RegExp]";
}
module.exports.isRegExp = $a839d65a800ee544$var$isRegExp;
module.exports.types.isRegExp = $a839d65a800ee544$var$isRegExp;
function $a839d65a800ee544$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
module.exports.isObject = $a839d65a800ee544$var$isObject;
function $a839d65a800ee544$var$isDate(d) {
    return $a839d65a800ee544$var$isObject(d) && $a839d65a800ee544$var$objectToString(d) === "[object Date]";
}
module.exports.isDate = $a839d65a800ee544$var$isDate;
module.exports.types.isDate = $a839d65a800ee544$var$isDate;
function $a839d65a800ee544$var$isError(e) {
    return $a839d65a800ee544$var$isObject(e) && ($a839d65a800ee544$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
module.exports.isError = $a839d65a800ee544$var$isError;
module.exports.types.isNativeError = $a839d65a800ee544$var$isError;
function $a839d65a800ee544$var$isFunction(arg) {
    return typeof arg === "function";
}
module.exports.isFunction = $a839d65a800ee544$var$isFunction;
function $a839d65a800ee544$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
module.exports.isPrimitive = $a839d65a800ee544$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("9PbZA"));
function $a839d65a800ee544$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $a839d65a800ee544$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $a839d65a800ee544$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $a839d65a800ee544$var$timestamp() {
    var d = new Date();
    var time = [
        $a839d65a800ee544$var$pad(d.getHours()),
        $a839d65a800ee544$var$pad(d.getMinutes()),
        $a839d65a800ee544$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $a839d65a800ee544$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log("%s - %s", $a839d65a800ee544$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("htbXe"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$a839d65a800ee544$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $a839d65a800ee544$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $a839d65a800ee544$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($a839d65a800ee544$var$kCustomPromisifiedSymbol && original[$a839d65a800ee544$var$kCustomPromisifiedSymbol]) {
        var fn = original[$a839d65a800ee544$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $a839d65a800ee544$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($a839d65a800ee544$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $a839d65a800ee544$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $a839d65a800ee544$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $a839d65a800ee544$var$kCustomPromisifiedSymbol;
function $a839d65a800ee544$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $a839d65a800ee544$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $jgs6G.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $jgs6G.nextTick($a839d65a800ee544$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $a839d65a800ee544$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $a839d65a800ee544$var$callbackify;

});
parcelRegister("3uObA", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $a6Kf1 = parcelRequire("a6Kf1");

var $3Qlp9 = parcelRequire("3Qlp9");

var $af53G = parcelRequire("af53G");

var $50vd7 = parcelRequire("50vd7");
function $28bb1a4e77be989c$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $28bb1a4e77be989c$var$BigIntSupported = typeof BigInt !== "undefined";
var $28bb1a4e77be989c$var$SymbolSupported = typeof Symbol !== "undefined";
var $28bb1a4e77be989c$var$ObjectToString = $28bb1a4e77be989c$var$uncurryThis(Object.prototype.toString);
var $28bb1a4e77be989c$var$numberValue = $28bb1a4e77be989c$var$uncurryThis(Number.prototype.valueOf);
var $28bb1a4e77be989c$var$stringValue = $28bb1a4e77be989c$var$uncurryThis(String.prototype.valueOf);
var $28bb1a4e77be989c$var$booleanValue = $28bb1a4e77be989c$var$uncurryThis(Boolean.prototype.valueOf);
if ($28bb1a4e77be989c$var$BigIntSupported) var $28bb1a4e77be989c$var$bigIntValue = $28bb1a4e77be989c$var$uncurryThis(BigInt.prototype.valueOf);
if ($28bb1a4e77be989c$var$SymbolSupported) var $28bb1a4e77be989c$var$symbolValue = $28bb1a4e77be989c$var$uncurryThis(Symbol.prototype.valueOf);
function $28bb1a4e77be989c$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $a6Kf1;
module.exports.isGeneratorFunction = $3Qlp9;
module.exports.isTypedArray = $50vd7;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $28bb1a4e77be989c$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $28bb1a4e77be989c$var$isPromise;
function $28bb1a4e77be989c$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $50vd7(value) || $28bb1a4e77be989c$var$isDataView(value);
}
module.exports.isArrayBufferView = $28bb1a4e77be989c$var$isArrayBufferView;
function $28bb1a4e77be989c$var$isUint8Array(value) {
    return $af53G(value) === "Uint8Array";
}
module.exports.isUint8Array = $28bb1a4e77be989c$var$isUint8Array;
function $28bb1a4e77be989c$var$isUint8ClampedArray(value) {
    return $af53G(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $28bb1a4e77be989c$var$isUint8ClampedArray;
function $28bb1a4e77be989c$var$isUint16Array(value) {
    return $af53G(value) === "Uint16Array";
}
module.exports.isUint16Array = $28bb1a4e77be989c$var$isUint16Array;
function $28bb1a4e77be989c$var$isUint32Array(value) {
    return $af53G(value) === "Uint32Array";
}
module.exports.isUint32Array = $28bb1a4e77be989c$var$isUint32Array;
function $28bb1a4e77be989c$var$isInt8Array(value) {
    return $af53G(value) === "Int8Array";
}
module.exports.isInt8Array = $28bb1a4e77be989c$var$isInt8Array;
function $28bb1a4e77be989c$var$isInt16Array(value) {
    return $af53G(value) === "Int16Array";
}
module.exports.isInt16Array = $28bb1a4e77be989c$var$isInt16Array;
function $28bb1a4e77be989c$var$isInt32Array(value) {
    return $af53G(value) === "Int32Array";
}
module.exports.isInt32Array = $28bb1a4e77be989c$var$isInt32Array;
function $28bb1a4e77be989c$var$isFloat32Array(value) {
    return $af53G(value) === "Float32Array";
}
module.exports.isFloat32Array = $28bb1a4e77be989c$var$isFloat32Array;
function $28bb1a4e77be989c$var$isFloat64Array(value) {
    return $af53G(value) === "Float64Array";
}
module.exports.isFloat64Array = $28bb1a4e77be989c$var$isFloat64Array;
function $28bb1a4e77be989c$var$isBigInt64Array(value) {
    return $af53G(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $28bb1a4e77be989c$var$isBigInt64Array;
function $28bb1a4e77be989c$var$isBigUint64Array(value) {
    return $af53G(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $28bb1a4e77be989c$var$isBigUint64Array;
function $28bb1a4e77be989c$var$isMapToString(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object Map]";
}
$28bb1a4e77be989c$var$isMapToString.working = typeof Map !== "undefined" && $28bb1a4e77be989c$var$isMapToString(new Map());
function $28bb1a4e77be989c$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $28bb1a4e77be989c$var$isMapToString.working ? $28bb1a4e77be989c$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $28bb1a4e77be989c$var$isMap;
function $28bb1a4e77be989c$var$isSetToString(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object Set]";
}
$28bb1a4e77be989c$var$isSetToString.working = typeof Set !== "undefined" && $28bb1a4e77be989c$var$isSetToString(new Set());
function $28bb1a4e77be989c$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $28bb1a4e77be989c$var$isSetToString.working ? $28bb1a4e77be989c$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $28bb1a4e77be989c$var$isSet;
function $28bb1a4e77be989c$var$isWeakMapToString(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object WeakMap]";
}
$28bb1a4e77be989c$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $28bb1a4e77be989c$var$isWeakMapToString(new WeakMap());
function $28bb1a4e77be989c$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $28bb1a4e77be989c$var$isWeakMapToString.working ? $28bb1a4e77be989c$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $28bb1a4e77be989c$var$isWeakMap;
function $28bb1a4e77be989c$var$isWeakSetToString(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object WeakSet]";
}
$28bb1a4e77be989c$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $28bb1a4e77be989c$var$isWeakSetToString(new WeakSet());
function $28bb1a4e77be989c$var$isWeakSet(value) {
    return $28bb1a4e77be989c$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $28bb1a4e77be989c$var$isWeakSet;
function $28bb1a4e77be989c$var$isArrayBufferToString(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$28bb1a4e77be989c$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $28bb1a4e77be989c$var$isArrayBufferToString(new ArrayBuffer());
function $28bb1a4e77be989c$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $28bb1a4e77be989c$var$isArrayBufferToString.working ? $28bb1a4e77be989c$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $28bb1a4e77be989c$var$isArrayBuffer;
function $28bb1a4e77be989c$var$isDataViewToString(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object DataView]";
}
$28bb1a4e77be989c$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $28bb1a4e77be989c$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $28bb1a4e77be989c$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $28bb1a4e77be989c$var$isDataViewToString.working ? $28bb1a4e77be989c$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $28bb1a4e77be989c$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $28bb1a4e77be989c$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $28bb1a4e77be989c$var$isSharedArrayBufferToString(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $28bb1a4e77be989c$var$isSharedArrayBuffer(value) {
    if (typeof $28bb1a4e77be989c$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $28bb1a4e77be989c$var$isSharedArrayBufferToString.working === "undefined") $28bb1a4e77be989c$var$isSharedArrayBufferToString.working = $28bb1a4e77be989c$var$isSharedArrayBufferToString(new $28bb1a4e77be989c$var$SharedArrayBufferCopy());
    return $28bb1a4e77be989c$var$isSharedArrayBufferToString.working ? $28bb1a4e77be989c$var$isSharedArrayBufferToString(value) : value instanceof $28bb1a4e77be989c$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $28bb1a4e77be989c$var$isSharedArrayBuffer;
function $28bb1a4e77be989c$var$isAsyncFunction(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $28bb1a4e77be989c$var$isAsyncFunction;
function $28bb1a4e77be989c$var$isMapIterator(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $28bb1a4e77be989c$var$isMapIterator;
function $28bb1a4e77be989c$var$isSetIterator(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $28bb1a4e77be989c$var$isSetIterator;
function $28bb1a4e77be989c$var$isGeneratorObject(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $28bb1a4e77be989c$var$isGeneratorObject;
function $28bb1a4e77be989c$var$isWebAssemblyCompiledModule(value) {
    return $28bb1a4e77be989c$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $28bb1a4e77be989c$var$isWebAssemblyCompiledModule;
function $28bb1a4e77be989c$var$isNumberObject(value) {
    return $28bb1a4e77be989c$var$checkBoxedPrimitive(value, $28bb1a4e77be989c$var$numberValue);
}
module.exports.isNumberObject = $28bb1a4e77be989c$var$isNumberObject;
function $28bb1a4e77be989c$var$isStringObject(value) {
    return $28bb1a4e77be989c$var$checkBoxedPrimitive(value, $28bb1a4e77be989c$var$stringValue);
}
module.exports.isStringObject = $28bb1a4e77be989c$var$isStringObject;
function $28bb1a4e77be989c$var$isBooleanObject(value) {
    return $28bb1a4e77be989c$var$checkBoxedPrimitive(value, $28bb1a4e77be989c$var$booleanValue);
}
module.exports.isBooleanObject = $28bb1a4e77be989c$var$isBooleanObject;
function $28bb1a4e77be989c$var$isBigIntObject(value) {
    return $28bb1a4e77be989c$var$BigIntSupported && $28bb1a4e77be989c$var$checkBoxedPrimitive(value, $28bb1a4e77be989c$var$bigIntValue);
}
module.exports.isBigIntObject = $28bb1a4e77be989c$var$isBigIntObject;
function $28bb1a4e77be989c$var$isSymbolObject(value) {
    return $28bb1a4e77be989c$var$SymbolSupported && $28bb1a4e77be989c$var$checkBoxedPrimitive(value, $28bb1a4e77be989c$var$symbolValue);
}
module.exports.isSymbolObject = $28bb1a4e77be989c$var$isSymbolObject;
function $28bb1a4e77be989c$var$isBoxedPrimitive(value) {
    return $28bb1a4e77be989c$var$isNumberObject(value) || $28bb1a4e77be989c$var$isStringObject(value) || $28bb1a4e77be989c$var$isBooleanObject(value) || $28bb1a4e77be989c$var$isBigIntObject(value) || $28bb1a4e77be989c$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $28bb1a4e77be989c$var$isBoxedPrimitive;
function $28bb1a4e77be989c$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($28bb1a4e77be989c$var$isArrayBuffer(value) || $28bb1a4e77be989c$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $28bb1a4e77be989c$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("a6Kf1", function(module, exports) {
"use strict";

var $75be55750139ce51$var$hasToStringTag = (parcelRequire("4CtGg"))();

var $6YhGh = parcelRequire("6YhGh");
var $75be55750139ce51$var$$toString = $6YhGh("Object.prototype.toString");
var $75be55750139ce51$var$isStandardArguments = function isArguments(value) {
    if ($75be55750139ce51$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $75be55750139ce51$var$$toString(value) === "[object Arguments]";
};
var $75be55750139ce51$var$isLegacyArguments = function isArguments(value) {
    if ($75be55750139ce51$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $75be55750139ce51$var$$toString(value) !== "[object Array]" && $75be55750139ce51$var$$toString(value.callee) === "[object Function]";
};
var $75be55750139ce51$var$supportsStandardArguments = function() {
    return $75be55750139ce51$var$isStandardArguments(arguments);
}();
$75be55750139ce51$var$isStandardArguments.isLegacyArguments = $75be55750139ce51$var$isLegacyArguments; // for tests
module.exports = $75be55750139ce51$var$supportsStandardArguments ? $75be55750139ce51$var$isStandardArguments : $75be55750139ce51$var$isLegacyArguments;

});
parcelRegister("4CtGg", function(module, exports) {
"use strict";

var $jgZd3 = parcelRequire("jgZd3");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $jgZd3() && !!Symbol.toStringTag;
};

});
parcelRegister("jgZd3", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("6YhGh", function(module, exports) {
"use strict";

var $jL42x = parcelRequire("jL42x");

var $9nLII = parcelRequire("9nLII");
var $51360fb96dc9864d$var$$indexOf = $9nLII($jL42x("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $jL42x(name, !!allowMissing);
    if (typeof intrinsic === "function" && $51360fb96dc9864d$var$$indexOf(name, ".prototype.") > -1) return $9nLII(intrinsic);
    return intrinsic;
};

});
parcelRegister("jL42x", function(module, exports) {
"use strict";
var $e6258a591842359f$var$undefined1;

var $aL3VJ = parcelRequire("aL3VJ");

var $ls3oZ = parcelRequire("ls3oZ");

var $fIltF = parcelRequire("fIltF");

var $cENas = parcelRequire("cENas");

var $68Sk6 = parcelRequire("68Sk6");

var $gIo8M = parcelRequire("gIo8M");

var $1W6jG = parcelRequire("1W6jG");
var $e6258a591842359f$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $e6258a591842359f$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $e6258a591842359f$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $e6258a591842359f$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($e6258a591842359f$var$$gOPD) try {
    $e6258a591842359f$var$$gOPD({}, "");
} catch (e) {
    $e6258a591842359f$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $e6258a591842359f$var$throwTypeError = function() {
    throw new $gIo8M();
};
var $e6258a591842359f$var$ThrowTypeError = $e6258a591842359f$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $e6258a591842359f$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $e6258a591842359f$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $e6258a591842359f$var$throwTypeError;
        }
    }
}() : $e6258a591842359f$var$throwTypeError;

var $e6258a591842359f$var$hasSymbols = (parcelRequire("dwKXJ"))();

var $e6258a591842359f$var$hasProto = (parcelRequire("cZ28A"))();
var $e6258a591842359f$var$getProto = Object.getPrototypeOf || ($e6258a591842359f$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $e6258a591842359f$var$needsEval = {};
var $e6258a591842359f$var$TypedArray = typeof Uint8Array === "undefined" || !$e6258a591842359f$var$getProto ? undefined : $e6258a591842359f$var$getProto(Uint8Array);
var $e6258a591842359f$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $e6258a591842359f$var$hasSymbols && $e6258a591842359f$var$getProto ? $e6258a591842359f$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $e6258a591842359f$var$needsEval,
    "%AsyncGenerator%": $e6258a591842359f$var$needsEval,
    "%AsyncGeneratorFunction%": $e6258a591842359f$var$needsEval,
    "%AsyncIteratorPrototype%": $e6258a591842359f$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $aL3VJ,
    "%eval%": eval,
    "%EvalError%": $ls3oZ,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $e6258a591842359f$var$$Function,
    "%GeneratorFunction%": $e6258a591842359f$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $e6258a591842359f$var$hasSymbols && $e6258a591842359f$var$getProto ? $e6258a591842359f$var$getProto($e6258a591842359f$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$e6258a591842359f$var$hasSymbols || !$e6258a591842359f$var$getProto ? undefined : $e6258a591842359f$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $fIltF,
    "%ReferenceError%": $cENas,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$e6258a591842359f$var$hasSymbols || !$e6258a591842359f$var$getProto ? undefined : $e6258a591842359f$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $e6258a591842359f$var$hasSymbols && $e6258a591842359f$var$getProto ? $e6258a591842359f$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $e6258a591842359f$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $68Sk6,
    "%ThrowTypeError%": $e6258a591842359f$var$ThrowTypeError,
    "%TypedArray%": $e6258a591842359f$var$TypedArray,
    "%TypeError%": $gIo8M,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $1W6jG,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($e6258a591842359f$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $e6258a591842359f$var$errorProto = $e6258a591842359f$var$getProto($e6258a591842359f$var$getProto(e));
    $e6258a591842359f$var$INTRINSICS["%Error.prototype%"] = $e6258a591842359f$var$errorProto;
}
var $e6258a591842359f$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $e6258a591842359f$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $e6258a591842359f$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $e6258a591842359f$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $e6258a591842359f$var$getProto) value = $e6258a591842359f$var$getProto(gen.prototype);
    }
    $e6258a591842359f$var$INTRINSICS[name] = value;
    return value;
};
var $e6258a591842359f$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $kWT2P = parcelRequire("kWT2P");

var $deNME = parcelRequire("deNME");
var $e6258a591842359f$var$$concat = $kWT2P.call(Function.call, Array.prototype.concat);
var $e6258a591842359f$var$$spliceApply = $kWT2P.call(Function.apply, Array.prototype.splice);
var $e6258a591842359f$var$$replace = $kWT2P.call(Function.call, String.prototype.replace);
var $e6258a591842359f$var$$strSlice = $kWT2P.call(Function.call, String.prototype.slice);
var $e6258a591842359f$var$$exec = $kWT2P.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $e6258a591842359f$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $e6258a591842359f$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $e6258a591842359f$var$stringToPath = function stringToPath(string) {
    var first = $e6258a591842359f$var$$strSlice(string, 0, 1);
    var last = $e6258a591842359f$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $68Sk6("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $68Sk6("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $e6258a591842359f$var$$replace(string, $e6258a591842359f$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $e6258a591842359f$var$$replace(subString, $e6258a591842359f$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $e6258a591842359f$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($deNME($e6258a591842359f$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $e6258a591842359f$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($deNME($e6258a591842359f$var$INTRINSICS, intrinsicName)) {
        var value = $e6258a591842359f$var$INTRINSICS[intrinsicName];
        if (value === $e6258a591842359f$var$needsEval) value = $e6258a591842359f$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $gIo8M("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $68Sk6("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $gIo8M("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $gIo8M('"allowMissing" argument must be a boolean');
    if ($e6258a591842359f$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $68Sk6("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $e6258a591842359f$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $e6258a591842359f$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $e6258a591842359f$var$$spliceApply(parts, $e6258a591842359f$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $e6258a591842359f$var$$strSlice(part, 0, 1);
        var last = $e6258a591842359f$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $68Sk6("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($deNME($e6258a591842359f$var$INTRINSICS, intrinsicRealName)) value = $e6258a591842359f$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $gIo8M("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($e6258a591842359f$var$$gOPD && i + 1 >= parts.length) {
                var desc = $e6258a591842359f$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $deNME(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $e6258a591842359f$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aL3VJ", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("ls3oZ", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("fIltF", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("cENas", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("68Sk6", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("gIo8M", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("1W6jG", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("dwKXJ", function(module, exports) {
"use strict";
var $9d92b14d176eed69$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $jgZd3 = parcelRequire("jgZd3");
module.exports = function hasNativeSymbols() {
    if (typeof $9d92b14d176eed69$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $9d92b14d176eed69$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $jgZd3();
};

});

parcelRegister("cZ28A", function(module, exports) {
"use strict";
var $973cd7031d1d5c1f$var$test = {
    __proto__: null,
    foo: {}
};
var $973cd7031d1d5c1f$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $973cd7031d1d5c1f$var$test
    }).foo === $973cd7031d1d5c1f$var$test.foo && !($973cd7031d1d5c1f$var$test instanceof $973cd7031d1d5c1f$var$$Object);
};

});

parcelRegister("kWT2P", function(module, exports) {
"use strict";

var $iMmld = parcelRequire("iMmld");
module.exports = Function.prototype.bind || $iMmld;

});
parcelRegister("iMmld", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $dabe0a2ceb7fd6eb$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $dabe0a2ceb7fd6eb$var$toStr = Object.prototype.toString;
var $dabe0a2ceb7fd6eb$var$max = Math.max;
var $dabe0a2ceb7fd6eb$var$funcType = "[object Function]";
var $dabe0a2ceb7fd6eb$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $dabe0a2ceb7fd6eb$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $dabe0a2ceb7fd6eb$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $dabe0a2ceb7fd6eb$var$toStr.apply(target) !== $dabe0a2ceb7fd6eb$var$funcType) throw new TypeError($dabe0a2ceb7fd6eb$var$ERROR_MESSAGE + target);
    var args = $dabe0a2ceb7fd6eb$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $dabe0a2ceb7fd6eb$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $dabe0a2ceb7fd6eb$var$concatty(args, arguments));
    };
    var boundLength = $dabe0a2ceb7fd6eb$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $dabe0a2ceb7fd6eb$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("deNME", function(module, exports) {
"use strict";
var $9a33332a5bbe77ae$var$call = Function.prototype.call;
var $9a33332a5bbe77ae$var$$hasOwn = Object.prototype.hasOwnProperty;

var $kWT2P = parcelRequire("kWT2P");
/** @type {import('.')} */ module.exports = $kWT2P.call($9a33332a5bbe77ae$var$call, $9a33332a5bbe77ae$var$$hasOwn);

});


parcelRegister("9nLII", function(module, exports) {
"use strict";

var $kWT2P = parcelRequire("kWT2P");

var $jL42x = parcelRequire("jL42x");

var $it6OP = parcelRequire("it6OP");

var $gIo8M = parcelRequire("gIo8M");
var $6d4b474df4dbad80$var$$apply = $jL42x("%Function.prototype.apply%");
var $6d4b474df4dbad80$var$$call = $jL42x("%Function.prototype.call%");
var $6d4b474df4dbad80$var$$reflectApply = $jL42x("%Reflect.apply%", true) || $kWT2P.call($6d4b474df4dbad80$var$$call, $6d4b474df4dbad80$var$$apply);

var $aFy9O = parcelRequire("aFy9O");
var $6d4b474df4dbad80$var$$max = $jL42x("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $gIo8M("a function is required");
    var func = $6d4b474df4dbad80$var$$reflectApply($kWT2P, $6d4b474df4dbad80$var$$call, arguments);
    return $it6OP(func, 1 + $6d4b474df4dbad80$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $6d4b474df4dbad80$var$applyBind = function applyBind() {
    return $6d4b474df4dbad80$var$$reflectApply($kWT2P, $6d4b474df4dbad80$var$$apply, arguments);
};
if ($aFy9O) $aFy9O(module.exports, "apply", {
    value: $6d4b474df4dbad80$var$applyBind
});
else module.exports.apply = $6d4b474df4dbad80$var$applyBind;

});
parcelRegister("it6OP", function(module, exports) {
"use strict";

var $jL42x = parcelRequire("jL42x");

var $64sl3 = parcelRequire("64sl3");

var $d7203985cb04715b$var$hasDescriptors = (parcelRequire("juqCy"))();

var $lepSM = parcelRequire("lepSM");

var $gIo8M = parcelRequire("gIo8M");
var $d7203985cb04715b$var$$floor = $jL42x("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $gIo8M("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $d7203985cb04715b$var$$floor(length) !== length) throw new $gIo8M("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $lepSM) {
        var desc = $lepSM(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($d7203985cb04715b$var$hasDescriptors) $64sl3(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $64sl3(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("64sl3", function(module, exports) {
"use strict";

var $aFy9O = parcelRequire("aFy9O");

var $68Sk6 = parcelRequire("68Sk6");

var $gIo8M = parcelRequire("gIo8M");

var $lepSM = parcelRequire("lepSM");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $gIo8M("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $gIo8M("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $gIo8M("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $gIo8M("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $gIo8M("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $gIo8M("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$lepSM && $lepSM(obj, property);
    if ($aFy9O) $aFy9O(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $68Sk6("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("aFy9O", function(module, exports) {
"use strict";

var $jL42x = parcelRequire("jL42x");
/** @type {import('.')} */ var $7c483aa0b7f7d8aa$var$$defineProperty = $jL42x("%Object.defineProperty%", true) || false;
if ($7c483aa0b7f7d8aa$var$$defineProperty) try {
    $7c483aa0b7f7d8aa$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $7c483aa0b7f7d8aa$var$$defineProperty = false;
}
module.exports = $7c483aa0b7f7d8aa$var$$defineProperty;

});

parcelRegister("lepSM", function(module, exports) {
"use strict";

var $jL42x = parcelRequire("jL42x");
var $f74efb84b6de7d1c$var$$gOPD = $jL42x("%Object.getOwnPropertyDescriptor%", true);
if ($f74efb84b6de7d1c$var$$gOPD) try {
    $f74efb84b6de7d1c$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $f74efb84b6de7d1c$var$$gOPD = null;
}
module.exports = $f74efb84b6de7d1c$var$$gOPD;

});


parcelRegister("juqCy", function(module, exports) {
"use strict";

var $aFy9O = parcelRequire("aFy9O");
var $e30578013f033377$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$aFy9O;
};
$e30578013f033377$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$aFy9O) return null;
    try {
        return $aFy9O([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $e30578013f033377$var$hasPropertyDescriptors;

});





parcelRegister("3Qlp9", function(module, exports) {
"use strict";
var $2cc6d4ecfc3f851f$var$toStr = Object.prototype.toString;
var $2cc6d4ecfc3f851f$var$fnToStr = Function.prototype.toString;
var $2cc6d4ecfc3f851f$var$isFnRegex = /^\s*(?:function)?\*/;

var $2cc6d4ecfc3f851f$var$hasToStringTag = (parcelRequire("4CtGg"))();
var $2cc6d4ecfc3f851f$var$getProto = Object.getPrototypeOf;
var $2cc6d4ecfc3f851f$var$getGeneratorFunc = function() {
    if (!$2cc6d4ecfc3f851f$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $2cc6d4ecfc3f851f$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($2cc6d4ecfc3f851f$var$isFnRegex.test($2cc6d4ecfc3f851f$var$fnToStr.call(fn))) return true;
    if (!$2cc6d4ecfc3f851f$var$hasToStringTag) {
        var str = $2cc6d4ecfc3f851f$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$2cc6d4ecfc3f851f$var$getProto) return false;
    if (typeof $2cc6d4ecfc3f851f$var$GeneratorFunction === "undefined") {
        var generatorFunc = $2cc6d4ecfc3f851f$var$getGeneratorFunc();
        $2cc6d4ecfc3f851f$var$GeneratorFunction = generatorFunc ? $2cc6d4ecfc3f851f$var$getProto(generatorFunc) : false;
    }
    return $2cc6d4ecfc3f851f$var$getProto(fn) === $2cc6d4ecfc3f851f$var$GeneratorFunction;
};

});

parcelRegister("af53G", function(module, exports) {
"use strict";

var $3bfte = parcelRequire("3bfte");

var $cf5FV = parcelRequire("cf5FV");

var $9nLII = parcelRequire("9nLII");

var $6YhGh = parcelRequire("6YhGh");

var $lepSM = parcelRequire("lepSM");
/** @type {(O: object) => string} */ var $774f3a95e65f1617$var$$toString = $6YhGh("Object.prototype.toString");

var $774f3a95e65f1617$var$hasToStringTag = (parcelRequire("4CtGg"))();
var $774f3a95e65f1617$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $774f3a95e65f1617$var$typedArrays = $cf5FV();
var $774f3a95e65f1617$var$$slice = $6YhGh("String.prototype.slice");
var $774f3a95e65f1617$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $774f3a95e65f1617$var$$indexOf = $6YhGh("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $774f3a95e65f1617$var$cache = {
    __proto__: null
};
if ($774f3a95e65f1617$var$hasToStringTag && $lepSM && $774f3a95e65f1617$var$getPrototypeOf) $3bfte($774f3a95e65f1617$var$typedArrays, function(typedArray) {
    var arr = new $774f3a95e65f1617$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $774f3a95e65f1617$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $lepSM(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $774f3a95e65f1617$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $lepSM(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $774f3a95e65f1617$var$cache["$" + typedArray] = $9nLII(descriptor.get);
    }
});
else $3bfte($774f3a95e65f1617$var$typedArrays, function(typedArray) {
    var arr = new $774f3a95e65f1617$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $774f3a95e65f1617$var$cache["$" + typedArray] = $9nLII(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $774f3a95e65f1617$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $3bfte(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $774f3a95e65f1617$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $774f3a95e65f1617$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $774f3a95e65f1617$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $3bfte(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $774f3a95e65f1617$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $774f3a95e65f1617$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$774f3a95e65f1617$var$hasToStringTag) {
        /** @type {string} */ var tag = $774f3a95e65f1617$var$$slice($774f3a95e65f1617$var$$toString(value), 8, -1);
        if ($774f3a95e65f1617$var$$indexOf($774f3a95e65f1617$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $774f3a95e65f1617$var$trySlices(value);
    }
    if (!$lepSM) return null;
     // unknown engine
    return $774f3a95e65f1617$var$tryTypedArrays(value);
};

});
parcelRegister("3bfte", function(module, exports) {
"use strict";

var $epM9W = parcelRequire("epM9W");
var $250e664d205fce62$var$toStr = Object.prototype.toString;
var $250e664d205fce62$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $250e664d205fce62$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($250e664d205fce62$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $250e664d205fce62$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $250e664d205fce62$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($250e664d205fce62$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $250e664d205fce62$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$epM9W(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($250e664d205fce62$var$toStr.call(list) === "[object Array]") $250e664d205fce62$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $250e664d205fce62$var$forEachString(list, iterator, receiver);
    else $250e664d205fce62$var$forEachObject(list, iterator, receiver);
};
module.exports = $250e664d205fce62$var$forEach;

});
parcelRegister("epM9W", function(module, exports) {
"use strict";
var $a7e8c1eda224223c$var$fnToStr = Function.prototype.toString;
var $a7e8c1eda224223c$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $a7e8c1eda224223c$var$badArrayLike;
var $a7e8c1eda224223c$var$isCallableMarker;
if (typeof $a7e8c1eda224223c$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $a7e8c1eda224223c$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $a7e8c1eda224223c$var$isCallableMarker;
        }
    });
    $a7e8c1eda224223c$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $a7e8c1eda224223c$var$reflectApply(function() {
        throw 42;
    }, null, $a7e8c1eda224223c$var$badArrayLike);
} catch (_) {
    if (_ !== $a7e8c1eda224223c$var$isCallableMarker) $a7e8c1eda224223c$var$reflectApply = null;
}
else $a7e8c1eda224223c$var$reflectApply = null;
var $a7e8c1eda224223c$var$constructorRegex = /^\s*class\b/;
var $a7e8c1eda224223c$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $a7e8c1eda224223c$var$fnToStr.call(value);
        return $a7e8c1eda224223c$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $a7e8c1eda224223c$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($a7e8c1eda224223c$var$isES6ClassFn(value)) return false;
        $a7e8c1eda224223c$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $a7e8c1eda224223c$var$toStr = Object.prototype.toString;
var $a7e8c1eda224223c$var$objectClass = "[object Object]";
var $a7e8c1eda224223c$var$fnClass = "[object Function]";
var $a7e8c1eda224223c$var$genClass = "[object GeneratorFunction]";
var $a7e8c1eda224223c$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $a7e8c1eda224223c$var$ddaClass2 = "[object HTML document.all class]";
var $a7e8c1eda224223c$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $a7e8c1eda224223c$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $a7e8c1eda224223c$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $a7e8c1eda224223c$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $a7e8c1eda224223c$var$all = document.all;
    if ($a7e8c1eda224223c$var$toStr.call($a7e8c1eda224223c$var$all) === $a7e8c1eda224223c$var$toStr.call(document.all)) $a7e8c1eda224223c$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($a7e8c1eda224223c$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $a7e8c1eda224223c$var$toStr.call(value);
            return (str === $a7e8c1eda224223c$var$ddaClass || str === $a7e8c1eda224223c$var$ddaClass2 || str === $a7e8c1eda224223c$var$ddaClass3 // opera 12.16
             || str === $a7e8c1eda224223c$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $a7e8c1eda224223c$var$reflectApply ? function isCallable(value) {
    if ($a7e8c1eda224223c$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $a7e8c1eda224223c$var$reflectApply(value, null, $a7e8c1eda224223c$var$badArrayLike);
    } catch (e) {
        if (e !== $a7e8c1eda224223c$var$isCallableMarker) return false;
    }
    return !$a7e8c1eda224223c$var$isES6ClassFn(value) && $a7e8c1eda224223c$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($a7e8c1eda224223c$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($a7e8c1eda224223c$var$hasToStringTag) return $a7e8c1eda224223c$var$tryFunctionObject(value);
    if ($a7e8c1eda224223c$var$isES6ClassFn(value)) return false;
    var strClass = $a7e8c1eda224223c$var$toStr.call(value);
    if (strClass !== $a7e8c1eda224223c$var$fnClass && strClass !== $a7e8c1eda224223c$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $a7e8c1eda224223c$var$tryFunctionObject(value);
};

});


parcelRegister("cf5FV", function(module, exports) {
"use strict";

var $3kwpe = parcelRequire("3kwpe");
var $8e9b49be6af177ab$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $3kwpe.length; i++)if (typeof $8e9b49be6af177ab$var$g[$3kwpe[i]] === "function") // @ts-expect-error
    out[out.length] = $3kwpe[i];
    return out;
};

});
parcelRegister("3kwpe", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("50vd7", function(module, exports) {
"use strict";

var $af53G = parcelRequire("af53G");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$af53G(value);
};

});


parcelRegister("9PbZA", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("htbXe", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});



parcelRegister("gULqW", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $jgs6G = parcelRequire("jgs6G");
"use strict";
function $c506ab9fca88a45d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c506ab9fca88a45d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c506ab9fca88a45d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c506ab9fca88a45d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c506ab9fca88a45d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c506ab9fca88a45d$var$_defineProperty(obj, key, value) {
    key = $c506ab9fca88a45d$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c506ab9fca88a45d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c506ab9fca88a45d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c506ab9fca88a45d$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c506ab9fca88a45d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c506ab9fca88a45d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c506ab9fca88a45d$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c506ab9fca88a45d$var$_toPropertyKey(arg) {
    var key = $c506ab9fca88a45d$var$_toPrimitive(arg, "string");
    return $c506ab9fca88a45d$var$_typeof(key) === "symbol" ? key : String(key);
}
function $c506ab9fca88a45d$var$_toPrimitive(input, hint) {
    if ($c506ab9fca88a45d$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($c506ab9fca88a45d$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $c506ab9fca88a45d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c506ab9fca88a45d$var$_setPrototypeOf(subClass, superClass);
}
function $c506ab9fca88a45d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c506ab9fca88a45d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c506ab9fca88a45d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c506ab9fca88a45d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c506ab9fca88a45d$var$_possibleConstructorReturn(this, result);
    };
}
function $c506ab9fca88a45d$var$_possibleConstructorReturn(self, call) {
    if (call && ($c506ab9fca88a45d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c506ab9fca88a45d$var$_assertThisInitialized(self);
}
function $c506ab9fca88a45d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c506ab9fca88a45d$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $c506ab9fca88a45d$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$c506ab9fca88a45d$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $c506ab9fca88a45d$var$_construct(Class, arguments, $c506ab9fca88a45d$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $c506ab9fca88a45d$var$_setPrototypeOf(Wrapper, Class);
    };
    return $c506ab9fca88a45d$var$_wrapNativeSuper(Class);
}
function $c506ab9fca88a45d$var$_construct(Parent, args, Class) {
    if ($c506ab9fca88a45d$var$_isNativeReflectConstruct()) $c506ab9fca88a45d$var$_construct = Reflect.construct.bind();
    else $c506ab9fca88a45d$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $c506ab9fca88a45d$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $c506ab9fca88a45d$var$_construct.apply(null, arguments);
}
function $c506ab9fca88a45d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c506ab9fca88a45d$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $c506ab9fca88a45d$var$_setPrototypeOf(o, p) {
    $c506ab9fca88a45d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c506ab9fca88a45d$var$_setPrototypeOf(o, p);
}
function $c506ab9fca88a45d$var$_getPrototypeOf(o) {
    $c506ab9fca88a45d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c506ab9fca88a45d$var$_getPrototypeOf(o);
}
function $c506ab9fca88a45d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c506ab9fca88a45d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c506ab9fca88a45d$var$_typeof(o);
}

var $ersGt = parcelRequire("ersGt");
var $c506ab9fca88a45d$var$inspect = $ersGt.inspect;

var $98EGw = parcelRequire("98EGw");
var $c506ab9fca88a45d$var$ERR_INVALID_ARG_TYPE = $98EGw.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $c506ab9fca88a45d$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $c506ab9fca88a45d$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return "";
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $c506ab9fca88a45d$var$blue = "";
var $c506ab9fca88a45d$var$green = "";
var $c506ab9fca88a45d$var$red = "";
var $c506ab9fca88a45d$var$white = "";
var $c506ab9fca88a45d$var$kReadableOperator = {
    deepStrictEqual: "Expected values to be strictly deep-equal:",
    strictEqual: "Expected values to be strictly equal:",
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: "Expected values to be loosely deep-equal:",
    equal: "Expected values to be loosely equal:",
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: "Values identical but not reference-equal:"
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $c506ab9fca88a45d$var$kMaxShortLength = 10;
function $c506ab9fca88a45d$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, "message", {
        value: source.message
    });
    return target;
}
function $c506ab9fca88a45d$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $c506ab9fca88a45d$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $c506ab9fca88a45d$var$createErrDiff(actual, expected, operator) {
    var other = "";
    var res = "";
    var lastPos = 0;
    var end = "";
    var skipped = false;
    var actualInspected = $c506ab9fca88a45d$var$inspectValue(actual);
    var actualLines = actualInspected.split("\n");
    var expectedLines = $c506ab9fca88a45d$var$inspectValue(expected).split("\n");
    var i = 0;
    var indicator = "";
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === "strictEqual" && $c506ab9fca88a45d$var$_typeof(actual) === "object" && $c506ab9fca88a45d$var$_typeof(expected) === "object" && actual !== null && expected !== null) operator = "strictEqualObject";
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $c506ab9fca88a45d$var$kMaxShortLength) {
            if (($c506ab9fca88a45d$var$_typeof(actual) !== "object" || actual === null) && ($c506ab9fca88a45d$var$_typeof(expected) !== "object" || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($c506ab9fca88a45d$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== "strictEqualObject") {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $jgs6G.stderr && $jgs6G.stderr.isTTY ? $jgs6G.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($c506ab9fca88a45d$var$repeat(" ", i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split("\n");
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($c506ab9fca88a45d$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join("\n"), "\n");
    }
    if (i > 3) {
        end = "\n".concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white).concat(end);
        skipped = true;
    }
    if (other !== "") {
        end = "\n  ".concat(other).concat(end);
        other = "";
    }
    var printedLines = 0;
    var msg = $c506ab9fca88a45d$var$kReadableOperator[operator] + "\n".concat($c506ab9fca88a45d$var$green, "+ actual").concat($c506ab9fca88a45d$var$white, " ").concat($c506ab9fca88a45d$var$red, "- expected").concat($c506ab9fca88a45d$var$white);
    var skippedMsg = " ".concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($c506ab9fca88a45d$var$red, "-").concat($c506ab9fca88a45d$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($c506ab9fca88a45d$var$green, "+").concat($c506ab9fca88a45d$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$c506ab9fca88a45d$var$endsWith(actualLine, ",") || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $c506ab9fca88a45d$var$endsWith(expectedLine, ",") && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ",";
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($c506ab9fca88a45d$var$green, "+").concat($c506ab9fca88a45d$var$white, " ").concat(actualLine);
                other += "\n".concat($c506ab9fca88a45d$var$red, "-").concat($c506ab9fca88a45d$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = "";
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white).concat(other, "\n") + "".concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : "", "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $c506ab9fca88a45d$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $c506ab9fca88a45d$var$_inherits(AssertionError, _Error);
    var _super = $c506ab9fca88a45d$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $c506ab9fca88a45d$var$_classCallCheck(this, AssertionError);
        if ($c506ab9fca88a45d$var$_typeof(options) !== "object" || options === null) throw new $c506ab9fca88a45d$var$ERR_INVALID_ARG_TYPE("options", "Object", options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($jgs6G.stderr && $jgs6G.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($jgs6G.stderr && $jgs6G.stderr.getColorDepth && $jgs6G.stderr.getColorDepth() !== 1) {
                    $c506ab9fca88a45d$var$blue = "\x1b[34m";
                    $c506ab9fca88a45d$var$green = "\x1b[32m";
                    $c506ab9fca88a45d$var$white = "\x1b[39m";
                    $c506ab9fca88a45d$var$red = "\x1b[31m";
                } else {
                    $c506ab9fca88a45d$var$blue = "";
                    $c506ab9fca88a45d$var$green = "";
                    $c506ab9fca88a45d$var$white = "";
                    $c506ab9fca88a45d$var$red = "";
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($c506ab9fca88a45d$var$_typeof(actual) === "object" && actual !== null && $c506ab9fca88a45d$var$_typeof(expected) === "object" && expected !== null && "stack" in actual && actual instanceof Error && "stack" in expected && expected instanceof Error) {
                actual = $c506ab9fca88a45d$var$copyError(actual);
                expected = $c506ab9fca88a45d$var$copyError(expected);
            }
            if (operator === "deepStrictEqual" || operator === "strictEqual") _this = _super.call(this, $c506ab9fca88a45d$var$createErrDiff(actual, expected, operator));
            else if (operator === "notDeepStrictEqual" || operator === "notStrictEqual") {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $c506ab9fca88a45d$var$kReadableOperator[operator];
                var res = $c506ab9fca88a45d$var$inspectValue(actual).split("\n");
                // In case "actual" is an object, it should not be reference equal.
                if (operator === "notStrictEqual" && $c506ab9fca88a45d$var$_typeof(actual) === "object" && actual !== null) base = $c506ab9fca88a45d$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($c506ab9fca88a45d$var$blue, "...").concat($c506ab9fca88a45d$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join("\n"), "\n"));
            } else {
                var _res = $c506ab9fca88a45d$var$inspectValue(actual);
                var other = "";
                var knownOperators = $c506ab9fca88a45d$var$kReadableOperator[operator];
                if (operator === "notDeepEqual" || operator === "notEqual") {
                    _res = "".concat($c506ab9fca88a45d$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($c506ab9fca88a45d$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === "deepEqual" || operator === "equal") _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($c506ab9fca88a45d$var$_assertThisInitialized(_this), "name", {
            value: "AssertionError [ERR_ASSERTION]",
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = "ERR_ASSERTION";
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($c506ab9fca88a45d$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = "AssertionError";
        return $c506ab9fca88a45d$var$_possibleConstructorReturn(_this);
    }
    $c506ab9fca88a45d$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $c506ab9fca88a45d$var$inspect(this, $c506ab9fca88a45d$var$_objectSpread($c506ab9fca88a45d$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $c506ab9fca88a45d$var$_wrapNativeSuper(Error), $c506ab9fca88a45d$var$inspect.custom);
module.exports = $c506ab9fca88a45d$var$AssertionError;

});

parcelRegister("1B01c", function(module, exports) {
"use strict";

var $49sJb = parcelRequire("49sJb");
var $129942cfafde5b1e$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $129942cfafde5b1e$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $49sJb;
    if ($129942cfafde5b1e$var$lacksProperEnumerationOrder()) return $49sJb;
    if ($129942cfafde5b1e$var$assignHasPendingExceptions()) return $49sJb;
    return Object.assign;
};

});
parcelRegister("49sJb", function(module, exports) {
"use strict";

var $1FrKZ = parcelRequire("1FrKZ");

var $305e496c2eff5557$var$hasSymbols = (parcelRequire("jgZd3"))();

var $6YhGh = parcelRequire("6YhGh");
var $305e496c2eff5557$var$toObject = Object;
var $305e496c2eff5557$var$$push = $6YhGh("Array.prototype.push");
var $305e496c2eff5557$var$$propIsEnumerable = $6YhGh("Object.prototype.propertyIsEnumerable");
var $305e496c2eff5557$var$originalGetSymbols = $305e496c2eff5557$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $305e496c2eff5557$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $305e496c2eff5557$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $1FrKZ(from);
        var getSymbols = $305e496c2eff5557$var$hasSymbols && (Object.getOwnPropertySymbols || $305e496c2eff5557$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($305e496c2eff5557$var$$propIsEnumerable(from, key)) $305e496c2eff5557$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($305e496c2eff5557$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("1FrKZ", function(module, exports) {
"use strict";
var $136f26bd5e65443e$var$slice = Array.prototype.slice;

var $4lAfP = parcelRequire("4lAfP");
var $136f26bd5e65443e$var$origKeys = Object.keys;

var $136f26bd5e65443e$var$keysShim = $136f26bd5e65443e$var$origKeys ? function keys(o) {
    return $136f26bd5e65443e$var$origKeys(o);
} : (parcelRequire("ehwY7"));
var $136f26bd5e65443e$var$originalKeys = Object.keys;
$136f26bd5e65443e$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($4lAfP(object)) return $136f26bd5e65443e$var$originalKeys($136f26bd5e65443e$var$slice.call(object));
            return $136f26bd5e65443e$var$originalKeys(object);
        };
    } else Object.keys = $136f26bd5e65443e$var$keysShim;
    return Object.keys || $136f26bd5e65443e$var$keysShim;
};
module.exports = $136f26bd5e65443e$var$keysShim;

});
parcelRegister("4lAfP", function(module, exports) {
"use strict";
var $32a53ef1300649e6$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $32a53ef1300649e6$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $32a53ef1300649e6$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("ehwY7", function(module, exports) {
"use strict";
var $a65c3a1e2891f863$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $a65c3a1e2891f863$var$has = Object.prototype.hasOwnProperty;
    var $a65c3a1e2891f863$var$toStr = Object.prototype.toString;
    var $a65c3a1e2891f863$var$isArgs = (parcelRequire("4lAfP")); // eslint-disable-line global-require
    var $a65c3a1e2891f863$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $a65c3a1e2891f863$var$hasDontEnumBug = !$a65c3a1e2891f863$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $a65c3a1e2891f863$var$hasProtoEnumBug = $a65c3a1e2891f863$var$isEnumerable.call(function() {}, "prototype");
    var $a65c3a1e2891f863$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $a65c3a1e2891f863$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $a65c3a1e2891f863$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $a65c3a1e2891f863$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$a65c3a1e2891f863$var$excludedKeys["$" + k] && $a65c3a1e2891f863$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $a65c3a1e2891f863$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $a65c3a1e2891f863$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$a65c3a1e2891f863$var$hasAutomationEqualityBug) return $a65c3a1e2891f863$var$equalsConstructorPrototype(o);
        try {
            return $a65c3a1e2891f863$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $a65c3a1e2891f863$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $a65c3a1e2891f863$var$toStr.call(object) === "[object Function]";
        var isArguments = $a65c3a1e2891f863$var$isArgs(object);
        var isString = isObject && $a65c3a1e2891f863$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $a65c3a1e2891f863$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$a65c3a1e2891f863$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $a65c3a1e2891f863$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($a65c3a1e2891f863$var$hasDontEnumBug) {
            var skipConstructor = $a65c3a1e2891f863$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $a65c3a1e2891f863$var$dontEnums.length; ++k)if (!(skipConstructor && $a65c3a1e2891f863$var$dontEnums[k] === "constructor") && $a65c3a1e2891f863$var$has.call(object, $a65c3a1e2891f863$var$dontEnums[k])) theKeys.push($a65c3a1e2891f863$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $a65c3a1e2891f863$var$keysShim;

});




parcelRegister("1IqFn", function(module, exports) {
"use strict";

var $eYlIW = parcelRequire("eYlIW");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $eYlIW;
};

});
parcelRegister("eYlIW", function(module, exports) {
"use strict";
var $ae678534cb9286d4$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($ae678534cb9286d4$var$numberIsNaN(a) && $ae678534cb9286d4$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("CT6Uk", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";
function $074e4c8121515940$var$_slicedToArray(arr, i) {
    return $074e4c8121515940$var$_arrayWithHoles(arr) || $074e4c8121515940$var$_iterableToArrayLimit(arr, i) || $074e4c8121515940$var$_unsupportedIterableToArray(arr, i) || $074e4c8121515940$var$_nonIterableRest();
}
function $074e4c8121515940$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $074e4c8121515940$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $074e4c8121515940$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $074e4c8121515940$var$_arrayLikeToArray(o, minLen);
}
function $074e4c8121515940$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $074e4c8121515940$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $074e4c8121515940$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $074e4c8121515940$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $074e4c8121515940$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $074e4c8121515940$var$_typeof(o);
}
var $074e4c8121515940$var$regexFlagsSupported = /a/g.flags !== undefined;
var $074e4c8121515940$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $074e4c8121515940$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $074e4c8121515940$var$objectIs = Object.is ? Object.is : (parcelRequire("UwsgQ"));
var $074e4c8121515940$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $074e4c8121515940$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("hknbw"));
function $074e4c8121515940$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $074e4c8121515940$var$hasOwnProperty = $074e4c8121515940$var$uncurryThis(Object.prototype.hasOwnProperty);
var $074e4c8121515940$var$propertyIsEnumerable = $074e4c8121515940$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $074e4c8121515940$var$objectToString = $074e4c8121515940$var$uncurryThis(Object.prototype.toString);

var $ersGt = parcelRequire("ersGt");
var $074e4c8121515940$require$_require$types = $ersGt.types;
var $074e4c8121515940$var$isAnyArrayBuffer = $074e4c8121515940$require$_require$types.isAnyArrayBuffer, $074e4c8121515940$var$isArrayBufferView = $074e4c8121515940$require$_require$types.isArrayBufferView, $074e4c8121515940$var$isDate = $074e4c8121515940$require$_require$types.isDate, $074e4c8121515940$var$isMap = $074e4c8121515940$require$_require$types.isMap, $074e4c8121515940$var$isRegExp = $074e4c8121515940$require$_require$types.isRegExp, $074e4c8121515940$var$isSet = $074e4c8121515940$require$_require$types.isSet, $074e4c8121515940$var$isNativeError = $074e4c8121515940$require$_require$types.isNativeError, $074e4c8121515940$var$isBoxedPrimitive = $074e4c8121515940$require$_require$types.isBoxedPrimitive, $074e4c8121515940$var$isNumberObject = $074e4c8121515940$require$_require$types.isNumberObject, $074e4c8121515940$var$isStringObject = $074e4c8121515940$require$_require$types.isStringObject, $074e4c8121515940$var$isBooleanObject = $074e4c8121515940$require$_require$types.isBooleanObject, $074e4c8121515940$var$isBigIntObject = $074e4c8121515940$require$_require$types.isBigIntObject, $074e4c8121515940$var$isSymbolObject = $074e4c8121515940$require$_require$types.isSymbolObject, $074e4c8121515940$var$isFloat32Array = $074e4c8121515940$require$_require$types.isFloat32Array, $074e4c8121515940$var$isFloat64Array = $074e4c8121515940$require$_require$types.isFloat64Array;
function $074e4c8121515940$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $074e4c8121515940$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($074e4c8121515940$var$isNonIndex).concat($074e4c8121515940$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $074e4c8121515940$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $074e4c8121515940$var$ONLY_ENUMERABLE = undefined;
var $074e4c8121515940$var$kStrict = true;
var $074e4c8121515940$var$kLoose = false;
var $074e4c8121515940$var$kNoIterator = 0;
var $074e4c8121515940$var$kIsArray = 1;
var $074e4c8121515940$var$kIsSet = 2;
var $074e4c8121515940$var$kIsMap = 3;
// Check if they have the same source and flags
function $074e4c8121515940$var$areSimilarRegExps(a, b) {
    return $074e4c8121515940$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $074e4c8121515940$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $074e4c8121515940$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $074e4c8121515940$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $074e4c8121515940$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $074e4c8121515940$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $074e4c8121515940$var$isEqualBoxedPrimitive(val1, val2) {
    if ($074e4c8121515940$var$isNumberObject(val1)) return $074e4c8121515940$var$isNumberObject(val2) && $074e4c8121515940$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($074e4c8121515940$var$isStringObject(val1)) return $074e4c8121515940$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($074e4c8121515940$var$isBooleanObject(val1)) return $074e4c8121515940$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($074e4c8121515940$var$isBigIntObject(val1)) return $074e4c8121515940$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $074e4c8121515940$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $074e4c8121515940$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $074e4c8121515940$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($074e4c8121515940$var$_typeof(val1) !== "object") return typeof val1 === "number" && $074e4c8121515940$var$numberIsNaN(val1) && $074e4c8121515940$var$numberIsNaN(val2);
        if ($074e4c8121515940$var$_typeof(val2) !== "object" || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $074e4c8121515940$var$_typeof(val1) !== "object") {
            if (val2 === null || $074e4c8121515940$var$_typeof(val2) !== "object") // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $074e4c8121515940$var$_typeof(val2) !== "object") return false;
    }
    var val1Tag = $074e4c8121515940$var$objectToString(val1);
    var val2Tag = $074e4c8121515940$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $074e4c8121515940$var$getOwnNonIndexProperties(val1, $074e4c8121515940$var$ONLY_ENUMERABLE);
        var keys2 = $074e4c8121515940$var$getOwnNonIndexProperties(val2, $074e4c8121515940$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $074e4c8121515940$var$keyCheck(val1, val2, strict, memos, $074e4c8121515940$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === "[object Object]") {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$074e4c8121515940$var$isMap(val1) && $074e4c8121515940$var$isMap(val2) || !$074e4c8121515940$var$isSet(val1) && $074e4c8121515940$var$isSet(val2)) return false;
    }
    if ($074e4c8121515940$var$isDate(val1)) {
        if (!$074e4c8121515940$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($074e4c8121515940$var$isRegExp(val1)) {
        if (!$074e4c8121515940$var$isRegExp(val2) || !$074e4c8121515940$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($074e4c8121515940$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($074e4c8121515940$var$isArrayBufferView(val1)) {
        if (!strict && ($074e4c8121515940$var$isFloat32Array(val1) || $074e4c8121515940$var$isFloat64Array(val1))) {
            if (!$074e4c8121515940$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$074e4c8121515940$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $074e4c8121515940$var$getOwnNonIndexProperties(val1, $074e4c8121515940$var$ONLY_ENUMERABLE);
        var _keys2 = $074e4c8121515940$var$getOwnNonIndexProperties(val2, $074e4c8121515940$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $074e4c8121515940$var$keyCheck(val1, val2, strict, memos, $074e4c8121515940$var$kNoIterator, _keys);
    } else if ($074e4c8121515940$var$isSet(val1)) {
        if (!$074e4c8121515940$var$isSet(val2) || val1.size !== val2.size) return false;
        return $074e4c8121515940$var$keyCheck(val1, val2, strict, memos, $074e4c8121515940$var$kIsSet);
    } else if ($074e4c8121515940$var$isMap(val1)) {
        if (!$074e4c8121515940$var$isMap(val2) || val1.size !== val2.size) return false;
        return $074e4c8121515940$var$keyCheck(val1, val2, strict, memos, $074e4c8121515940$var$kIsMap);
    } else if ($074e4c8121515940$var$isAnyArrayBuffer(val1)) {
        if (!$074e4c8121515940$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($074e4c8121515940$var$isBoxedPrimitive(val1) && !$074e4c8121515940$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $074e4c8121515940$var$keyCheck(val1, val2, strict, memos, $074e4c8121515940$var$kNoIterator);
}
function $074e4c8121515940$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $074e4c8121515940$var$propertyIsEnumerable(val, k);
    });
}
function $074e4c8121515940$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$074e4c8121515940$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $074e4c8121515940$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($074e4c8121515940$var$propertyIsEnumerable(val1, key)) {
                    if (!$074e4c8121515940$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($074e4c8121515940$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $074e4c8121515940$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $074e4c8121515940$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $074e4c8121515940$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $074e4c8121515940$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $074e4c8121515940$var$kNoIterator || iterationType === $074e4c8121515940$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $074e4c8121515940$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $074e4c8121515940$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $074e4c8121515940$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($074e4c8121515940$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $074e4c8121515940$var$findLooseMatchingPrimitives(prim) {
    switch($074e4c8121515940$var$_typeof(prim)){
        case "undefined":
            return null;
        case "object":
            // Only pass in null as object!
            return undefined;
        case "symbol":
            return false;
        case "string":
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case "number":
            if ($074e4c8121515940$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $074e4c8121515940$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $074e4c8121515940$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $074e4c8121515940$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $074e4c8121515940$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$074e4c8121515940$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $074e4c8121515940$var$innerDeepEqual(item, curB, false, memo);
}
function $074e4c8121515940$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $074e4c8121515940$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($074e4c8121515940$var$_typeof(val) === "object" && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$074e4c8121515940$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $074e4c8121515940$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($074e4c8121515940$var$_typeof(_val) === "object" && _val !== null) {
                if (!$074e4c8121515940$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$074e4c8121515940$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $074e4c8121515940$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $074e4c8121515940$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($074e4c8121515940$var$innerDeepEqual(key1, key2, strict, memo) && $074e4c8121515940$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $074e4c8121515940$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $074e4c8121515940$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $074e4c8121515940$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($074e4c8121515940$var$_typeof(key) === "object" && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$074e4c8121515940$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$074e4c8121515940$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $074e4c8121515940$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $074e4c8121515940$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($074e4c8121515940$var$_typeof(_key) === "object" && _key !== null) {
                if (!$074e4c8121515940$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$074e4c8121515940$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$074e4c8121515940$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $074e4c8121515940$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $074e4c8121515940$var$kIsSet) {
        if (!$074e4c8121515940$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $074e4c8121515940$var$kIsMap) {
        if (!$074e4c8121515940$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $074e4c8121515940$var$kIsArray) for(; i < a.length; i++){
        if ($074e4c8121515940$var$hasOwnProperty(a, i)) {
            if (!$074e4c8121515940$var$hasOwnProperty(b, i) || !$074e4c8121515940$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($074e4c8121515940$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$074e4c8121515940$var$hasOwnProperty(b, key) || !$074e4c8121515940$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$074e4c8121515940$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $074e4c8121515940$var$isDeepEqual(val1, val2) {
    return $074e4c8121515940$var$innerDeepEqual(val1, val2, $074e4c8121515940$var$kLoose);
}
function $074e4c8121515940$var$isDeepStrictEqual(val1, val2) {
    return $074e4c8121515940$var$innerDeepEqual(val1, val2, $074e4c8121515940$var$kStrict);
}
module.exports = {
    isDeepEqual: $074e4c8121515940$var$isDeepEqual,
    isDeepStrictEqual: $074e4c8121515940$var$isDeepStrictEqual
};

});
parcelRegister("UwsgQ", function(module, exports) {
"use strict";

var $ckZZt = parcelRequire("ckZZt");

var $9nLII = parcelRequire("9nLII");

var $eYlIW = parcelRequire("eYlIW");

var $1IqFn = parcelRequire("1IqFn");

var $2k6FH = parcelRequire("2k6FH");
var $0a9e67f5ccd18b45$var$polyfill = $9nLII($1IqFn(), Object);
$ckZZt($0a9e67f5ccd18b45$var$polyfill, {
    getPolyfill: $1IqFn,
    implementation: $eYlIW,
    shim: $2k6FH
});
module.exports = $0a9e67f5ccd18b45$var$polyfill;

});
parcelRegister("ckZZt", function(module, exports) {
"use strict";

var $1FrKZ = parcelRequire("1FrKZ");
var $8fb770577f7e624a$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $8fb770577f7e624a$var$toStr = Object.prototype.toString;
var $8fb770577f7e624a$var$concat = Array.prototype.concat;

var $64sl3 = parcelRequire("64sl3");
var $8fb770577f7e624a$var$isFunction = function(fn) {
    return typeof fn === "function" && $8fb770577f7e624a$var$toStr.call(fn) === "[object Function]";
};

var $8fb770577f7e624a$var$supportsDescriptors = (parcelRequire("juqCy"))();
var $8fb770577f7e624a$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$8fb770577f7e624a$var$isFunction(predicate) || !predicate()) return;
    }
    if ($8fb770577f7e624a$var$supportsDescriptors) $64sl3(object, name, value, true);
    else $64sl3(object, name, value);
};
var $8fb770577f7e624a$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $1FrKZ(map);
    if ($8fb770577f7e624a$var$hasSymbols) props = $8fb770577f7e624a$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$8fb770577f7e624a$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$8fb770577f7e624a$var$defineProperties.supportsDescriptors = !!$8fb770577f7e624a$var$supportsDescriptors;
module.exports = $8fb770577f7e624a$var$defineProperties;

});

parcelRegister("2k6FH", function(module, exports) {
"use strict";

var $1IqFn = parcelRequire("1IqFn");

var $ckZZt = parcelRequire("ckZZt");
module.exports = function shimObjectIs() {
    var polyfill = $1IqFn();
    $ckZZt(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("hknbw", function(module, exports) {
"use strict";

var $9nLII = parcelRequire("9nLII");

var $ckZZt = parcelRequire("ckZZt");

var $bFzJa = parcelRequire("bFzJa");

var $iPDjo = parcelRequire("iPDjo");

var $hQvhj = parcelRequire("hQvhj");
var $c9d649f78c49495e$var$polyfill = $9nLII($iPDjo(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $ckZZt($c9d649f78c49495e$var$polyfill, {
    getPolyfill: $iPDjo,
    implementation: $bFzJa,
    shim: $hQvhj
});
module.exports = $c9d649f78c49495e$var$polyfill;

});
parcelRegister("bFzJa", function(module, exports) {
"use strict";
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("iPDjo", function(module, exports) {
"use strict";

var $bFzJa = parcelRequire("bFzJa");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN("a")) return Number.isNaN;
    return $bFzJa;
};

});

parcelRegister("hQvhj", function(module, exports) {
"use strict";

var $ckZZt = parcelRequire("ckZZt");

var $iPDjo = parcelRequire("iPDjo");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $iPDjo();
    $ckZZt(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("iabXK", function(module, exports) {
"use strict";
var $d39270b745a53926$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === "string";
};
var $d39270b745a53926$var$gOPD = Object.getOwnPropertyDescriptor;
if ($d39270b745a53926$var$gOPD) try {
    $d39270b745a53926$var$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $d39270b745a53926$var$gOPD = null;
}
$d39270b745a53926$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$d39270b745a53926$var$functionsHaveNames() || !$d39270b745a53926$var$gOPD) return false;
    var desc = $d39270b745a53926$var$gOPD(function() {}, "name");
    return !!desc && !!desc.configurable;
};
var $d39270b745a53926$var$$bind = Function.prototype.bind;
$d39270b745a53926$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $d39270b745a53926$var$functionsHaveNames() && typeof $d39270b745a53926$var$$bind === "function" && (function f() {}).bind().name !== "";
};
module.exports = $d39270b745a53926$var$functionsHaveNames;

});

parcelRegister("jfHx5", function(module, exports) {
"use strict";

var $jL42x = parcelRequire("jL42x");

var $6YhGh = parcelRequire("6YhGh");

var $7DeEN = parcelRequire("7DeEN");

var $gIo8M = parcelRequire("gIo8M");
var $e0412fb7ffe6c089$var$$WeakMap = $jL42x("%WeakMap%", true);
var $e0412fb7ffe6c089$var$$Map = $jL42x("%Map%", true);
var $e0412fb7ffe6c089$var$$weakMapGet = $6YhGh("WeakMap.prototype.get", true);
var $e0412fb7ffe6c089$var$$weakMapSet = $6YhGh("WeakMap.prototype.set", true);
var $e0412fb7ffe6c089$var$$weakMapHas = $6YhGh("WeakMap.prototype.has", true);
var $e0412fb7ffe6c089$var$$mapGet = $6YhGh("Map.prototype.get", true);
var $e0412fb7ffe6c089$var$$mapSet = $6YhGh("Map.prototype.set", true);
var $e0412fb7ffe6c089$var$$mapHas = $6YhGh("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $e0412fb7ffe6c089$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $e0412fb7ffe6c089$var$listGet = function(objects, key) {
    var node = $e0412fb7ffe6c089$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $e0412fb7ffe6c089$var$listSet = function(objects, key, value) {
    var node = $e0412fb7ffe6c089$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $e0412fb7ffe6c089$var$listHas = function(objects, key) {
    return !!$e0412fb7ffe6c089$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $gIo8M("Side channel does not contain " + $7DeEN(key));
        },
        get: function(key) {
            if ($e0412fb7ffe6c089$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $e0412fb7ffe6c089$var$$weakMapGet($wm, key);
            } else if ($e0412fb7ffe6c089$var$$Map) {
                if ($m) return $e0412fb7ffe6c089$var$$mapGet($m, key);
            } else {
                if ($o) return $e0412fb7ffe6c089$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($e0412fb7ffe6c089$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $e0412fb7ffe6c089$var$$weakMapHas($wm, key);
            } else if ($e0412fb7ffe6c089$var$$Map) {
                if ($m) return $e0412fb7ffe6c089$var$$mapHas($m, key);
            } else {
                if ($o) return $e0412fb7ffe6c089$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($e0412fb7ffe6c089$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $e0412fb7ffe6c089$var$$WeakMap();
                $e0412fb7ffe6c089$var$$weakMapSet($wm, key, value);
            } else if ($e0412fb7ffe6c089$var$$Map) {
                if (!$m) $m = new $e0412fb7ffe6c089$var$$Map();
                $e0412fb7ffe6c089$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $e0412fb7ffe6c089$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("7DeEN", function(module, exports) {
var $58e78b833c7b3c9b$var$hasMap = typeof Map === "function" && Map.prototype;
var $58e78b833c7b3c9b$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $58e78b833c7b3c9b$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $58e78b833c7b3c9b$var$mapSize = $58e78b833c7b3c9b$var$hasMap && $58e78b833c7b3c9b$var$mapSizeDescriptor && typeof $58e78b833c7b3c9b$var$mapSizeDescriptor.get === "function" ? $58e78b833c7b3c9b$var$mapSizeDescriptor.get : null;
var $58e78b833c7b3c9b$var$mapForEach = $58e78b833c7b3c9b$var$hasMap && Map.prototype.forEach;
var $58e78b833c7b3c9b$var$hasSet = typeof Set === "function" && Set.prototype;
var $58e78b833c7b3c9b$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $58e78b833c7b3c9b$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $58e78b833c7b3c9b$var$setSize = $58e78b833c7b3c9b$var$hasSet && $58e78b833c7b3c9b$var$setSizeDescriptor && typeof $58e78b833c7b3c9b$var$setSizeDescriptor.get === "function" ? $58e78b833c7b3c9b$var$setSizeDescriptor.get : null;
var $58e78b833c7b3c9b$var$setForEach = $58e78b833c7b3c9b$var$hasSet && Set.prototype.forEach;
var $58e78b833c7b3c9b$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $58e78b833c7b3c9b$var$weakMapHas = $58e78b833c7b3c9b$var$hasWeakMap ? WeakMap.prototype.has : null;
var $58e78b833c7b3c9b$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $58e78b833c7b3c9b$var$weakSetHas = $58e78b833c7b3c9b$var$hasWeakSet ? WeakSet.prototype.has : null;
var $58e78b833c7b3c9b$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $58e78b833c7b3c9b$var$weakRefDeref = $58e78b833c7b3c9b$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $58e78b833c7b3c9b$var$booleanValueOf = Boolean.prototype.valueOf;
var $58e78b833c7b3c9b$var$objectToString = Object.prototype.toString;
var $58e78b833c7b3c9b$var$functionToString = Function.prototype.toString;
var $58e78b833c7b3c9b$var$$match = String.prototype.match;
var $58e78b833c7b3c9b$var$$slice = String.prototype.slice;
var $58e78b833c7b3c9b$var$$replace = String.prototype.replace;
var $58e78b833c7b3c9b$var$$toUpperCase = String.prototype.toUpperCase;
var $58e78b833c7b3c9b$var$$toLowerCase = String.prototype.toLowerCase;
var $58e78b833c7b3c9b$var$$test = RegExp.prototype.test;
var $58e78b833c7b3c9b$var$$concat = Array.prototype.concat;
var $58e78b833c7b3c9b$var$$join = Array.prototype.join;
var $58e78b833c7b3c9b$var$$arrSlice = Array.prototype.slice;
var $58e78b833c7b3c9b$var$$floor = Math.floor;
var $58e78b833c7b3c9b$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $58e78b833c7b3c9b$var$gOPS = Object.getOwnPropertySymbols;
var $58e78b833c7b3c9b$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $58e78b833c7b3c9b$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $58e78b833c7b3c9b$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $58e78b833c7b3c9b$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $58e78b833c7b3c9b$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $58e78b833c7b3c9b$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $58e78b833c7b3c9b$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $58e78b833c7b3c9b$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$58e78b833c7b3c9b$var$$floor(-num) : $58e78b833c7b3c9b$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $58e78b833c7b3c9b$var$$slice.call(str, intStr.length + 1);
            return $58e78b833c7b3c9b$var$$replace.call(intStr, sepRegex, "$&_") + "." + $58e78b833c7b3c9b$var$$replace.call($58e78b833c7b3c9b$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $58e78b833c7b3c9b$var$$replace.call(str, sepRegex, "$&_");
}

var $68nm9 = parcelRequire("68nm9");
var $58e78b833c7b3c9b$var$inspectCustom = $68nm9.custom;
var $58e78b833c7b3c9b$var$inspectSymbol = $58e78b833c7b3c9b$var$isSymbol($58e78b833c7b3c9b$var$inspectCustom) ? $58e78b833c7b3c9b$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($58e78b833c7b3c9b$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($58e78b833c7b3c9b$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $58e78b833c7b3c9b$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($58e78b833c7b3c9b$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($58e78b833c7b3c9b$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $58e78b833c7b3c9b$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $58e78b833c7b3c9b$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $58e78b833c7b3c9b$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $58e78b833c7b3c9b$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $58e78b833c7b3c9b$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($58e78b833c7b3c9b$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $58e78b833c7b3c9b$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($58e78b833c7b3c9b$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$58e78b833c7b3c9b$var$isRegExp(obj)) {
        var name = $58e78b833c7b3c9b$var$nameOf(obj);
        var keys = $58e78b833c7b3c9b$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $58e78b833c7b3c9b$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($58e78b833c7b3c9b$var$isSymbol(obj)) {
        var symString = $58e78b833c7b3c9b$var$hasShammedSymbols ? $58e78b833c7b3c9b$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $58e78b833c7b3c9b$var$symToString.call(obj);
        return typeof obj === "object" && !$58e78b833c7b3c9b$var$hasShammedSymbols ? $58e78b833c7b3c9b$var$markBoxed(symString) : symString;
    }
    if ($58e78b833c7b3c9b$var$isElement(obj)) {
        var s = "<" + $58e78b833c7b3c9b$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $58e78b833c7b3c9b$var$wrapQuotes($58e78b833c7b3c9b$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $58e78b833c7b3c9b$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($58e78b833c7b3c9b$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $58e78b833c7b3c9b$var$arrObjKeys(obj, inspect);
        if (indent && !$58e78b833c7b3c9b$var$singleLineValues(xs)) return "[" + $58e78b833c7b3c9b$var$indentedJoin(xs, indent) + "]";
        return "[ " + $58e78b833c7b3c9b$var$$join.call(xs, ", ") + " ]";
    }
    if ($58e78b833c7b3c9b$var$isError(obj)) {
        var parts = $58e78b833c7b3c9b$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$58e78b833c7b3c9b$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $58e78b833c7b3c9b$var$$join.call($58e78b833c7b3c9b$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $58e78b833c7b3c9b$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($58e78b833c7b3c9b$var$inspectSymbol && typeof obj[$58e78b833c7b3c9b$var$inspectSymbol] === "function" && $68nm9) return $68nm9(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($58e78b833c7b3c9b$var$isMap(obj)) {
        var mapParts = [];
        if ($58e78b833c7b3c9b$var$mapForEach) $58e78b833c7b3c9b$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $58e78b833c7b3c9b$var$collectionOf("Map", $58e78b833c7b3c9b$var$mapSize.call(obj), mapParts, indent);
    }
    if ($58e78b833c7b3c9b$var$isSet(obj)) {
        var setParts = [];
        if ($58e78b833c7b3c9b$var$setForEach) $58e78b833c7b3c9b$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $58e78b833c7b3c9b$var$collectionOf("Set", $58e78b833c7b3c9b$var$setSize.call(obj), setParts, indent);
    }
    if ($58e78b833c7b3c9b$var$isWeakMap(obj)) return $58e78b833c7b3c9b$var$weakCollectionOf("WeakMap");
    if ($58e78b833c7b3c9b$var$isWeakSet(obj)) return $58e78b833c7b3c9b$var$weakCollectionOf("WeakSet");
    if ($58e78b833c7b3c9b$var$isWeakRef(obj)) return $58e78b833c7b3c9b$var$weakCollectionOf("WeakRef");
    if ($58e78b833c7b3c9b$var$isNumber(obj)) return $58e78b833c7b3c9b$var$markBoxed(inspect(Number(obj)));
    if ($58e78b833c7b3c9b$var$isBigInt(obj)) return $58e78b833c7b3c9b$var$markBoxed(inspect($58e78b833c7b3c9b$var$bigIntValueOf.call(obj)));
    if ($58e78b833c7b3c9b$var$isBoolean(obj)) return $58e78b833c7b3c9b$var$markBoxed($58e78b833c7b3c9b$var$booleanValueOf.call(obj));
    if ($58e78b833c7b3c9b$var$isString(obj)) return $58e78b833c7b3c9b$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$58e78b833c7b3c9b$var$isDate(obj) && !$58e78b833c7b3c9b$var$isRegExp(obj)) {
        var ys = $58e78b833c7b3c9b$var$arrObjKeys(obj, inspect);
        var isPlainObject = $58e78b833c7b3c9b$var$gPO ? $58e78b833c7b3c9b$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $58e78b833c7b3c9b$var$toStringTag && Object(obj) === obj && $58e78b833c7b3c9b$var$toStringTag in obj ? $58e78b833c7b3c9b$var$$slice.call($58e78b833c7b3c9b$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $58e78b833c7b3c9b$var$$join.call($58e78b833c7b3c9b$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $58e78b833c7b3c9b$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $58e78b833c7b3c9b$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $58e78b833c7b3c9b$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $58e78b833c7b3c9b$var$quote(s) {
    return $58e78b833c7b3c9b$var$$replace.call(String(s), /"/g, "&quot;");
}
function $58e78b833c7b3c9b$var$isArray(obj) {
    return $58e78b833c7b3c9b$var$toStr(obj) === "[object Array]" && (!$58e78b833c7b3c9b$var$toStringTag || !(typeof obj === "object" && $58e78b833c7b3c9b$var$toStringTag in obj));
}
function $58e78b833c7b3c9b$var$isDate(obj) {
    return $58e78b833c7b3c9b$var$toStr(obj) === "[object Date]" && (!$58e78b833c7b3c9b$var$toStringTag || !(typeof obj === "object" && $58e78b833c7b3c9b$var$toStringTag in obj));
}
function $58e78b833c7b3c9b$var$isRegExp(obj) {
    return $58e78b833c7b3c9b$var$toStr(obj) === "[object RegExp]" && (!$58e78b833c7b3c9b$var$toStringTag || !(typeof obj === "object" && $58e78b833c7b3c9b$var$toStringTag in obj));
}
function $58e78b833c7b3c9b$var$isError(obj) {
    return $58e78b833c7b3c9b$var$toStr(obj) === "[object Error]" && (!$58e78b833c7b3c9b$var$toStringTag || !(typeof obj === "object" && $58e78b833c7b3c9b$var$toStringTag in obj));
}
function $58e78b833c7b3c9b$var$isString(obj) {
    return $58e78b833c7b3c9b$var$toStr(obj) === "[object String]" && (!$58e78b833c7b3c9b$var$toStringTag || !(typeof obj === "object" && $58e78b833c7b3c9b$var$toStringTag in obj));
}
function $58e78b833c7b3c9b$var$isNumber(obj) {
    return $58e78b833c7b3c9b$var$toStr(obj) === "[object Number]" && (!$58e78b833c7b3c9b$var$toStringTag || !(typeof obj === "object" && $58e78b833c7b3c9b$var$toStringTag in obj));
}
function $58e78b833c7b3c9b$var$isBoolean(obj) {
    return $58e78b833c7b3c9b$var$toStr(obj) === "[object Boolean]" && (!$58e78b833c7b3c9b$var$toStringTag || !(typeof obj === "object" && $58e78b833c7b3c9b$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $58e78b833c7b3c9b$var$isSymbol(obj) {
    if ($58e78b833c7b3c9b$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$58e78b833c7b3c9b$var$symToString) return false;
    try {
        $58e78b833c7b3c9b$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $58e78b833c7b3c9b$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$58e78b833c7b3c9b$var$bigIntValueOf) return false;
    try {
        $58e78b833c7b3c9b$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $58e78b833c7b3c9b$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $58e78b833c7b3c9b$var$has(obj, key) {
    return $58e78b833c7b3c9b$var$hasOwn.call(obj, key);
}
function $58e78b833c7b3c9b$var$toStr(obj) {
    return $58e78b833c7b3c9b$var$objectToString.call(obj);
}
function $58e78b833c7b3c9b$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $58e78b833c7b3c9b$var$$match.call($58e78b833c7b3c9b$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $58e78b833c7b3c9b$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $58e78b833c7b3c9b$var$isMap(x) {
    if (!$58e78b833c7b3c9b$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $58e78b833c7b3c9b$var$mapSize.call(x);
        try {
            $58e78b833c7b3c9b$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $58e78b833c7b3c9b$var$isWeakMap(x) {
    if (!$58e78b833c7b3c9b$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $58e78b833c7b3c9b$var$weakMapHas.call(x, $58e78b833c7b3c9b$var$weakMapHas);
        try {
            $58e78b833c7b3c9b$var$weakSetHas.call(x, $58e78b833c7b3c9b$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $58e78b833c7b3c9b$var$isWeakRef(x) {
    if (!$58e78b833c7b3c9b$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $58e78b833c7b3c9b$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $58e78b833c7b3c9b$var$isSet(x) {
    if (!$58e78b833c7b3c9b$var$setSize || !x || typeof x !== "object") return false;
    try {
        $58e78b833c7b3c9b$var$setSize.call(x);
        try {
            $58e78b833c7b3c9b$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $58e78b833c7b3c9b$var$isWeakSet(x) {
    if (!$58e78b833c7b3c9b$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $58e78b833c7b3c9b$var$weakSetHas.call(x, $58e78b833c7b3c9b$var$weakSetHas);
        try {
            $58e78b833c7b3c9b$var$weakMapHas.call(x, $58e78b833c7b3c9b$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $58e78b833c7b3c9b$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $58e78b833c7b3c9b$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $58e78b833c7b3c9b$var$inspectString($58e78b833c7b3c9b$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $58e78b833c7b3c9b$var$$replace.call($58e78b833c7b3c9b$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $58e78b833c7b3c9b$var$lowbyte);
    return $58e78b833c7b3c9b$var$wrapQuotes(s, "single", opts);
}
function $58e78b833c7b3c9b$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $58e78b833c7b3c9b$var$$toUpperCase.call(n.toString(16));
}
function $58e78b833c7b3c9b$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $58e78b833c7b3c9b$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $58e78b833c7b3c9b$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $58e78b833c7b3c9b$var$indentedJoin(entries, indent) : $58e78b833c7b3c9b$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $58e78b833c7b3c9b$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($58e78b833c7b3c9b$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $58e78b833c7b3c9b$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $58e78b833c7b3c9b$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $58e78b833c7b3c9b$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $58e78b833c7b3c9b$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $58e78b833c7b3c9b$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $58e78b833c7b3c9b$var$arrObjKeys(obj, inspect) {
    var isArr = $58e78b833c7b3c9b$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $58e78b833c7b3c9b$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $58e78b833c7b3c9b$var$gOPS === "function" ? $58e78b833c7b3c9b$var$gOPS(obj) : [];
    var symMap;
    if ($58e78b833c7b3c9b$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$58e78b833c7b3c9b$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($58e78b833c7b3c9b$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($58e78b833c7b3c9b$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $58e78b833c7b3c9b$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($58e78b833c7b3c9b$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("68nm9", function(module, exports) {
"use strict";

});



parcelRegister("7s3wv", function(module, exports) {
var $56cde199cb7a5010$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $56cde199cb7a5010$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("35IUa", function(module, exports) {
"use strict";
var $2404abebeb1b0d42$var$strValue = String.prototype.valueOf;
var $2404abebeb1b0d42$var$tryStringObject = function tryStringObject(value) {
    try {
        $2404abebeb1b0d42$var$strValue.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $2404abebeb1b0d42$var$toStr = Object.prototype.toString;
var $2404abebeb1b0d42$var$strClass = "[object String]";

var $2404abebeb1b0d42$var$hasToStringTag = (parcelRequire("4CtGg"))();
module.exports = function isString(value) {
    if (typeof value === "string") return true;
    if (typeof value !== "object") return false;
    return $2404abebeb1b0d42$var$hasToStringTag ? $2404abebeb1b0d42$var$tryStringObject(value) : $2404abebeb1b0d42$var$toStr.call(value) === $2404abebeb1b0d42$var$strClass;
};

});

parcelRegister("iZ7CD", function(module, exports) {
"use strict";
/** @const */ var $dd23d61f9f6ab3a3$var$$Map = typeof Map === "function" && Map.prototype ? Map : null;
var $dd23d61f9f6ab3a3$var$$Set = typeof Set === "function" && Set.prototype ? Set : null;
var $dd23d61f9f6ab3a3$var$exported;
if (!$dd23d61f9f6ab3a3$var$$Map) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$dd23d61f9f6ab3a3$var$exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
};
var $dd23d61f9f6ab3a3$var$$mapHas = $dd23d61f9f6ab3a3$var$$Map ? Map.prototype.has : null;
var $dd23d61f9f6ab3a3$var$$setHas = $dd23d61f9f6ab3a3$var$$Set ? Set.prototype.has : null;
if (!$dd23d61f9f6ab3a3$var$exported && !$dd23d61f9f6ab3a3$var$$mapHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$dd23d61f9f6ab3a3$var$exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = $dd23d61f9f6ab3a3$var$exported || function isMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $dd23d61f9f6ab3a3$var$$mapHas.call(x);
        if ($dd23d61f9f6ab3a3$var$$setHas) try {
            $dd23d61f9f6ab3a3$var$$setHas.call(x);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $Map is always truthy here
        return x instanceof $dd23d61f9f6ab3a3$var$$Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

});

parcelRegister("a1LoQ", function(module, exports) {
"use strict";
var $74cec3ffd9ad9399$var$$Map = typeof Map === "function" && Map.prototype ? Map : null;
var $74cec3ffd9ad9399$var$$Set = typeof Set === "function" && Set.prototype ? Set : null;
var $74cec3ffd9ad9399$var$exported;
if (!$74cec3ffd9ad9399$var$$Set) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$74cec3ffd9ad9399$var$exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
};
var $74cec3ffd9ad9399$var$$mapHas = $74cec3ffd9ad9399$var$$Map ? Map.prototype.has : null;
var $74cec3ffd9ad9399$var$$setHas = $74cec3ffd9ad9399$var$$Set ? Set.prototype.has : null;
if (!$74cec3ffd9ad9399$var$exported && !$74cec3ffd9ad9399$var$$setHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$74cec3ffd9ad9399$var$exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = $74cec3ffd9ad9399$var$exported || function isSet(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $74cec3ffd9ad9399$var$$setHas.call(x);
        if ($74cec3ffd9ad9399$var$$mapHas) try {
            $74cec3ffd9ad9399$var$$mapHas.call(x);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $Set is always truthy here
        return x instanceof $74cec3ffd9ad9399$var$$Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

});

parcelRegister("gpHnc", function(module, exports) {
"use strict";
var $bf30a022ceb1482f$var$$BigInt = typeof BigInt !== "undefined" && BigInt;
module.exports = function hasNativeBigInts() {
    return typeof $bf30a022ceb1482f$var$$BigInt === "function" && typeof BigInt === "function" && typeof $bf30a022ceb1482f$var$$BigInt(42) === "bigint" // eslint-disable-line no-magic-numbers
     && typeof BigInt(42) === "bigint"; // eslint-disable-line no-magic-numbers
};

});

/**
 * Functionality
 */ // Adds `.tabbing` class to html element once tabbing detected
function $65b4de7ca7b2ca88$export$2e2bcd8739ae039() {
    const onKeyUp = function(e) {
        const charCode = e.which || e.keyCode;
        if (charCode === 9) {
            document.documentElement.classList.add("tabbing");
            document.removeEventListener("keyup", onKeyUp);
        }
    };
    document.addEventListener("keyup", onKeyUp);
}


var $f31978d9b51db8d6$exports = {};
var $842ae172950db755$exports = {};
var $842ae172950db755$var$DOCUMENT_NODE_TYPE = 9;
/**
 * A polyfill for Element.matches()
 */ if (typeof Element !== "undefined" && !Element.prototype.matches) {
    var $842ae172950db755$var$proto = Element.prototype;
    $842ae172950db755$var$proto.matches = $842ae172950db755$var$proto.matchesSelector || $842ae172950db755$var$proto.mozMatchesSelector || $842ae172950db755$var$proto.msMatchesSelector || $842ae172950db755$var$proto.oMatchesSelector || $842ae172950db755$var$proto.webkitMatchesSelector;
}
/**
 * Finds the closest parent that matches a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @return {Function}
 */ function $842ae172950db755$var$closest(element, selector) {
    while(element && element.nodeType !== $842ae172950db755$var$DOCUMENT_NODE_TYPE){
        if (typeof element.matches === "function" && element.matches(selector)) return element;
        element = element.parentNode;
    }
}
$842ae172950db755$exports = $842ae172950db755$var$closest;


/**
 * Delegates event to a selector.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function $f31978d9b51db8d6$var$_delegate(element, selector, type, callback, useCapture) {
    var listenerFn = $f31978d9b51db8d6$var$listener.apply(this, arguments);
    element.addEventListener(type, listenerFn, useCapture);
    return {
        destroy: function() {
            element.removeEventListener(type, listenerFn, useCapture);
        }
    };
}
/**
 * Delegates event to a selector.
 *
 * @param {Element|String|Array} [elements]
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @param {Boolean} useCapture
 * @return {Object}
 */ function $f31978d9b51db8d6$var$delegate(elements, selector, type, callback, useCapture) {
    // Handle the regular Element usage
    if (typeof elements.addEventListener === "function") return $f31978d9b51db8d6$var$_delegate.apply(null, arguments);
    // Handle Element-less usage, it defaults to global delegation
    if (typeof type === "function") // Use `document` as the first parameter, then apply arguments
    // This is a short way to .unshift `arguments` without running into deoptimizations
    return $f31978d9b51db8d6$var$_delegate.bind(null, document).apply(null, arguments);
    // Handle Selector-based usage
    if (typeof elements === "string") elements = document.querySelectorAll(elements);
    // Handle Array-like based usage
    return Array.prototype.map.call(elements, function(element) {
        return $f31978d9b51db8d6$var$_delegate(element, selector, type, callback, useCapture);
    });
}
/**
 * Finds closest match and invokes callback.
 *
 * @param {Element} element
 * @param {String} selector
 * @param {String} type
 * @param {Function} callback
 * @return {Function}
 */ function $f31978d9b51db8d6$var$listener(element, selector, type, callback) {
    return function(e) {
        e.delegateTarget = $842ae172950db755$exports(e.target, selector);
        if (e.delegateTarget) callback.call(element, e);
    };
}
$f31978d9b51db8d6$exports = $f31978d9b51db8d6$var$delegate;


function $0bbedd1cf2657f4d$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))(document.body, "a[href]", "click", (e)=>{
        var a = new RegExp("/" + window.location.host + "/|mailto:|data:text", "g");
        if (!a.test(e.delegateTarget.href)) {
            e.preventDefault();
            e.stopPropagation();
            window.open(e.delegateTarget.href, "_blank");
        }
    });
}



function $0ffb30c7ca5554ae$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))("[data-sublink]", "click", (e)=>{
        const a = e.delegateTarget.querySelector("a");
        if (a && e.target !== a) {
            a.click();
            return;
        }
        const btn = e.delegateTarget.querySelector("button");
        if (btn && e.target !== btn) {
            btn.click();
            return;
        }
    }, false);
}



// Smooth scrolls to anchor element
const $ad4b2b72846e4da5$var$offset = -25;
function $ad4b2b72846e4da5$export$2e2bcd8739ae039() {
    (0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))('a[href^="#"]', "click", (e)=>{
        e.preventDefault();
        const $section = document.querySelector(e.target.hash);
        if ($section) window.scroll({
            top: $section.offsetTop - $ad4b2b72846e4da5$var$offset,
            behavior: "smooth"
        });
    }, false);
}


var $93307c02d3900b6f$exports = {};
(function(global, factory) {
    $93307c02d3900b6f$exports = factory();
})($93307c02d3900b6f$exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */ var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    // don't know a better way to get the size of a CSS 100vh…
    function createTestElement() {
        var testElement = document.createElement("div");
        testElement.style.cssText = "position: fixed; top: 0; height: 100vh; pointer-events: none;";
        document.documentElement.insertBefore(testElement, document.documentElement.firstChild);
        return testElement;
    }
    function removeTestElement(element) {
        document.documentElement.removeChild(element);
    }
    //  in some browsers this will be bigger than window.innerHeight
    function checkSizes() {
        var vhTest = createTestElement();
        var windowHeight = window.innerHeight;
        var vh = vhTest.offsetHeight;
        var offset = vh - windowHeight;
        removeTestElement(vhTest);
        return {
            vh: vh,
            windowHeight: windowHeight,
            offset: offset,
            isNeeded: offset !== 0,
            value: 0
        };
    }
    // export
    function noop() {}
    function computeDifference() {
        var sizes = checkSizes();
        sizes.value = sizes.offset;
        return sizes;
    }
    function redefineVhUnit() {
        var sizes = checkSizes();
        sizes.value = sizes.windowHeight * 0.01;
        return sizes;
    }
    var methods = /*#__PURE__*/ Object.freeze({
        noop: noop,
        computeDifference: computeDifference,
        redefineVhUnit: redefineVhUnit
    });
    function isString(text) {
        return typeof text === "string" && text.length > 0;
    }
    function isFunction(f) {
        return typeof f === "function";
    }
    var defaultOptions = Object.freeze({
        cssVarName: "vh-offset",
        redefineVh: false,
        method: computeDifference,
        force: false,
        bind: true,
        updateOnTouch: false,
        onUpdate: noop
    });
    function getOptions(options) {
        // old options handling: only redefine the CSS var name
        if (isString(options)) return __assign({}, defaultOptions, {
            cssVarName: options
        });
        // be sure to have a configuration object
        if (typeof options !== "object") return defaultOptions;
        // make sure we have the right options to start with
        var finalOptions = {
            force: options.force === true,
            bind: options.bind !== false,
            updateOnTouch: options.updateOnTouch === true,
            onUpdate: isFunction(options.onUpdate) ? options.onUpdate : noop
        };
        // method change
        var redefineVh = options.redefineVh === true;
        finalOptions.method = methods[redefineVh ? "redefineVhUnit" : "computeDifference"];
        finalOptions.cssVarName = isString(options.cssVarName) ? options.cssVarName : redefineVh ? /*
                  when redefining vh unit we follow this article name convention
                  https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
                */ "vh" : defaultOptions.cssVarName;
        return finalOptions;
    }
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
    var passiveSupported = false;
    var eventListeners = [];
    /* istanbul ignore next */ try {
        var options = Object.defineProperty({}, "passive", {
            get: function() {
                passiveSupported = true;
            }
        });
        window.addEventListener("test", options, options);
        window.removeEventListener("test", options, options);
    } catch (err) {
        passiveSupported = false;
    }
    function addListener(eventName, callback) {
        eventListeners.push({
            eventName: eventName,
            callback: callback
        });
        window.addEventListener(eventName, callback, /* istanbul ignore next */ passiveSupported ? {
            passive: true
        } : false);
    }
    function removeAll() {
        eventListeners.forEach(function(config) {
            window.removeEventListener(config.eventName, config.callback);
        });
        eventListeners = [];
    }
    function updateCssVar(cssVarName, result) {
        document.documentElement.style.setProperty("--" + cssVarName, result.value + "px");
    }
    function formatResult(sizes, options) {
        return __assign({}, sizes, {
            unbind: removeAll,
            recompute: options.method
        });
    }
    function vhCheck(options) {
        var config = Object.freeze(getOptions(options));
        var result = formatResult(config.method(), config);
        // usefulness check
        if (!result.isNeeded && !config.force) return result;
        updateCssVar(config.cssVarName, result);
        config.onUpdate(result);
        // enabled by default
        if (!config.bind) return result;
        function onWindowChange() {
            window.requestAnimationFrame(function() {
                var sizes = config.method();
                updateCssVar(config.cssVarName, sizes);
                config.onUpdate(formatResult(sizes, config));
            });
        }
        // be sure we don't duplicates events listeners
        result.unbind();
        // listen for orientation change
        // - this can't be configured
        // - because it's convenient and not a real performance bottleneck
        addListener("orientationchange", onWindowChange);
        // listen to touch move for scrolling
        // – disabled by default
        // - listening to scrolling can be expansive…
        if (config.updateOnTouch) addListener("touchmove", onWindowChange);
        return result;
    }
    return vhCheck;
});


function $23465f4677c1f584$export$2e2bcd8739ae039(arr, cb) {
    var i = 0, len = arr.length;
    for(; i < len; i++){
        if (!cb(arr[i], i, arr)) return false;
    }
    return true;
}


"use strict";
const $0e83632b90b75bec$var$SEP = "/";
// Types ~> static, param, any, optional
const $0e83632b90b75bec$var$STYPE = 0, $0e83632b90b75bec$var$PTYPE = 1, $0e83632b90b75bec$var$ATYPE = 2, $0e83632b90b75bec$var$OTYPE = 3;
// Char Codes ~> / : *
const $0e83632b90b75bec$var$SLASH = 47, $0e83632b90b75bec$var$COLON = 58, $0e83632b90b75bec$var$ASTER = 42, $0e83632b90b75bec$var$QMARK = 63;
function $0e83632b90b75bec$var$strip(str) {
    if (str === $0e83632b90b75bec$var$SEP) return str;
    str.charCodeAt(0) === $0e83632b90b75bec$var$SLASH && (str = str.substring(1));
    var len = str.length - 1;
    return str.charCodeAt(len) === $0e83632b90b75bec$var$SLASH ? str.substring(0, len) : str;
}
function $0e83632b90b75bec$var$split(str) {
    return (str = $0e83632b90b75bec$var$strip(str)) === $0e83632b90b75bec$var$SEP ? [
        $0e83632b90b75bec$var$SEP
    ] : str.split($0e83632b90b75bec$var$SEP);
}
function $0e83632b90b75bec$var$isMatch(arr, obj, idx) {
    idx = arr[idx];
    return obj.val === idx && obj.type === $0e83632b90b75bec$var$STYPE || (idx === $0e83632b90b75bec$var$SEP ? obj.type > $0e83632b90b75bec$var$PTYPE : obj.type !== $0e83632b90b75bec$var$STYPE && (idx || "").endsWith(obj.end));
}
function $0e83632b90b75bec$export$4659b591c19bdf3d(str, all) {
    var i = 0, tmp, segs = $0e83632b90b75bec$var$split(str), len = segs.length, l;
    var fn = $0e83632b90b75bec$var$isMatch.bind($0e83632b90b75bec$var$isMatch, segs);
    for(; i < all.length; i++){
        tmp = all[i];
        if ((l = tmp.length) === len || l < len && tmp[l - 1].type === $0e83632b90b75bec$var$ATYPE || l > len && tmp[l - 1].type === $0e83632b90b75bec$var$OTYPE) {
            if ((0, $23465f4677c1f584$export$2e2bcd8739ae039)(tmp, fn)) return tmp;
        }
    }
    return [];
}
function $0e83632b90b75bec$export$98e6a39c04603d36(str) {
    if (str === $0e83632b90b75bec$var$SEP) return [
        {
            old: str,
            type: $0e83632b90b75bec$var$STYPE,
            val: str,
            end: ""
        }
    ];
    var c, x, t, sfx, nxt = $0e83632b90b75bec$var$strip(str), i = -1, j = 0, len = nxt.length, out = [];
    while(++i < len){
        c = nxt.charCodeAt(i);
        if (c === $0e83632b90b75bec$var$COLON) {
            j = i + 1; // begining of param
            t = $0e83632b90b75bec$var$PTYPE; // set type
            x = 0; // reset mark
            sfx = "";
            while(i < len && nxt.charCodeAt(i) !== $0e83632b90b75bec$var$SLASH){
                c = nxt.charCodeAt(i);
                if (c === $0e83632b90b75bec$var$QMARK) {
                    x = i;
                    t = $0e83632b90b75bec$var$OTYPE;
                } else if (c === 46 && sfx.length === 0) sfx = nxt.substring(x = i);
                i++; // move on
            }
            out.push({
                old: str,
                type: t,
                val: nxt.substring(j, x || i),
                end: sfx
            });
            // shorten string & update pointers
            nxt = nxt.substring(i);
            len -= i;
            i = 0;
            continue; // loop
        } else if (c === $0e83632b90b75bec$var$ASTER) {
            out.push({
                old: str,
                type: $0e83632b90b75bec$var$ATYPE,
                val: nxt.substring(i),
                end: ""
            });
            continue; // loop
        } else {
            j = i;
            while(i < len && nxt.charCodeAt(i) !== $0e83632b90b75bec$var$SLASH)++i; // skip to next slash
            out.push({
                old: str,
                type: $0e83632b90b75bec$var$STYPE,
                val: nxt.substring(j, i),
                end: ""
            });
            // shorten string & update pointers
            nxt = nxt.substring(i);
            len -= i;
            i = j = 0;
        }
    }
    return out;
}
function $0e83632b90b75bec$export$78e3044358792147(str, arr) {
    var i = 0, x, y, segs = $0e83632b90b75bec$var$split(str), out = {};
    for(; i < arr.length; i++){
        x = segs[i];
        y = arr[i];
        if (x === $0e83632b90b75bec$var$SEP) continue;
        if (x !== void 0 && y.type | 2 === $0e83632b90b75bec$var$OTYPE) out[y.val] = x.replace(y.end, "");
    }
    return out;
}


var $b50c183501f1ff74$var$r = new Map;
function $b50c183501f1ff74$var$a(n) {
    return n.replace(window.location.origin, "");
}
function $b50c183501f1ff74$var$o(n, r) {
    var a = "", o = "", i = n.split(/#|\?/), c = i[0], u = i.slice(1);
    c = (c = c.replace(/\/$/g, "")) || "/";
    for(var l = 0; l < u.length; l++){
        var f = n.split(u[l])[0];
        "?" === f[f.length - 1] && (o = u[l]), "#" === f[f.length - 1] && (a = u[l]);
    }
    var h = (0, $0e83632b90b75bec$export$4659b591c19bdf3d)(c, r.map(function(n) {
        return n.matcher;
    })), s = r.filter(function(n) {
        return n.path === h[0].old;
    })[0];
    return h[0] ? Object.assign({}, s, {
        params: (0, $0e83632b90b75bec$export$78e3044358792147)(c, h),
        hash: a,
        search: o,
        pathname: c,
        location: n
    }) : null;
}
function $b50c183501f1ff74$export$2e2bcd8739ae039(t, e) {
    void 0 === e && (e = [
        "*"
    ]);
    var i, c = document.querySelector(t), u = [], l = {};
    e = e.concat(e.indexOf("*") < 0 ? "*" : []).reduce(function(n, t) {
        return "function" == typeof t ? (u.push(t), n) : n.concat(t);
    }, []).map(function(t) {
        return t.path ? Object.assign({}, t, {
            matcher: (0, $0e83632b90b75bec$export$98e6a39c04603d36)(t.path)
        }) : {
            path: t,
            matcher: (0, $0e83632b90b75bec$export$98e6a39c04603d36)(t)
        };
    });
    var f = $b50c183501f1ff74$var$o($b50c183501f1ff74$var$a(window.location.href), e), h = Object.assign({
        previousDocument: null
    }, f);
    function s(n) {
        return l[n] ? l[n].map(function(n) {
            return n(h);
        }) : [];
    }
    function p(n, t, e, r) {
        h.previousDocument = n.cloneNode(!0), Promise.all(u.concat(e.handler || []).map(function(n) {
            return n(h);
        })).then(function() {
            requestAnimationFrame(function() {
                c.innerHTML = t, s("after"), e.hash && s("hash");
            });
        });
    }
    function d(n, e, a) {
        if (!e) return window.location.href = n;
        fetch(n, {
            credentials: "include"
        }).then(function(n) {
            return n.text();
        }).then(function(o) {
            var i = (new window.DOMParser).parseFromString(o, "text/html"), c = [
                i,
                i.querySelector(t).innerHTML
            ];
            $b50c183501f1ff74$var$r.set(n, c), a && a(c[0], c[1], e);
        });
    }
    function m(n, t, e) {
        i = function() {
            var e = $b50c183501f1ff74$var$r.get(n);
            e && !1 !== t.cache ? p(e[0], e[1], t) : d(n, t, p);
        }, Object.assign(h, t), Promise.all(s("before")).then(i);
    }
    function v(n) {
        var t = $b50c183501f1ff74$var$a(n);
        return [
            t,
            $b50c183501f1ff74$var$o(t, e)
        ];
    }
    return document.body.addEventListener("click", function(n) {
        if (!(n.ctrlKey || n.metaKey || n.altKey || n.shiftKey || n.defaultPrevented)) {
            for(var t = n.target; t && (!t.href || "A" !== t.nodeName);)t = t.parentNode;
            if (!t) return n;
            var e = v(t.href), r = e[0], a = e[1];
            return a.ignore ? n : h.pathname === a.pathname && a.hash ? (n.preventDefault(), Object.assign(h, a), s("hash"), n) : window.location.origin !== t.origin || t.hasAttribute("download") || "_blank" === t.target || /^(?:mailto|tel):/.test(t.href) || t.classList.contains("no-ajax") ? n : (n.preventDefault(), h.location !== r && m(r, a), s("navigate"), !1);
        }
    }), window.addEventListener("popstate", function(n) {
        if (n.target.location.pathname !== h.pathname) return m.apply(void 0, v(n.target.location.href).concat([
            !0
        ])), !1;
    }), {
        get state () {
            return h;
        },
        go: function(n) {
            i = null, m.apply(void 0, v(n).concat([
                !1
            ]));
        },
        load: function(n, t) {
            return d.apply(void 0, v(n).concat([
                t
            ]));
        },
        on: function(n, t) {
            return l[n] = l[n] ? l[n].concat(t) : [
                t
            ], function() {
                return l[n].slice(l[n].indexOf(t), 1);
            };
        }
    };
}



var $6ac1a5641367fc62$exports = {};
var $ba974ad32e0bf6f4$exports = {};
"use strict";
/**
 * Remove a range of items from an array
 *
 * @function removeItems
 * @param {Array<*>} arr The target array
 * @param {number} startIdx The index to begin removing from (inclusive)
 * @param {number} removeCount How many items to remove
 */ $ba974ad32e0bf6f4$exports = function removeItems(arr, startIdx, removeCount) {
    var i, length = arr.length;
    if (startIdx >= length || removeCount === 0) return;
    removeCount = startIdx + removeCount > length ? length - startIdx : removeCount;
    var len = length - removeCount;
    for(i = startIdx; i < len; ++i)arr[i] = arr[i + removeCount];
    arr.length = len;
};


var $6f76f8235b7895c0$exports = {};

var $6f76f8235b7895c0$var$scheduler = (parcelRequire("1DJsI"))();

var $Jm0Yx = parcelRequire("Jm0Yx");
var $6f76f8235b7895c0$var$perf;
$6f76f8235b7895c0$var$nanotiming.disabled = true;
try {
    $6f76f8235b7895c0$var$perf = window.performance;
    $6f76f8235b7895c0$var$nanotiming.disabled = window.localStorage.DISABLE_NANOTIMING === "true" || !$6f76f8235b7895c0$var$perf.mark;
} catch (e) {}
$6f76f8235b7895c0$exports = $6f76f8235b7895c0$var$nanotiming;
function $6f76f8235b7895c0$var$nanotiming(name) {
    $Jm0Yx.equal(typeof name, "string", "nanotiming: name should be type string");
    if ($6f76f8235b7895c0$var$nanotiming.disabled) return $6f76f8235b7895c0$var$noop;
    var uuid = ($6f76f8235b7895c0$var$perf.now() * 10000).toFixed() % Number.MAX_SAFE_INTEGER;
    var startName = "start-" + uuid + "-" + name;
    $6f76f8235b7895c0$var$perf.mark(startName);
    function end(cb) {
        var endName = "end-" + uuid + "-" + name;
        $6f76f8235b7895c0$var$perf.mark(endName);
        $6f76f8235b7895c0$var$scheduler.push(function() {
            var err = null;
            try {
                var measureName = name + " [" + uuid + "]";
                $6f76f8235b7895c0$var$perf.measure(measureName, startName, endName);
                $6f76f8235b7895c0$var$perf.clearMarks(startName);
                $6f76f8235b7895c0$var$perf.clearMarks(endName);
            } catch (e) {
                err = e;
            }
            if (cb) cb(err, name);
        });
    }
    end.uuid = uuid;
    return end;
}
function $6f76f8235b7895c0$var$noop(cb) {
    if (cb) $6f76f8235b7895c0$var$scheduler.push(function() {
        cb(new Error("nanotiming: performance API unavailable"));
    });
}



var $Jm0Yx = parcelRequire("Jm0Yx");
$6ac1a5641367fc62$exports = $6ac1a5641367fc62$var$Nanobus;
function $6ac1a5641367fc62$var$Nanobus(name) {
    if (!(this instanceof $6ac1a5641367fc62$var$Nanobus)) return new $6ac1a5641367fc62$var$Nanobus(name);
    this._name = name || "nanobus";
    this._starListeners = [];
    this._listeners = {};
}
$6ac1a5641367fc62$var$Nanobus.prototype.emit = function(eventName) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.emit: eventName should be type string or symbol");
    var data = [];
    for(var i = 1, len = arguments.length; i < len; i++)data.push(arguments[i]);
    var emitTiming = $6f76f8235b7895c0$exports(this._name + "('" + eventName.toString() + "')");
    var listeners = this._listeners[eventName];
    if (listeners && listeners.length > 0) this._emit(this._listeners[eventName], data);
    if (this._starListeners.length > 0) this._emit(this._starListeners, eventName, data, emitTiming.uuid);
    emitTiming();
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.on = $6ac1a5641367fc62$var$Nanobus.prototype.addListener = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.on: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.on: listener should be type function");
    if (eventName === "*") this._starListeners.push(listener);
    else {
        if (!this._listeners[eventName]) this._listeners[eventName] = [];
        this._listeners[eventName].push(listener);
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.prependListener = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.prependListener: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.prependListener: listener should be type function");
    if (eventName === "*") this._starListeners.unshift(listener);
    else {
        if (!this._listeners[eventName]) this._listeners[eventName] = [];
        this._listeners[eventName].unshift(listener);
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.once = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.once: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.once: listener should be type function");
    var self = this;
    this.on(eventName, once);
    function once() {
        listener.apply(self, arguments);
        self.removeListener(eventName, once);
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.prependOnceListener = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.prependOnceListener: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.prependOnceListener: listener should be type function");
    var self = this;
    this.prependListener(eventName, once);
    function once() {
        listener.apply(self, arguments);
        self.removeListener(eventName, once);
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.removeListener = function(eventName, listener) {
    $Jm0Yx.ok(typeof eventName === "string" || typeof eventName === "symbol", "nanobus.removeListener: eventName should be type string or symbol");
    $Jm0Yx.equal(typeof listener, "function", "nanobus.removeListener: listener should be type function");
    if (eventName === "*") {
        this._starListeners = this._starListeners.slice();
        return remove(this._starListeners, listener);
    } else {
        if (typeof this._listeners[eventName] !== "undefined") this._listeners[eventName] = this._listeners[eventName].slice();
        return remove(this._listeners[eventName], listener);
    }
    function remove(arr, listener) {
        if (!arr) return;
        var index = arr.indexOf(listener);
        if (index !== -1) {
            $ba974ad32e0bf6f4$exports(arr, index, 1);
            return true;
        }
    }
};
$6ac1a5641367fc62$var$Nanobus.prototype.removeAllListeners = function(eventName) {
    if (eventName) {
        if (eventName === "*") this._starListeners = [];
        else this._listeners[eventName] = [];
    } else {
        this._starListeners = [];
        this._listeners = {};
    }
    return this;
};
$6ac1a5641367fc62$var$Nanobus.prototype.listeners = function(eventName) {
    var listeners = eventName !== "*" ? this._listeners[eventName] : this._starListeners;
    var ret = [];
    if (listeners) {
        var ilength = listeners.length;
        for(var i = 0; i < ilength; i++)ret.push(listeners[i]);
    }
    return ret;
};
$6ac1a5641367fc62$var$Nanobus.prototype._emit = function(arr, eventName, data, uuid) {
    if (typeof arr === "undefined") return;
    if (arr.length === 0) return;
    if (data === undefined) {
        data = eventName;
        eventName = null;
    }
    if (eventName) {
        if (uuid !== undefined) data = [
            eventName
        ].concat(data, uuid);
        else data = [
            eventName
        ].concat(data);
    }
    var length = arr.length;
    for(var i = 0; i < length; i++){
        var listener = arr[i];
        listener.apply(listener, data);
    }
};


const $3104dd1e56b57153$export$ff7a4086e1ae6cb5 = (0, (/*@__PURE__*/$parcel$interopDefault($6ac1a5641367fc62$exports)))();


function $6999c02c9fa8589c$export$6483924f57bebc09(path) {
    return path.replace(window.SITE_BASE, "").replace(/^\/+/g, "");
}
function $6999c02c9fa8589c$export$fbeb6c75aea2f573(path) {
    const uri = $6999c02c9fa8589c$export$6483924f57bebc09(path);
    const params = $6999c02c9fa8589c$export$b00f191dd2e4e48(uri);
    let apiuri;
    if (uri === "") apiuri = "home.json";
    else if (params.params) // Note: content rep params that start with page fail on localhost
    apiuri = params.uri + ".json/" + params.params;
    else apiuri = uri + ".json";
    return apiuri;
}
function $6999c02c9fa8589c$export$b00f191dd2e4e48(uri) {
    const segments = uri.split("/");
    const separator1 = ":";
    let uriSegment = [];
    let paramsSegment = [];
    segments.forEach((segment)=>{
        const kv = segment.split(separator1);
        if (kv.length === 2) paramsSegment.push({
            key: kv[0],
            value: kv[1]
        });
        else uriSegment.push(kv[0]);
    });
    return {
        uri: uriSegment.join("/"),
        params: paramsSegment.map((p)=>`${p.key}${separator1}${p.value}`).join("/") || false,
        data: paramsSegment
    };
}
function $6999c02c9fa8589c$export$d0897e91ee75c451(params) {
    return params.map((p)=>`${p.key}${separator}${p.value}`).join("/") || false;
}
function $6999c02c9fa8589c$export$8f10f63063da874a(path) {
    return `${window.SITE_BASE}/${path}`;
}
function $6999c02c9fa8589c$export$99418391c9d4edd1(path) {
    return $6999c02c9fa8589c$export$6483924f57bebc09(path) === "";
}
function $6999c02c9fa8589c$export$32b5e5fecf41ac06(path) {
    const uri = $6999c02c9fa8589c$export$6483924f57bebc09(path);
    return uri.startsWith("exhibitions") || uri.startsWith("events");
}
function $6999c02c9fa8589c$export$270e7ba5936d3c48(html) {
    return new DOMParser().parseFromString(html, "text/html").body.firstChild;
}
function $6999c02c9fa8589c$export$248d38f6296296c5(a, b) {
    try {
        return JSON.stringify(a) === JSON.stringify(b);
    } catch (e) {
        return false;
    }
}
function $6999c02c9fa8589c$export$738e5b30c1de07ca(key, value) {
    const root = document.querySelector(":root");
    root.style.setProperty(key, value);
}
function $6999c02c9fa8589c$export$246d3e180f7f2ea(key, asInt) {
    const root = document.querySelector(":root");
    const rs = getComputedStyle(root);
    const val = rs.getPropertyValue(key);
    return asInt ? parseInt(val) : val;
}
const $6999c02c9fa8589c$export$fa3d0cfd30804048 = ($element, offset, options)=>{
    window.scrollTo(Object.assign({
        top: $element.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset
    }, options || {}));
};
const $6999c02c9fa8589c$export$81bfe36fdbf6f8bf = window.matchMedia("(hover: hover)");
const $6999c02c9fa8589c$export$d0a8044dce8ff2fc = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const $6999c02c9fa8589c$export$d6f8e41b69326771 = "#f00";
const $6999c02c9fa8589c$export$33a2cf1bd0f02582 = (coordinates, map)=>{
    let options = {
        center: coordinates
    };
    // only zoom in when zoomed out
    if (map.getZoom() < 15) options.zoom = 15;
    // disable curve when zoomed in
    if (map.getZoom() >= 15 && map.getBounds().contains(coordinates)) options.curve = 0;
    map.flyTo(options);
};
const $6999c02c9fa8589c$export$9975f96781720201 = (geojson)=>{
    const groupByCoordinates = geojson?.features.reduce((a, feature)=>{
        const coordinates = feature.geometry.coordinates.join(",");
        if (!a[coordinates]) a[coordinates] = [];
        a[coordinates].push(feature);
        return a;
    }, {});
    const overlappingPointGroups = Object.values(groupByCoordinates).filter((groups)=>groups.length > 1);
    overlappingPointGroups.forEach((group)=>{
        group.forEach((point, i)=>{
            const coordinates = point.geometry.coordinates;
            // Modify the point in the actual geojson
            // geojson.features[point.id].geometry.coordinates[0] = coordinates[0] + (0.00005 * i)
            geojson.features[point.id].geometry.coordinates[0] = coordinates[0] + 0.0001 * i;
        });
    });
    return geojson;
};


let $d7437ec6a852468a$var$previousLocation = window.location.pathname;
let $d7437ec6a852468a$var$loadingTimeout = null;
let $d7437ec6a852468a$var$isPopState = false;
const $d7437ec6a852468a$var$app = window.GPLA_APP = (0, $b50c183501f1ff74$export$2e2bcd8739ae039)("[data-operator-viewport]");
// Set previous location on link click
(0, (/*@__PURE__*/$parcel$interopDefault($f31978d9b51db8d6$exports)))(document.body, "a[href]", "click", (e)=>{
    $d7437ec6a852468a$var$previousLocation = window.location.pathname;
}, true);
// Close existing popup on `before` navigate
$d7437ec6a852468a$var$app.on("before", (state)=>{
    (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:page", (0, $6999c02c9fa8589c$export$fbeb6c75aea2f573)(state.location));
});
$d7437ec6a852468a$var$app.on("navigate", (state)=>{
    // Don't do anything when navigating to same route
    if ($d7437ec6a852468a$var$previousLocation === state.location) return;
    // Add loading timeout after 250ms
    $d7437ec6a852468a$var$loadingTimeout = setTimeout(()=>{
        document.documentElement.classList.add("loading");
    }, 250);
});
$d7437ec6a852468a$var$app.on("after", ({ previousDocument: previousDocument, location: location })=>{
    // Clear loading timeout
    clearTimeout($d7437ec6a852468a$var$loadingTimeout);
    document.documentElement.classList.remove("loading");
    // Update title
    document.title = previousDocument.title;
    // Update route
    if ($d7437ec6a852468a$var$isPopState) {
        // When navigating back with browser back button, replace state
        window.history.replaceState(null, "", location);
        $d7437ec6a852468a$var$isPopState = false;
    } else window.history.pushState(null, "", location);
    // Update opengraph
    let opengraphTags = [
        ...previousDocument.querySelectorAll('[property^="og:"]')
    ];
    opengraphTags.forEach((tag)=>{
        let existingOpengraphTag = document.querySelector(`[property="${tag.getAttribute("property")}"`);
        if (existingOpengraphTag) existingOpengraphTag.content = tag.content;
    });
    // Update classes
    $d7437ec6a852468a$var$updateClasses(previousDocument);
    // Update areas
    $d7437ec6a852468a$var$updateAreas(previousDocument);
    // Reset scroll position
    window.scrollTo(0, 0);
    // Refresh Instagram Embeds
    window?.instgrm?.Embeds?.process();
});
window.onpopstate = function() {
    $d7437ec6a852468a$var$isPopState = true;
};
/**
 * Add a `data-operator-classes` attribute to all elements
 * outside the operator viewport that should have their
 * classList updated on navigate.
 */ function $d7437ec6a852468a$var$updateClasses(previousDocument) {
    const oldElements = [
        ...previousDocument.querySelectorAll("[data-operator-classes]")
    ];
    const newElements = [
        ...document.querySelectorAll("[data-operator-classes]")
    ];
    newElements.forEach((newElement, i)=>{
        let oldElement = oldElements[i];
        let oldClasses = [
            ...oldElement.classList
        ];
        let newClasses = [
            ...newElement.classList
        ];
        let classesToRemove = newClasses.filter((x)=>!oldClasses.includes(x));
        let classesToAdd = oldClasses.filter((x)=>!newClasses.includes(x));
        newElement.classList.remove(...classesToRemove);
        newElement.classList.add(...classesToAdd);
    });
}
/**
 * Add a `data-operator-area` attribute to all elements
 * outside the operator viewport that should have their
 * contents updated on navigate.
 */ function $d7437ec6a852468a$var$updateAreas(previousDocument) {
    const newElements = [
        ...previousDocument.querySelectorAll("[data-operator-area]")
    ];
    const currentElements = [
        ...document.querySelectorAll("[data-operator-area]")
    ];
    currentElements.forEach((currentElement, i)=>{
        let newElement = newElements[i];
        if (!newElement) return;
        currentElement.replaceWith(newElement);
    });
}


var $cee2a9123a7e8ef2$export$2e2bcd8739ae039 = typeof Promise === "function" ? Promise : function(fn) {
    let queue = [], resolved = 0, value;
    fn(($)=>{
        value = $;
        resolved = 1;
        queue.splice(0).forEach(then);
    });
    return {
        then: then
    };
    function then(fn) {
        return resolved ? setTimeout(fn, 0, value) : queue.push(fn), this;
    }
};


const $52ca24f3afc1ec72$var$TRUE = true, $52ca24f3afc1ec72$var$FALSE = false;
const $52ca24f3afc1ec72$var$QSA = "querySelectorAll";
function $52ca24f3afc1ec72$var$add(node) {
    this.observe(node, {
        subtree: $52ca24f3afc1ec72$var$TRUE,
        childList: $52ca24f3afc1ec72$var$TRUE
    });
}
const $52ca24f3afc1ec72$export$5e14cdade93d6f7b = (callback, root, MO)=>{
    const loop = (nodes, added, removed, connected, pass)=>{
        for(let i = 0, { length: length } = nodes; i < length; i++){
            const node = nodes[i];
            if (pass || $52ca24f3afc1ec72$var$QSA in node) {
                if (connected) {
                    if (!added.has(node)) {
                        added.add(node);
                        removed.delete(node);
                        callback(node, connected);
                    }
                } else if (!removed.has(node)) {
                    removed.add(node);
                    added.delete(node);
                    callback(node, connected);
                }
                if (!pass) loop(node[$52ca24f3afc1ec72$var$QSA]("*"), added, removed, connected, $52ca24f3afc1ec72$var$TRUE);
            }
        }
    };
    const observer = new (MO || MutationObserver)((records)=>{
        for(let added = new Set, removed = new Set, i = 0, { length: length } = records; i < length; i++){
            const { addedNodes: addedNodes, removedNodes: removedNodes } = records[i];
            loop(removedNodes, added, removed, $52ca24f3afc1ec72$var$FALSE, $52ca24f3afc1ec72$var$FALSE);
            loop(addedNodes, added, removed, $52ca24f3afc1ec72$var$TRUE, $52ca24f3afc1ec72$var$FALSE);
        }
    });
    observer.add = $52ca24f3afc1ec72$var$add;
    observer.add(root || document);
    return observer;
};


const $19516ec9e1dc890a$var$QSA = "querySelectorAll";
const { document: $19516ec9e1dc890a$var$document, Element: $19516ec9e1dc890a$var$Element, MutationObserver: $19516ec9e1dc890a$var$MutationObserver, Set: $19516ec9e1dc890a$var$Set, WeakMap: $19516ec9e1dc890a$var$WeakMap } = self;
const $19516ec9e1dc890a$var$elements = (element)=>$19516ec9e1dc890a$var$QSA in element;
const { filter: $19516ec9e1dc890a$var$filter } = [];
var $19516ec9e1dc890a$export$2e2bcd8739ae039 = (options)=>{
    const live = new $19516ec9e1dc890a$var$WeakMap;
    const drop = (elements)=>{
        for(let i = 0, { length: length } = elements; i < length; i++)live.delete(elements[i]);
    };
    const flush = ()=>{
        const records = observer.takeRecords();
        for(let i = 0, { length: length } = records; i < length; i++){
            parse($19516ec9e1dc890a$var$filter.call(records[i].removedNodes, $19516ec9e1dc890a$var$elements), false);
            parse($19516ec9e1dc890a$var$filter.call(records[i].addedNodes, $19516ec9e1dc890a$var$elements), true);
        }
    };
    const matches = (element)=>element.matches || element.webkitMatchesSelector || element.msMatchesSelector;
    const notifier = (element, connected)=>{
        let selectors;
        if (connected) {
            for(let q, m = matches(element), i = 0, { length: length } = query; i < length; i++)if (m.call(element, q = query[i])) {
                if (!live.has(element)) live.set(element, new $19516ec9e1dc890a$var$Set);
                selectors = live.get(element);
                if (!selectors.has(q)) {
                    selectors.add(q);
                    options.handle(element, connected, q);
                }
            }
        } else if (live.has(element)) {
            selectors = live.get(element);
            live.delete(element);
            selectors.forEach((q)=>{
                options.handle(element, connected, q);
            });
        }
    };
    const parse = (elements, connected = true)=>{
        for(let i = 0, { length: length } = elements; i < length; i++)notifier(elements[i], connected);
    };
    const { query: query } = options;
    const root = options.root || $19516ec9e1dc890a$var$document;
    const observer = (0, $52ca24f3afc1ec72$export$5e14cdade93d6f7b)(notifier, root, $19516ec9e1dc890a$var$MutationObserver);
    const { attachShadow: attachShadow } = $19516ec9e1dc890a$var$Element.prototype;
    if (attachShadow) $19516ec9e1dc890a$var$Element.prototype.attachShadow = function(init) {
        const shadowRoot = attachShadow.call(this, init);
        observer.add(shadowRoot);
        return shadowRoot;
    };
    if (query.length) parse(root[$19516ec9e1dc890a$var$QSA](query));
    return {
        drop: drop,
        flush: flush,
        observer: observer,
        parse: parse
    };
};


const { create: $8f89c991f8e64093$var$create, keys: $8f89c991f8e64093$var$keys } = Object;
const $8f89c991f8e64093$var$attributes = new WeakMap;
const $8f89c991f8e64093$var$lazy = new Set;
const $8f89c991f8e64093$var$query = [];
const $8f89c991f8e64093$var$config = {};
const $8f89c991f8e64093$var$defined = {};
const $8f89c991f8e64093$var$attributeChangedCallback = (records, o)=>{
    for(let h = $8f89c991f8e64093$var$attributes.get(o), i = 0, { length: length } = records; i < length; i++){
        const { target: target, attributeName: attributeName, oldValue: oldValue } = records[i];
        const newValue = target.getAttribute(attributeName);
        h.attributeChanged(attributeName, oldValue, newValue);
    }
};
const $8f89c991f8e64093$var$set = (value, m, l, o)=>{
    const handler = $8f89c991f8e64093$var$create(o, {
        element: {
            enumerable: true,
            value: value
        }
    });
    for(let i = 0, { length: length } = l; i < length; i++)value.addEventListener(l[i].t, handler, l[i].o);
    m.set(value, handler);
    if (handler.init) handler.init();
    const { observedAttributes: observedAttributes } = o;
    if (observedAttributes) {
        const mo = new MutationObserver($8f89c991f8e64093$var$attributeChangedCallback);
        mo.observe(value, {
            attributes: true,
            attributeOldValue: true,
            attributeFilter: observedAttributes.map((attributeName)=>{
                if (value.hasAttribute(attributeName)) handler.attributeChanged(attributeName, null, value.getAttribute(attributeName));
                return attributeName;
            })
        });
        $8f89c991f8e64093$var$attributes.set(mo, handler);
    }
    return handler;
};
const { drop: $8f89c991f8e64093$var$drop, flush: $8f89c991f8e64093$var$flush, parse: $8f89c991f8e64093$var$parse } = (0, $19516ec9e1dc890a$export$2e2bcd8739ae039)({
    query: $8f89c991f8e64093$var$query,
    handle (element, connected, selector) {
        const { m: m, l: l, o: o } = $8f89c991f8e64093$var$config[selector];
        const handler = m.get(element) || $8f89c991f8e64093$var$set(element, m, l, o);
        const method = connected ? "connected" : "disconnected";
        if (method in handler) handler[method]();
    }
});
const $8f89c991f8e64093$export$3988ae62b71be9a3 = (selector)=>($8f89c991f8e64093$var$config[selector] || $8f89c991f8e64093$var$attributes).o;
const $8f89c991f8e64093$export$f36d6a7a5c09a23e = (selector, definition)=>{
    if (-1 < $8f89c991f8e64093$var$query.indexOf(selector)) throw new Error("duplicated: " + selector);
    $8f89c991f8e64093$var$flush();
    const listeners = [];
    const retype = $8f89c991f8e64093$var$create(null);
    for(let k = $8f89c991f8e64093$var$keys(definition), i = 0, { length: length } = k; i < length; i++){
        const key = k[i];
        if (/^on/.test(key) && !/Options$/.test(key)) {
            const options = definition[key + "Options"] || false;
            const lower = key.toLowerCase();
            let type = lower.slice(2);
            listeners.push({
                t: type,
                o: options
            });
            retype[type] = key;
            if (lower !== key) {
                type = key.slice(2, 3).toLowerCase() + key.slice(3);
                retype[type] = key;
                listeners.push({
                    t: type,
                    o: options
                });
            }
        }
    }
    if (listeners.length) definition.handleEvent = function(event) {
        this[retype[event.type]](event);
    };
    $8f89c991f8e64093$var$query.push(selector);
    $8f89c991f8e64093$var$config[selector] = {
        m: new WeakMap,
        l: listeners,
        o: definition
    };
    $8f89c991f8e64093$var$parse(document.querySelectorAll(selector));
    $8f89c991f8e64093$export$785f9b878ae51e44(selector);
    if (!$8f89c991f8e64093$var$lazy.has(selector)) $8f89c991f8e64093$var$defined[selector]._();
};
const $8f89c991f8e64093$export$cb4885581b710ca6 = (selector, callback, _)=>{
    $8f89c991f8e64093$var$lazy.add(selector);
    $8f89c991f8e64093$export$f36d6a7a5c09a23e(selector, {
        init () {
            if ($8f89c991f8e64093$var$lazy.has(selector)) {
                $8f89c991f8e64093$var$lazy.delete(selector);
                callback().then(({ default: definition })=>{
                    $8f89c991f8e64093$var$query.splice($8f89c991f8e64093$var$query.indexOf(selector), 1);
                    $8f89c991f8e64093$var$drop(document.querySelectorAll(selector));
                    (_ || $8f89c991f8e64093$export$f36d6a7a5c09a23e)(selector, definition);
                });
            }
        }
    });
};
const $8f89c991f8e64093$export$ba387509dbaf942e = (element)=>{
    if ($8f89c991f8e64093$var$query.length) {
        $8f89c991f8e64093$var$flush();
        $8f89c991f8e64093$var$parse([
            element
        ]);
    }
};
const $8f89c991f8e64093$export$785f9b878ae51e44 = (selector)=>{
    if (!(selector in $8f89c991f8e64093$var$defined)) {
        let _, $ = new (0, $cee2a9123a7e8ef2$export$2e2bcd8739ae039)(($)=>{
            _ = $;
        });
        $8f89c991f8e64093$var$defined[selector] = {
            _: _,
            $: $
        };
    }
    return $8f89c991f8e64093$var$defined[selector].$;
};


class $b1b80f837b980ac7$export$2e2bcd8739ae039 extends Array {
    #index = 0;
    constructor(array){
        if (!Array.isArray(array)) throw new TypeError("Expected an array");
        super(...array);
    }
    *[Symbol.iterator]() {
        let { length: length } = this;
        while(length-- > 0){
            yield this.current();
            this.index++;
        }
    }
    get index() {
        return this.#index;
    }
    set index(index) {
        this.#index = (this.length + index % this.length) % this.length;
    }
    step(steps) {
        this.#index = (this.length + this.#index + steps) % this.length;
        return this[this.#index];
    }
    peek(steps) {
        return this[(this.length + this.#index + steps) % this.length];
    }
    current() {
        return this.step(0);
    }
    next() {
        return this.step(1);
    }
    previous() {
        return this.step(-1);
    }
    *indefinitely() {
        while(true)yield this.next();
    }
    *indefinitelyReversed() {
        while(true)yield this.previous();
    }
}


var $9bc53439224f155e$exports = {};
$9bc53439224f155e$exports = $9bc53439224f155e$var$random;
function $9bc53439224f155e$var$random(n1, n2) {
    if (typeof n1 == "undefined") n1 = 1;
    if (typeof n2 == "undefined") n2 = 0;
    if (typeof n1 != "number" || typeof n2 !== "number") throw new Error("just-random: arguments must be numbers");
    if (n1 > n2) {
        let temp = n1;
        n1 = n2;
        n2 = temp;
    }
    return ~~(Math.random() * ($9bc53439224f155e$var$trunc(n2) + 1 - $9bc53439224f155e$var$trunc(n1))) + $9bc53439224f155e$var$trunc(n1);
}
function $9bc53439224f155e$var$trunc(n) {
    return Math.trunc ? Math.trunc(n) : Math.floor(n) + (n < 0 ? 1 : 0);
}


const $aeb2112c1ea428ff$export$2e2bcd8739ae039 = {
    "accent": "#f0e9e3",
    "tan": "#cfbeaf",
    "red": "#fa4003",
    "blue": "#267dde",
    "yellow": "#ffed00",
    "green": "#45c905",
    "tan_10": "#bbad9e",
    "tan_20": "#a4968a",
    "tan_30": "#90857a",
    "tan_40": "#7d7369",
    "tan_50": "#676058",
    "tan_60": "#534c46",
    "tan_70": "#3d3933",
    "tan_80": "#292623",
    "tan_90": "#171514"
};
const $aeb2112c1ea428ff$var$cyclecolors = {
    "red": "#fa4003",
    "blue": "#267dde",
    "green": "#45c905"
};
const $aeb2112c1ea428ff$var$colorNames = Object.keys($aeb2112c1ea428ff$var$cyclecolors);
const $aeb2112c1ea428ff$export$78232bdf77d1cea6 = new (0, $b1b80f837b980ac7$export$2e2bcd8739ae039)($aeb2112c1ea428ff$var$colorNames);
$aeb2112c1ea428ff$export$78232bdf77d1cea6.index = (0, (/*@__PURE__*/$parcel$interopDefault($9bc53439224f155e$exports)))($aeb2112c1ea428ff$var$colorNames.length - 1);


(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="use-color"]', {
    init () {
        const color = (0, $aeb2112c1ea428ff$export$78232bdf77d1cea6).next();
        this.element.style.setProperty("--accent", `var(--${color})`);
    }
});



var $bbe186f9413d552f$exports = {};
$bbe186f9413d552f$exports = $bbe186f9413d552f$var$Element;
function $bbe186f9413d552f$var$Element(svgText) {
    var parser = new DOMParser(), xmlText = "<svg xmlns='http://www.w3.org/2000/svg'>" + svgText + "</svg>", docElem = parser.parseFromString(xmlText, "text/xml").documentElement;
    var node = docElem.firstChild;
    document.importNode(node, true);
    return node;
}


function $0458c39d24b2e7ef$export$2e2bcd8739ae039(array) {
    if (!Array.isArray(array)) throw new TypeError("Expected an array");
    return array[Math.floor(Math.random() * array.length)];
}
$0458c39d24b2e7ef$export$2e2bcd8739ae039.multiple = (array, count)=>{
    if (!(Number.isInteger(count) && count >= 0)) throw new TypeError("Expected a non-negative integer");
    return [
        ...Array.from({
            length: count
        })
    ].map(()=>$0458c39d24b2e7ef$export$2e2bcd8739ae039(array));
};


/**
 * Draws SVG with various corner shapes
 * as the background of an element
 *
 * Notes:
 * - Bevel, Curve, Sweep, Notch, false (normal corner)
 * - Can pass % radius
 * - Can pass min radius
 * - data-stroke is a boolean attribute:
 *   - We shrink 1px around egde of svg to support 1px stroke
 *
 * Enhancements:
 * - Calc inset based on stroke width for variable stroke
 */ (0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="corner-shape"]', {
    init () {
        this.radius = parseFloat(this.element.dataset.radius) || 50;
        this.minRadius = parseInt(this.element.dataset.minRadius) || 0;
        this.percentage = this.element.dataset?.radius?.includes("%");
        this.stroke = this.element.hasAttribute("data-stroke");
        const shapes = [
            [
                "bevel",
                false,
                "curve",
                false
            ],
            [
                false,
                "curve",
                false,
                "curve"
            ],
            [
                false,
                "curve",
                "bevel",
                false
            ],
            [
                "bevel",
                "bevel",
                "bevel",
                "bevel"
            ],
            [
                "bevel",
                "bevel",
                false,
                "curve"
            ],
            [
                false,
                "bevel",
                "curve",
                "bevel"
            ]
        ];
        // Get corner from option or select random
        try {
            let parsed = JSON.parse(this.element.dataset.corners);
            parsed = parsed.map((item)=>item === "false" ? false : item === "true" ? true : item);
            this.corners = parsed.length === 4 ? parsed : (0, $0458c39d24b2e7ef$export$2e2bcd8739ae039)(shapes);
        } catch (e) {
            this.corners = (0, $0458c39d24b2e7ef$export$2e2bcd8739ae039)(shapes);
        }
        // SVG init
        this.$svg = this.stroke ? (0, (/*@__PURE__*/$parcel$interopDefault($bbe186f9413d552f$exports)))(`<svg preserveAspectRatio="none"><g transform="translate(0.5,0.5)"><path /></g></svg>`) : (0, (/*@__PURE__*/$parcel$interopDefault($bbe186f9413d552f$exports)))(`<svg preserveAspectRatio="none"><g><path /></g></svg>`);
        this.$g = this.$svg.querySelector("g");
        this.$path = this.$svg.querySelector("path");
        this.element.appendChild(this.$svg);
        this.render = this.render.bind(this);
        this.resizeObserver = new ResizeObserver(this.render);
    },
    connected () {
        this.render();
        this.resizeObserver.observe(this.element);
    },
    disconnected () {
        this.resizeObserver.unobserve(this.element);
    },
    drawCorner (corner, shape, w, h, r, d) {
        if (!shape) switch(corner){
            case 0:
                d.push("h", r, "v", r);
                break;
            case 1:
                d.push("v", r, "h", -r);
                break;
            case 2:
                d.push("h", -r, "v", -r);
                break;
            case 3:
                d.push("v", -r, "h", r);
        }
        else if (shape === "notch") switch(corner){
            case 0:
                d.push("v", r, "h", r);
                break;
            case 1:
                d.push("h", -r, "v", r);
                break;
            case 2:
                d.push("v", -r, "h", -r);
                break;
            case 3:
                d.push("h", r, "v", -r);
        }
        else {
            if (shape === "curve" || shape === "scoop") {
                const sweep = +(shape === "curve");
                d.push("a", r, r, "0", 0, sweep);
            } else if (shape === "bevel") d.push("l");
            d.push(corner === 1 || corner === 2 ? -r : r);
            d.push(corner === 2 || corner === 3 ? -r : r);
        }
    },
    adjustedRadius (r, w, h) {
        // Calculate radius based on percentage
        let radius = r;
        if (this.percentage) {
            const calculatedRadius = Math.max(w, h) * (r / 100);
            radius = Math.max(calculatedRadius, this.minRadius);
        }
        // Make sure radius is no greater than 1/3 of the largest size
        if (radius > w / 3 || radius > h / 3) return Math.min(w, h) / 3;
        else return radius;
    },
    render () {
        const inset = this.stroke ? 2 : 0 // space for stroke
        ;
        const w = this.element.offsetWidth;
        const h = this.element.offsetHeight;
        const r = this.adjustedRadius(this.radius, w, h);
        // Set svg size
        this.$svg.setAttribute("width", w + inset);
        this.$svg.setAttribute("height", h + inset);
        this.$svg.setAttribute("viewBox", `0 0 ${w + inset} ${h + inset}`);
        // Open shape
        let d = [
            "M",
            r,
            "0"
        ];
        // Draw corners
        this.corners.forEach((shape, corner)=>{
            switch(corner){
                case 0:
                    d.push("h", w - r * 2);
                    break;
                case 1:
                    d.push("v", h - r * 2);
                    break;
                case 2:
                    d.push("h", -w + r * 2);
                    break;
                case 3:
                    d.push("v", -h + r * 2);
            }
            this.drawCorner(corner, shape, w, h, r, d);
        });
        // Close shape
        d.push("Z");
        this.$path.setAttribute("d", d.join(" "));
    }
});


const $1a1ba1ab2bb4f0ed$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $1a1ba1ab2bb4f0ed$var$e = function(t, i) {
    return !(!t || t === document.body || i && t === i) && (function(t) {
        if (!(t && t instanceof Element && t.offsetParent)) return !1;
        const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
        return e && !n && !s;
    }(t) ? t : $1a1ba1ab2bb4f0ed$var$e(t.parentElement, i));
}, $1a1ba1ab2bb4f0ed$var$i = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $1a1ba1ab2bb4f0ed$var$n = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $1a1ba1ab2bb4f0ed$var$s = (t, e, i)=>{
    t && $1a1ba1ab2bb4f0ed$var$n(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $1a1ba1ab2bb4f0ed$var$o {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $1a1ba1ab2bb4f0ed$var$a = {
    passive: !1
};
class $1a1ba1ab2bb4f0ed$var$r {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $1a1ba1ab2bb4f0ed$var$a), this.element.addEventListener("touchstart", this.onTouchStart, $1a1ba1ab2bb4f0ed$var$a), this.element.addEventListener("touchmove", this.onMove, $1a1ba1ab2bb4f0ed$var$a), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $1a1ba1ab2bb4f0ed$var$o(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $1a1ba1ab2bb4f0ed$var$o(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $1a1ba1ab2bb4f0ed$var$o(t)) : [
            new $1a1ba1ab2bb4f0ed$var$o(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $1a1ba1ab2bb4f0ed$var$o(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $1a1ba1ab2bb4f0ed$var$o(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $1a1ba1ab2bb4f0ed$var$a), this.element.removeEventListener("touchstart", this.onTouchStart, $1a1ba1ab2bb4f0ed$var$a), this.element.removeEventListener("touchmove", this.onMove, $1a1ba1ab2bb4f0ed$var$a), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $1a1ba1ab2bb4f0ed$var$l(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $1a1ba1ab2bb4f0ed$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $1a1ba1ab2bb4f0ed$var$c = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $1a1ba1ab2bb4f0ed$var$d = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $1a1ba1ab2bb4f0ed$var$c(i) ? Object.assign(t[e], $1a1ba1ab2bb4f0ed$var$d(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $1a1ba1ab2bb4f0ed$var$u = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $1a1ba1ab2bb4f0ed$var$g {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $1a1ba1ab2bb4f0ed$var$d({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $1a1ba1ab2bb4f0ed$var$u(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $1a1ba1ab2bb4f0ed$var$u(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $1a1ba1ab2bb4f0ed$var$u(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($1a1ba1ab2bb4f0ed$var$g, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($1a1ba1ab2bb4f0ed$var$g, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $1a1ba1ab2bb4f0ed$var$p extends $1a1ba1ab2bb4f0ed$var$g {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $1a1ba1ab2bb4f0ed$var$f;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($1a1ba1ab2bb4f0ed$var$f || ($1a1ba1ab2bb4f0ed$var$f = {}));
const $1a1ba1ab2bb4f0ed$var$m = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $1a1ba1ab2bb4f0ed$var$b = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: {
        PANUP: "Move up",
        PANDOWN: "Move down",
        PANLEFT: "Move left",
        PANRIGHT: "Move right",
        ZOOMIN: "Zoom in",
        ZOOMOUT: "Zoom out",
        TOGGLEZOOM: "Toggle zoom level",
        TOGGLE1TO1: "Toggle zoom level",
        ITERATEZOOM: "Toggle zoom level",
        ROTATECCW: "Rotate counterclockwise",
        ROTATECW: "Rotate clockwise",
        FLIPX: "Flip horizontally",
        FLIPY: "Flip vertically",
        FITX: "Fit horizontally",
        FITY: "Fit vertically",
        RESET: "Reset",
        TOGGLEFS: "Toggle fullscreen"
    }
}, $1a1ba1ab2bb4f0ed$var$v = '<circle cx="25" cy="25" r="20"></circle>', $1a1ba1ab2bb4f0ed$var$y = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $1a1ba1ab2bb4f0ed$var$v + $1a1ba1ab2bb4f0ed$var$v + "</svg></div>", $1a1ba1ab2bb4f0ed$var$w = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $1a1ba1ab2bb4f0ed$var$x = (t, e)=>{
    t && $1a1ba1ab2bb4f0ed$var$n(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $1a1ba1ab2bb4f0ed$var$P = (t, e)=>{
    t && $1a1ba1ab2bb4f0ed$var$n(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $1a1ba1ab2bb4f0ed$var$T = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $1a1ba1ab2bb4f0ed$var$S = 1e5, $1a1ba1ab2bb4f0ed$var$M = 1e4, $1a1ba1ab2bb4f0ed$var$O = "mousemove", $1a1ba1ab2bb4f0ed$var$E = "drag", $1a1ba1ab2bb4f0ed$var$k = "content", $1a1ba1ab2bb4f0ed$var$z = "auto";
let $1a1ba1ab2bb4f0ed$var$L = null, $1a1ba1ab2bb4f0ed$var$D = null;
class $1a1ba1ab2bb4f0ed$export$b704d075ddd20210 extends $1a1ba1ab2bb4f0ed$var$p {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $1a1ba1ab2bb4f0ed$var$D && ($1a1ba1ab2bb4f0ed$var$D = window.matchMedia("(hover: none)").matches), $1a1ba1ab2bb4f0ed$var$D;
    }
    get isMobile() {
        return null === $1a1ba1ab2bb4f0ed$var$L && ($1a1ba1ab2bb4f0ed$var$L = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $1a1ba1ab2bb4f0ed$var$L;
    }
    get panMode() {
        return this.options.panMode !== $1a1ba1ab2bb4f0ed$var$O || this.isTouchDevice ? $1a1ba1ab2bb4f0ed$var$E : $1a1ba1ab2bb4f0ed$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $1a1ba1ab2bb4f0ed$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $1a1ba1ab2bb4f0ed$var$m){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, n = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $1a1ba1ab2bb4f0ed$var$f.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $1a1ba1ab2bb4f0ed$var$T)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $1a1ba1ab2bb4f0ed$var$T)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $1a1ba1ab2bb4f0ed$export$b704d075ddd20210.Plugins), n)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $1a1ba1ab2bb4f0ed$var$i($1a1ba1ab2bb4f0ed$var$y);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($1a1ba1ab2bb4f0ed$var$k);
        let i = this.option($1a1ba1ab2bb4f0ed$var$k) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $1a1ba1ab2bb4f0ed$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $1a1ba1ab2bb4f0ed$var$f.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $1a1ba1ab2bb4f0ed$var$f.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $1a1ba1ab2bb4f0ed$var$f.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $1a1ba1ab2bb4f0ed$var$r(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($1a1ba1ab2bb4f0ed$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($1a1ba1ab2bb4f0ed$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $1a1ba1ab2bb4f0ed$var$m)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $1a1ba1ab2bb4f0ed$var$m)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, h = a.max, c = r.min, d = r.max;
        let u = 0, g = 0;
        return l !== 1 / 0 && n < l ? u = l - n : h !== 1 / 0 && n > h && (u = h - n), c !== 1 / 0 && s < c ? g = c - s : d !== 1 / 0 && s > d && (g = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(g) < 1e-4 && (g = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: g,
            inBounds: !u && !g
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), h = i ? o : n, c = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), g = new DOMPoint(0 + h, 0).matrixTransform(d), p = new DOMPoint(0 + h, 0 + c).matrixTransform(d), f = new DOMPoint(0, 0 + c).matrixTransform(d), m = Math.abs(p.x - u.x), b = Math.abs(p.y - u.y), v = Math.abs(f.x - g.x), y = Math.abs(f.y - g.y);
            r = Math.max(m, v), l = Math.max(b, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $1a1ba1ab2bb4f0ed$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $1a1ba1ab2bb4f0ed$var$m)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $1a1ba1ab2bb4f0ed$var$f.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $1a1ba1ab2bb4f0ed$var$w(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const h = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, c = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && c && h(c)) : (this.emit("dblClick", t), t.defaultPrevented || h(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && c && h(c));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $1a1ba1ab2bb4f0ed$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(i, n, s) {
        if (!1 === this.option("touch", i)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $1a1ba1ab2bb4f0ed$var$t(this.targetScale) <= $1a1ba1ab2bb4f0ed$var$t(this.minScale)) return;
        if (this.emit("touchMove", i), i.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $1a1ba1ab2bb4f0ed$var$h(s[0], s[1]), r = $1a1ba1ab2bb4f0ed$var$h(n[0], n[1]);
        let c = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            c = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $1a1ba1ab2bb4f0ed$var$l(s[0], s[1]), g = $1a1ba1ab2bb4f0ed$var$l(n[0], n[1]);
        let p = u ? g / u : 1, f = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += f, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let b = $1a1ba1ab2bb4f0ed$var$t(this.targetScale) === $1a1ba1ab2bb4f0ed$var$t(this.minScale) && this.option("lockAxis");
        if (b && !this.lockedAxis) {
            if ("xy" === b || "y" === b || "touchmove" === i.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void i.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, f = 0, m = 0;
            } else this.lockedAxis = b;
        }
        if ($1a1ba1ab2bb4f0ed$var$e(i.target, this.content) && (b = "x", this.dragOffset.y = 0), b && "xy" !== b && this.lockedAxis !== b && $1a1ba1ab2bb4f0ed$var$t(this.targetScale) === $1a1ba1ab2bb4f0ed$var$t(this.minScale)) return;
        i.cancelable && i.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const v = this.checkBounds(f, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (v.xDiff > 0 && f < 0 || v.xDiff < 0 && f > 0) && (f *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * v.xDiff))), "y" !== this.isInfinite && (v.yDiff > 0 && m < 0 || v.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * v.yDiff)))) : (v.xDiff && (f = 0), v.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (p = Math.max(p, w)), y > 1.5 * x && (p = Math.min(p, x)), "y" === this.lockedAxis && $1a1ba1ab2bb4f0ed$var$t(y) === $1a1ba1ab2bb4f0ed$var$t(w) && (f = 0), "x" === this.lockedAxis && $1a1ba1ab2bb4f0ed$var$t(y) === $1a1ba1ab2bb4f0ed$var$t(w) && (m = 0), this.applyChange({
            originX: c,
            originY: d,
            panX: f,
            panY: m,
            scale: p,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, i, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(i), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $1a1ba1ab2bb4f0ed$var$e(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $1a1ba1ab2bb4f0ed$var$f.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $1a1ba1ab2bb4f0ed$var$m)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $1a1ba1ab2bb4f0ed$var$x(this.container, "is-scaling"), $1a1ba1ab2bb4f0ed$var$x(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const h = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== h && (a *= h, r *= h);
        let c = 0, d = 0, u = 0, g = 0, p = this.option("decelFriction");
        const f = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, g = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), g = Math.max(Math.min(g, t), -1 * t));
        }
        u && (c = u / (1 / (1 - p) - 1)), g && (d = g / (1 / (1 - p) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $1a1ba1ab2bb4f0ed$var$t(f) === this.minScale) && (c = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $1a1ba1ab2bb4f0ed$var$t(f) === this.minScale) && (d = g = 0);
        const b = this.dragOffset.x, v = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(b) < y && Math.abs(v) < y && (c = d = 0, u = g = 0), (this.option("zoom") && (f < this.minScale - 1e-5 || f > this.maxScale + 1e-5) || i && !c && !d) && (p = .35), this.applyChange({
            panX: c,
            panY: d,
            friction: p
        }), this.emit("decel", u, g, b, v);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $1a1ba1ab2bb4f0ed$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $1a1ba1ab2bb4f0ed$var$T);
        for (const n of $1a1ba1ab2bb4f0ed$var$m){
            const s = "e" == n || "f" === n ? $1a1ba1ab2bb4f0ed$var$M : $1a1ba1ab2bb4f0ed$var$S;
            o[n] = $1a1ba1ab2bb4f0ed$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: h, e: c, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${h}, ${c}, ${d})`, g = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (g = g.parentElement || g), g.style.transform === u) return;
        g.style.transform = u;
        const { contentWidth: p, contentHeight: f } = this.calculateContentDim();
        s.width = p, s.height = f, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $1a1ba1ab2bb4f0ed$var$f.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let h = r.width * n, c = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = h - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), g = c - d;
        this.containerRect = {
            width: h,
            height: c,
            innerWidth: u,
            innerHeight: g
        };
        const p = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), m = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let b = this.option("width", p) || $1a1ba1ab2bb4f0ed$var$z, v = this.option("height", m) || $1a1ba1ab2bb4f0ed$var$z;
        const y = b === $1a1ba1ab2bb4f0ed$var$z, w = v === $1a1ba1ab2bb4f0ed$var$z;
        "number" != typeof b && (b = p), "number" != typeof v && (v = m), y && (b = p * (v / m)), w && (v = m / (p / b));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const P = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const T = o.getBoundingClientRect();
        let S = T.width * n, M = T.height * n, O = S, E = M;
        S = Math.min(S, b), M = Math.min(M, v), a ? { width: S, height: M } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(b, v, S, M) : (S = Math.min(S, b), M = Math.min(M, v));
        let k = .5 * (E - M), L = .5 * (O - S);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: T.top - r.top + k,
            bottom: r.bottom - T.bottom + k,
            left: T.left - r.left + L,
            right: r.right - T.right + L,
            fitWidth: S,
            fitHeight: M,
            width: S,
            height: M,
            fullWidth: b,
            fullHeight: v
        }), x.style.cssText = P, a && (x.style.width = `${S}px`, x.style.height = `${M}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($1a1ba1ab2bb4f0ed$var$t(this.targetScale) < $1a1ba1ab2bb4f0ed$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $1a1ba1ab2bb4f0ed$var$f.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, h = 0, c = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, h = 1 / 0, l = -1 / 0, c = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $1a1ba1ab2bb4f0ed$var$t(o * n, $1a1ba1ab2bb4f0ed$var$M), g = $1a1ba1ab2bb4f0ed$var$t(a * n, $1a1ba1ab2bb4f0ed$var$M), { innerWidth: p, innerHeight: f } = s;
            if (s.width === u && (p = s.width), s.width === g && (f = s.height), e > p) {
                h = .5 * (e - p), r = -1 * h;
                let t = .5 * (d.right - d.left);
                r += t, h += t;
            }
            if (o > p && e < p && (r -= .5 * (o - p), h -= .5 * (o - p)), i > f) {
                c = .5 * (i - f), l = -1 * c;
                let t = .5 * (d.bottom - d.top);
                l += t, c += t;
            }
            a > f && i < f && (r -= .5 * (a - f), h -= .5 * (a - f));
        }
        return {
            x: {
                min: r,
                max: h
            },
            y: {
                min: l,
                max: c
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $1a1ba1ab2bb4f0ed$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: o, targetScale: a, minScale: r } = e;
        let l = r, h = e.option("click") || !1;
        h && (l = e.getNextScale(h));
        let c = e.canZoomIn(), d = e.canZoomOut(), u = n === $1a1ba1ab2bb4f0ed$var$E && !!this.option("touch"), g = d && u;
        if (u && ($1a1ba1ab2bb4f0ed$var$t(a) < $1a1ba1ab2bb4f0ed$var$t(r) && !this.panOnlyZoomed && (g = !0), ($1a1ba1ab2bb4f0ed$var$t(o.width, 1) > $1a1ba1ab2bb4f0ed$var$t(o.fitWidth, 1) || $1a1ba1ab2bb4f0ed$var$t(o.height, 1) > $1a1ba1ab2bb4f0ed$var$t(o.fitHeight, 1)) && (g = !0)), $1a1ba1ab2bb4f0ed$var$t(o.width * a, 1) < $1a1ba1ab2bb4f0ed$var$t(o.fitWidth, 1) && (g = !1), n === $1a1ba1ab2bb4f0ed$var$O && (g = !1), $1a1ba1ab2bb4f0ed$var$s(i, this.cn("isDraggable"), g), !this.option("zoom")) return;
        let p = c && $1a1ba1ab2bb4f0ed$var$t(l) > $1a1ba1ab2bb4f0ed$var$t(a), f = !p && !g && d && $1a1ba1ab2bb4f0ed$var$t(l) < $1a1ba1ab2bb4f0ed$var$t(a);
        $1a1ba1ab2bb4f0ed$var$s(i, this.cn("canZoomIn"), p), $1a1ba1ab2bb4f0ed$var$s(i, this.cn("canZoomOut"), f);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    c ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    c || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = c ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: h = !1 }) {
        this.state !== $1a1ba1ab2bb4f0ed$var$f.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: h
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: h = !1, ignoreBounds: c = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $1a1ba1ab2bb4f0ed$var$f.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = c;
        const { current: g } = this, p = g.e, b = g.f, v = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(p, b).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!c) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-p, -b).multiply(v), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), h && (y = y.scale(1, -1));
        for (const e of $1a1ba1ab2bb4f0ed$var$m)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $1a1ba1ab2bb4f0ed$var$t(y[e], $1a1ba1ab2bb4f0ed$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $1a1ba1ab2bb4f0ed$var$O || !1 === d) && !c && this.clampTargetBounds(), u === $1a1ba1ab2bb4f0ed$var$f.Init ? this.animate() : this.isResting || (this.state = $1a1ba1ab2bb4f0ed$var$f.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $1a1ba1ab2bb4f0ed$var$f.Init || this.state === $1a1ba1ab2bb4f0ed$var$f.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $1a1ba1ab2bb4f0ed$var$m)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $1a1ba1ab2bb4f0ed$var$x(this.container, "is-scaling"), $1a1ba1ab2bb4f0ed$var$x(this.container, "is-animating"), this.isTicking = !1, this.state = $1a1ba1ab2bb4f0ed$var$f.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $1a1ba1ab2bb4f0ed$var$P(this.container, "is-animating"), this.isScaling && $1a1ba1ab2bb4f0ed$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $1a1ba1ab2bb4f0ed$var$O || !e) return;
        if ($1a1ba1ab2bb4f0ed$var$t(this.targetScale) <= $1a1ba1ab2bb4f0ed$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), h = (e.clientX || 0) - l.left, c = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const g = this.option("mouseMoveFactor");
        g > 1 && (d !== a && (d *= g), u !== r && (u *= g));
        let p = .5 * (d - a) - h / a * 100 / 100 * (d - a);
        p += .5 * (o.right - o.left);
        let f = .5 * (u - r) - c / r * 100 / 100 * (u - r);
        f += .5 * (o.bottom - o.top), this.applyChange({
            panX: p - this.target.e,
            panY: f - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $1a1ba1ab2bb4f0ed$var$f.Destroy || this.state === $1a1ba1ab2bb4f0ed$var$f.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $1a1ba1ab2bb4f0ed$var$t(l) < $1a1ba1ab2bb4f0ed$var$t(r) && $1a1ba1ab2bb4f0ed$var$t(o) <= $1a1ba1ab2bb4f0ed$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $1a1ba1ab2bb4f0ed$var$t(l) > $1a1ba1ab2bb4f0ed$var$t(a) && $1a1ba1ab2bb4f0ed$var$t(o) >= $1a1ba1ab2bb4f0ed$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $1a1ba1ab2bb4f0ed$var$t(l) !== $1a1ba1ab2bb4f0ed$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($1a1ba1ab2bb4f0ed$var$t(this.contentRect.width, 1) < $1a1ba1ab2bb4f0ed$var$t(this.contentRect.fitWidth, 1) || $1a1ba1ab2bb4f0ed$var$t(this.targetScale) < $1a1ba1ab2bb4f0ed$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $1a1ba1ab2bb4f0ed$var$t(this.targetScale) > $1a1ba1ab2bb4f0ed$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $1a1ba1ab2bb4f0ed$var$z, originX: i = $1a1ba1ab2bb4f0ed$var$z, originY: n = $1a1ba1ab2bb4f0ed$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $1a1ba1ab2bb4f0ed$var$f.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $1a1ba1ab2bb4f0ed$var$O && (s = this.pmme || s), s || i === $1a1ba1ab2bb4f0ed$var$z || n === $1a1ba1ab2bb4f0ed$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let h = 1;
        "number" == typeof t ? h = t : "full" === t ? h = a : "cover" === t ? h = l : "max" === t ? h = r : "fit" === t ? h = 1 : "next" === t && (h = this.getNextScale("iterateZoom")), h = h / o || 1, e = e === $1a1ba1ab2bb4f0ed$var$z ? h > 1 ? .15 : .25 : e, this.applyChange({
            scale: h,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $1a1ba1ab2bb4f0ed$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $1a1ba1ab2bb4f0ed$var$f.Init && this.state !== $1a1ba1ab2bb4f0ed$var$f.Destroy) {
            this.stop("current");
            for (const t of $1a1ba1ab2bb4f0ed$var$m)this.target[t] = $1a1ba1ab2bb4f0ed$var$T[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $1a1ba1ab2bb4f0ed$var$f.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $1a1ba1ab2bb4f0ed$var$f.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($1a1ba1ab2bb4f0ed$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $1a1ba1ab2bb4f0ed$var$b
}), Object.defineProperty($1a1ba1ab2bb4f0ed$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $1a1ba1ab2bb4f0ed$var$C = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $1a1ba1ab2bb4f0ed$var$A = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $1a1ba1ab2bb4f0ed$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $1a1ba1ab2bb4f0ed$var$F;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($1a1ba1ab2bb4f0ed$var$F || ($1a1ba1ab2bb4f0ed$var$F = {}));
const $1a1ba1ab2bb4f0ed$var$I = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $1a1ba1ab2bb4f0ed$var$B = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $1a1ba1ab2bb4f0ed$var$H extends $1a1ba1ab2bb4f0ed$var$g {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $1a1ba1ab2bb4f0ed$var$N = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $1a1ba1ab2bb4f0ed$var$X extends $1a1ba1ab2bb4f0ed$var$H {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $1a1ba1ab2bb4f0ed$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $1a1ba1ab2bb4f0ed$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), o = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof o && e > 5 && e >= o, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($1a1ba1ab2bb4f0ed$var$s(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let h, c = 0;
        for (const e of [
            ...l.children
        ]){
            const i = c === this.instance.page;
            i && (h = e), $1a1ba1ab2bb4f0ed$var$s(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$1a1ba1ab2bb4f0ed$var$x(e, this.cn(t));
            c++;
        }
        if (h = h || l.firstChild, a && h) {
            const t = h.previousElementSibling, e = t && t.previousElementSibling;
            $1a1ba1ab2bb4f0ed$var$P(t, this.cn("isPrev")), $1a1ba1ab2bb4f0ed$var$P(e, this.cn("isBeforePrev"));
            const i = h.nextElementSibling, n = i && i.nextElementSibling;
            $1a1ba1ab2bb4f0ed$var$P(i, this.cn("isNext")), $1a1ba1ab2bb4f0ed$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const n = document.createElement("li");
        n.setAttribute("role", "presentation");
        const s = $1a1ba1ab2bb4f0ed$var$i(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return n.appendChild(s), null === (e = n.children[0]) || void 0 === e || e.setAttribute("role", "tab"), n;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $1a1ba1ab2bb4f0ed$var$x(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($1a1ba1ab2bb4f0ed$var$X, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $1a1ba1ab2bb4f0ed$var$N
});
const $1a1ba1ab2bb4f0ed$var$W = "disabled", $1a1ba1ab2bb4f0ed$var$Y = "next", $1a1ba1ab2bb4f0ed$var$$ = "prev";
class $1a1ba1ab2bb4f0ed$var$Z extends $1a1ba1ab2bb4f0ed$var$H {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($1a1ba1ab2bb4f0ed$var$W), s.removeAttribute($1a1ba1ab2bb4f0ed$var$W), t.isInfinite || (i <= 0 && n.setAttribute($1a1ba1ab2bb4f0ed$var$W, ""), i >= e - 1 && s.setAttribute($1a1ba1ab2bb4f0ed$var$W, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $1a1ba1ab2bb4f0ed$var$P(n, this.cn("button") + " " + this.cn(t === $1a1ba1ab2bb4f0ed$var$Y ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $1a1ba1ab2bb4f0ed$var$Y ? $1a1ba1ab2bb4f0ed$var$$ : $1a1ba1ab2bb4f0ed$var$Y : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $1a1ba1ab2bb4f0ed$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($1a1ba1ab2bb4f0ed$var$Y)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($1a1ba1ab2bb4f0ed$var$$)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($1a1ba1ab2bb4f0ed$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $1a1ba1ab2bb4f0ed$var$V extends $1a1ba1ab2bb4f0ed$var$H {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $1a1ba1ab2bb4f0ed$var$F.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $1a1ba1ab2bb4f0ed$var$F.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const h = parseInt(l.dataset.index || "", 10) || 0, c = r.getPageForSlide(h), d = a.getPageForSlide(h);
        a.slideTo(d), r.slideTo(c, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(h);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $1a1ba1ab2bb4f0ed$var$F.Ready || i.state !== $1a1ba1ab2bb4f0ed$var$F.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $1a1ba1ab2bb4f0ed$var$F.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($1a1ba1ab2bb4f0ed$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $1a1ba1ab2bb4f0ed$var$q = {
    Navigation: $1a1ba1ab2bb4f0ed$var$Z,
    Dots: $1a1ba1ab2bb4f0ed$var$X,
    Sync: $1a1ba1ab2bb4f0ed$var$V
}, $1a1ba1ab2bb4f0ed$var$_ = "animationend", $1a1ba1ab2bb4f0ed$var$G = "isSelected", $1a1ba1ab2bb4f0ed$var$U = "slide";
class $1a1ba1ab2bb4f0ed$export$144901db2ea8e967 extends $1a1ba1ab2bb4f0ed$var$p {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $1a1ba1ab2bb4f0ed$var$F.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $1a1ba1ab2bb4f0ed$var$F.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$1a1ba1ab2bb4f0ed$var$w(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $1a1ba1ab2bb4f0ed$var$C(this.slideNext.bind(this), 150), this.slidePrev = $1a1ba1ab2bb4f0ed$var$C(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $1a1ba1ab2bb4f0ed$var$d({}, $1a1ba1ab2bb4f0ed$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $1a1ba1ab2bb4f0ed$var$c(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $1a1ba1ab2bb4f0ed$var$c(e) && (n += t, $1a1ba1ab2bb4f0ed$var$d(i, e));
        n === this.bp && this.state !== $1a1ba1ab2bb4f0ed$var$F.Init || (this.bp = n, this.state === $1a1ba1ab2bb4f0ed$var$F.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $1a1ba1ab2bb4f0ed$var$F.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $1a1ba1ab2bb4f0ed$var$F.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $1a1ba1ab2bb4f0ed$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $1a1ba1ab2bb4f0ed$var$F.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $1a1ba1ab2bb4f0ed$var$P(t, this.cn("container")), $1a1ba1ab2bb4f0ed$var$s(t, e.isLTR, !this.isRTL), $1a1ba1ab2bb4f0ed$var$s(t, e.isRTL, this.isRTL), $1a1ba1ab2bb4f0ed$var$s(t, e.isVertical, !this.isHorizontal), $1a1ba1ab2bb4f0ed$var$s(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $1a1ba1ab2bb4f0ed$var$P(i, e.viewport), i.append(...$1a1ba1ab2bb4f0ed$var$A(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $1a1ba1ab2bb4f0ed$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$1a1ba1ab2bb4f0ed$var$A(t, `.${this.cn($1a1ba1ab2bb4f0ed$var$U)}`)
        ].forEach((t)=>{
            if ($1a1ba1ab2bb4f0ed$var$w(t)) {
                const e = $1a1ba1ab2bb4f0ed$var$I({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($1a1ba1ab2bb4f0ed$var$I(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $1a1ba1ab2bb4f0ed$export$b704d075ddd20210(this.viewport, $1a1ba1ab2bb4f0ed$var$d({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($1a1ba1ab2bb4f0ed$var$B()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $1a1ba1ab2bb4f0ed$var$t(e.pos, 1e3), e.dim = $1a1ba1ab2bb4f0ed$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let h;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            h && e.pos === h.pos ? (h.dim += e.dim, h.slides = [
                ...h.slides,
                ...e.slides
            ]) : (e.index = l.length, h = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $1a1ba1ab2bb4f0ed$var$P(r, this.cn($1a1ba1ab2bb4f0ed$var$U) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const h = getComputedStyle(r);
        return "content-box" === h.boxSizing && (this.isHorizontal ? (o += parseFloat(h.paddingLeft) || 0, o += parseFloat(h.paddingRight) || 0) : (o += parseFloat(h.paddingTop) || 0, o += parseFloat(h.paddingBottom) || 0)), a = parseFloat(h[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $1a1ba1ab2bb4f0ed$var$t(o, 1e3),
            gap: $1a1ba1ab2bb4f0ed$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: h, slides: c, panzoom: d } = this, u = 0, g = 0, p = 0, f = 0;
        d ? f = -1 * d.current[this.axis] : h[l] && (f = h[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (f *= -1);
        for (const i of c){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === g ? "" : `${$1a1ba1ab2bb4f0ed$var$t(g, 1e3)}px` : n.style[e] = "", p += i.dim + i.gap, u++) : g += i.dim + i.gap;
        }
        if (s && p && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", h = parseFloat(n[s + (i ? "Left" : "Top")]);
            f -= h, a += h, a += parseFloat(n[s + l]);
            for (const i of c)i.el && ($1a1ba1ab2bb4f0ed$var$t(i.pos) < $1a1ba1ab2bb4f0ed$var$t(a) && $1a1ba1ab2bb4f0ed$var$t(i.pos + i.dim + i.gap) < $1a1ba1ab2bb4f0ed$var$t(f) && $1a1ba1ab2bb4f0ed$var$t(f) > $1a1ba1ab2bb4f0ed$var$t(r - a) && (i.el.style[e] = `${$1a1ba1ab2bb4f0ed$var$t(g + p, 1e3)}px`), $1a1ba1ab2bb4f0ed$var$t(i.pos + i.gap) >= $1a1ba1ab2bb4f0ed$var$t(r - a) && $1a1ba1ab2bb4f0ed$var$t(i.pos) > $1a1ba1ab2bb4f0ed$var$t(f + a) && $1a1ba1ab2bb4f0ed$var$t(f) < $1a1ba1ab2bb4f0ed$var$t(a) && (i.el.style[e] = `-${$1a1ba1ab2bb4f0ed$var$t(p, 1e3)}px`));
        }
        let m, b, v = [
            ...this.inTransition
        ];
        if (v.length > 1 && (m = h[v[0]], b = h[v[1]]), m && b) {
            let i = 0;
            for (const n of c)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$1a1ba1ab2bb4f0ed$var$t(i + (m.pos - b.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $1a1ba1ab2bb4f0ed$var$P(n, this.cn($1a1ba1ab2bb4f0ed$var$U)), $1a1ba1ab2bb4f0ed$var$P(n, t.class), $1a1ba1ab2bb4f0ed$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($1a1ba1ab2bb4f0ed$var$G);
        if (i.classList.contains(n) && ($1a1ba1ab2bb4f0ed$var$x(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($1a1ba1ab2bb4f0ed$var$_);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const h = this.getPageFromIndex(t);
        if (!l || !r[h] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let c = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (c = -1), a === r.length - 1 && 0 === t && (c = 1));
        const d = r[h].pos * (this.isRTL ? 1 : -1);
        if (a === h && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $1a1ba1ab2bb4f0ed$var$P(this.container, this.cn("inTransition"));
        const g = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, p = (null === (o = r[h]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(p.index), this.createSlideEl(p);
        let f = g.el, m = p.el;
        u || e === $1a1ba1ab2bb4f0ed$var$U || (e = "fadeFast", f = null);
        const b = this.isRTL ? "next" : "prev", v = this.isRTL ? "prev" : "next";
        return f && (this.inTransition.add(g.index), g.transition = e, f.addEventListener($1a1ba1ab2bb4f0ed$var$_, this.onAnimationEnd), f.classList.add(`f-${e}Out`, `to-${c > 0 ? v : b}`)), m && (p.transition = e, m.addEventListener($1a1ba1ab2bb4f0ed$var$_, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${c > 0 ? b : v}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(h), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($1a1ba1ab2bb4f0ed$var$G);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($1a1ba1ab2bb4f0ed$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($1a1ba1ab2bb4f0ed$var$x(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, h = 0, c = .5 * s;
        n && e ? (r < -c && (h = -1, r += o), r > o - c && (h = 1, r -= o)) : (r > c && (h = 1, r -= o), r < -o + c && (h = -1, r += o)), h && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const n = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $1a1ba1ab2bb4f0ed$var$x(e, o), e.complete && ($1a1ba1ab2bb4f0ed$var$P(e, s), setTimeout(()=>{
                $1a1ba1ab2bb4f0ed$var$x(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (n.updateMetrics(), n.setViewportHeight()), this.emit("load", t));
        };
        $1a1ba1ab2bb4f0ed$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const n = e.parentNode;
            n && t.el && (e.complete ? l() : a || (r = $1a1ba1ab2bb4f0ed$var$i($1a1ba1ab2bb4f0ed$var$y), n.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, h = l.length, c = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = c > 45 && c < 135 ? a ? 0 : i : a ? e : 0, !h) return;
        let u = this.page, g = o && a ? 1 : -1;
        const p = t.current[r] * g;
        let { pageIndex: f } = this.getPageFromPosition(p);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = f), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : f, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $1a1ba1ab2bb4f0ed$var$w(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $1a1ba1ab2bb4f0ed$var$F.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $1a1ba1ab2bb4f0ed$var$F.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, h = r.length, c = a && o ? 1 : -1;
        if (!l || !h) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * c;
            if (2 === h) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= c, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $1a1ba1ab2bb4f0ed$var$x(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($1a1ba1ab2bb4f0ed$var$_, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, h = this.contentDim < this.viewportDim;
        let c = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of c)d.push($1a1ba1ab2bb4f0ed$var$I(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, c = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            h && 1 === n ? (t <= this.page && (a.current[this.axis] -= c, a.target[this.axis] -= c), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $1a1ba1ab2bb4f0ed$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let h, c = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && h ? (n = h.dim, o = h.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), h = i), n = $1a1ba1ab2bb4f0ed$var$t(n, 1e3), o = $1a1ba1ab2bb4f0ed$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = c, c += n, (a || e < s.length - 1) && (c += o);
        }
        c = $1a1ba1ab2bb4f0ed$var$t(c, 1e3), this.contentDim = c, e && (e.contentRect[r] = c, e.contentRect[o ? "fullWidth" : "fullHeight"] = c), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $1a1ba1ab2bb4f0ed$var$F.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, h = $1a1ba1ab2bb4f0ed$var$t((l - r.pos) / (1 * r.dim), 1e3), c = h, d = h;
        this.isInfinite && !0 !== n && (c = $1a1ba1ab2bb4f0ed$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $1a1ba1ab2bb4f0ed$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            h,
            c,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $1a1ba1ab2bb4f0ed$var$f.Init && n.state !== $1a1ba1ab2bb4f0ed$var$f.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const h = l - o * t, c = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < c && o > h && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], h = n[r - 1], c = this.option("center");
        let d = 0, u = 0, g = 0, p = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        c && (p += .5 * e), this.isInfinite ? (p < l.pos - .5 * h.gap && (p -= i, g = -1), p > h.pos + h.dim + .5 * h.gap && (p -= i, g = 1)) : p = Math.max(l.pos || 0, Math.min(p, h.pos));
        let f = h, m = n.find((t)=>{
            const e = t.pos - .5 * f.gap, i = t.pos + t.dim + .5 * t.gap;
            return f = t, p >= e && p < i;
        });
        return m || (m = h), u = this.getPageForSlide(m.index), d = u + g * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $1a1ba1ab2bb4f0ed$var$F.Destroy
        ].includes(this.state)) return;
        this.state = $1a1ba1ab2bb4f0ed$var$F.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($1a1ba1ab2bb4f0ed$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $1a1ba1ab2bb4f0ed$export$b704d075ddd20210
}), Object.defineProperty($1a1ba1ab2bb4f0ed$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $1a1ba1ab2bb4f0ed$var$j
}), Object.defineProperty($1a1ba1ab2bb4f0ed$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $1a1ba1ab2bb4f0ed$var$q
});


const $c8a9e35c9d263ba3$var$e = (t, ...s)=>{
    const n = s.length;
    for(let i = 0; i < n; i++){
        const n = s[i] || {};
        Object.entries(n).forEach(([s, n])=>{
            const i = Array.isArray(n) ? [] : {};
            var o;
            t[s] || Object.assign(t, {
                [s]: i
            }), "object" == typeof (o = n) && null !== o && o.constructor === Object && "[object Object]" === Object.prototype.toString.call(o) ? Object.assign(t[s], $c8a9e35c9d263ba3$var$e(i, n)) : Array.isArray(n) ? Object.assign(t, {
                [s]: [
                    ...n
                ]
            }) : Object.assign(t, {
                [s]: n
            });
        });
    }
    return t;
}, $c8a9e35c9d263ba3$var$t = function(e, t) {
    return e.split(".").reduce((e, t)=>"object" == typeof e ? e[t] : void 0, t);
};
class $c8a9e35c9d263ba3$var$s {
    constructor(e = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(e);
        for (const e of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))e.startsWith("on") && "function" == typeof this[e] && (this[e] = this[e].bind(this));
    }
    setOptions(t) {
        this.options = t ? $c8a9e35c9d263ba3$var$e({}, this.constructor.defaults, t) : {};
        for (const [e, t] of Object.entries(this.option("on") || {}))this.on(e, t);
    }
    option(e, ...s) {
        let n = $c8a9e35c9d263ba3$var$t(e, this.options);
        return n && "function" == typeof n && (n = n.call(this, this, ...s)), n;
    }
    optionFor(e, s, n, ...i) {
        let o = $c8a9e35c9d263ba3$var$t(s, e);
        var r;
        "string" != typeof (r = o) || isNaN(r) || isNaN(parseFloat(r)) || (o = parseFloat(o)), "true" === o && (o = !0), "false" === o && (o = !1), o && "function" == typeof o && (o = o.call(this, this, e, ...i));
        let a = $c8a9e35c9d263ba3$var$t(s, this.options);
        return a && "function" == typeof a ? o = a.call(this, this, e, ...i, o) : void 0 === o && (o = a), void 0 === o ? n : o;
    }
    cn(e) {
        const t = this.options.classes;
        return t && t[e] || "";
    }
    localize(e, t = []) {
        e = String(e).replace(/\{\{(\w+).?(\w+)?\}\}/g, (e, t, s)=>{
            let n = "";
            return s ? n = this.option(`${t[0] + t.toLowerCase().substring(1)}.l10n.${s}`) : t && (n = this.option(`l10n.${t}`)), n || (n = e), n;
        });
        for(let s = 0; s < t.length; s++)e = e.split(t[s][0]).join(t[s][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    on(e, t) {
        let s = [];
        "string" == typeof e ? s = e.split(" ") : Array.isArray(e) && (s = e), this.events || (this.events = new Map), s.forEach((e)=>{
            let s = this.events.get(e);
            s || (this.events.set(e, []), s = []), s.includes(t) || s.push(t), this.events.set(e, s);
        });
    }
    off(e, t) {
        let s = [];
        "string" == typeof e ? s = e.split(" ") : Array.isArray(e) && (s = e), s.forEach((e)=>{
            const s = this.events.get(e);
            if (Array.isArray(s)) {
                const e = s.indexOf(t);
                e > -1 && s.splice(e, 1);
            }
        });
    }
    emit(e, ...t) {
        [
            ...this.events.get(e) || []
        ].forEach((e)=>e(this, ...t)), "*" !== e && this.emit("*", e, ...t);
    }
}
Object.defineProperty($c8a9e35c9d263ba3$var$s, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($c8a9e35c9d263ba3$var$s, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $c8a9e35c9d263ba3$var$n extends $c8a9e35c9d263ba3$var$s {
    constructor(e, t){
        super(t), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: e
        });
    }
    attach() {}
    detach() {}
}
const $c8a9e35c9d263ba3$var$i = (e)=>`${e || ""}`.split(" ").filter((e)=>!!e), $c8a9e35c9d263ba3$var$o = (e, t)=>{
    e && $c8a9e35c9d263ba3$var$i(t).forEach((t)=>{
        e.classList.add(t);
    });
}, $c8a9e35c9d263ba3$var$r = "play", $c8a9e35c9d263ba3$var$a = "pause", $c8a9e35c9d263ba3$var$l = "ready";
class $c8a9e35c9d263ba3$export$6c96167f46662e38 extends $c8a9e35c9d263ba3$var$n {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $c8a9e35c9d263ba3$var$l
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $c8a9e35c9d263ba3$var$l;
    }
    onReady(e) {
        this.option("autoStart") && (e.isInfinite || e.page < e.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var e;
        this.inHover = !1, (null === (e = this.instance.panzoom) || void 0 === e ? void 0 : e.isResting) && this.resume();
    }
    onTimerEnd() {
        const e = this.instance;
        "play" === this.state && (e.isInfinite || e.page !== e.pages.length - 1 ? e.slideNext() : e.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var e;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const t = this.instance, s = (null === (e = t.pages[t.page]) || void 0 === e ? void 0 : e.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === s.length ? s[0].el : null) || t.viewport), !n) return null;
        const i = document.createElement("div");
        return $c8a9e35c9d263ba3$var$o(i, "f-progress"), n.prepend(i), this.progressBar = i, i.offsetHeight, i;
    }
    set() {
        const e = this, t = e.instance;
        if (t.pages.length < 2) return;
        if (e.timer) return;
        const s = e.option("timeout");
        e.state = $c8a9e35c9d263ba3$var$r, $c8a9e35c9d263ba3$var$o(t.container, "has-autoplay");
        let n = e.createProgressBar();
        n && (n.style.transitionDuration = `${s}ms`, n.style.transform = "scaleX(1)"), e.timer = setTimeout(()=>{
            e.timer = null, e.inHover || e.onTimerEnd();
        }, s), e.emit("set");
    }
    clear() {
        const e = this;
        e.timer && (clearTimeout(e.timer), e.timer = null), e.removeProgressBar();
    }
    start() {
        const e = this;
        if (e.set(), e.state !== $c8a9e35c9d263ba3$var$l) {
            if (e.option("pauseOnHover")) {
                const t = e.instance.container;
                t.addEventListener("mouseenter", e.onMouseEnter, !1), t.addEventListener("mouseleave", e.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", e.onVisibilityChange, !1), e.emit("start");
        }
    }
    stop() {
        const e = this, t = e.state, s = e.instance.container;
        var n, o;
        e.clear(), e.state = $c8a9e35c9d263ba3$var$l, s.removeEventListener("mouseenter", e.onMouseEnter, !1), s.removeEventListener("mouseleave", e.onMouseLeave, !1), document.removeEventListener("visibilitychange", e.onVisibilityChange, !1), o = "has-autoplay", (n = s) && $c8a9e35c9d263ba3$var$i(o).forEach((e)=>{
            n.classList.remove(e);
        }), t !== $c8a9e35c9d263ba3$var$l && e.emit("stop");
    }
    pause() {
        const e = this;
        e.state === $c8a9e35c9d263ba3$var$r && (e.state = $c8a9e35c9d263ba3$var$a, e.clear(), e.emit($c8a9e35c9d263ba3$var$a));
    }
    resume() {
        const e = this, t = e.instance;
        if (t.isInfinite || t.page !== t.pages.length - 1) {
            if (e.state !== $c8a9e35c9d263ba3$var$r) {
                if (e.state === $c8a9e35c9d263ba3$var$a && !e.inHover) {
                    const t = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    e.emit("resume", t), t.defaultPrevented || e.set();
                }
            } else e.set();
        } else e.stop();
    }
    toggle() {
        this.state === $c8a9e35c9d263ba3$var$r || this.state === $c8a9e35c9d263ba3$var$a ? this.stop() : this.start();
    }
    attach() {
        const e = this, t = e.instance;
        t.on("ready", e.onReady), t.on("Panzoom.startAnimation", e.onChange), t.on("Panzoom.endAnimation", e.onSettle), t.on("Panzoom.touchMove", e.onChange);
    }
    detach() {
        const e = this, t = e.instance;
        t.off("ready", e.onReady), t.off("Panzoom.startAnimation", e.onChange), t.off("Panzoom.endAnimation", e.onSettle), t.off("Panzoom.touchMove", e.onChange), e.stop();
    }
}
Object.defineProperty($c8a9e35c9d263ba3$export$6c96167f46662e38, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});




(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="slider"]', {
    init () {
        this.id = this.element.id;
        this.options = {
            infinite: true,
            Dots: this.element.hasAttribute("data-dots"),
            Navigation: false,
            Autoplay: {
                autoStart: this.element.getAttribute("data-autoplay"),
                timeout: 1000 * this.element.getAttribute("data-autoplay") || 3000
            }
        };
        this.$slider = this.element.querySelector("[data-slider]");
        this.$prev = this.element.querySelector("[data-previous]");
        this.$next = this.element.querySelector("[data-next]");
        this.slider = new (0, $1a1ba1ab2bb4f0ed$export$144901db2ea8e967)(this.$slider, this.options, {
            Autoplay: $c8a9e35c9d263ba3$export$6c96167f46662e38
        });
    },
    connected () {
        if (this.$prev) this.$prev.addEventListener("click", ()=>this.slider.slidePrev());
        if (this.$next) this.$next.addEventListener("click", ()=>this.slider.slideNext());
    },
    disconnected () {
        this.slider.destroy();
    },
    handleCaption () {}
});



var $a05e1d2f7f75ff3e$exports = {};

var $6HmnW = parcelRequire("6HmnW");
$a05e1d2f7f75ff3e$exports = $a05e1d2f7f75ff3e$var$onIntersect;
function $a05e1d2f7f75ff3e$var$onIntersect(el, opts, onEnter, onExit) {
    $6HmnW.ok(typeof window !== "undefined", "on-intersect: window did not exist. Are you calling this in the browser?");
    $6HmnW.equal(typeof el, "object", "on-intersect: el should be a valid DOM node");
    if (typeof opts === "function") {
        onExit = onEnter;
        onEnter = opts;
        opts = {};
    }
    $6HmnW.ok(onEnter || onExit, "on-intersect: must have at least one listener");
    onEnter = onEnter || $a05e1d2f7f75ff3e$var$noop;
    onExit = onExit || $a05e1d2f7f75ff3e$var$noop;
    $6HmnW.equal(typeof opts, "object", "on-intersect: opts should be type object");
    $6HmnW.equal(typeof onEnter, "function", "on-intersect: onEnter should be type function");
    $6HmnW.equal(typeof onExit, "function", "on-intersect: onExit should be type function");
    var wasCalled = false;
    var observer = new window.IntersectionObserver(handler, opts);
    observer.observe(el);
    return function() {
        observer.disconnect();
    };
    function handler(entries, obs) {
        var entry = entries[0];
        // This covers subtle edge cases where the intersection value is 0.
        // See: https://github.com/yoshuawuyts/on-intersect/issues/2
        var isNotIntersecting = typeof entry.isIntersecting === "boolean" ? !entry.isIntersecting : entry.intersectionRatio === 0;
        if (isNotIntersecting) // Make sure it's not called immediately when loaded.
        {
            if (wasCalled) onExit(entry);
        } else onEnter(entry);
        wasCalled = true;
    }
}
function $a05e1d2f7f75ff3e$var$noop() {}


(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="ultralazy"]', {
    init () {
        this.state = {};
        this.options = {
            ...this.element.dataset
        };
        this.onEnter = this.onEnter.bind(this);
        this.onLoad = this.onLoad.bind(this);
    },
    connected () {
        if (!this.options.manual) this.stopObserving = (0, (/*@__PURE__*/$parcel$interopDefault($a05e1d2f7f75ff3e$exports)))(this.element, {}, this.onEnter);
    },
    disconnected () {
        if (!this.options.manual) this.stopObserving();
    },
    onEnter (e) {
        this.loadImg();
        this.stopObserving();
    },
    loadImg () {
        this.element.classList.replace("lazyload", "lazyloading");
        const newSrcset = this.element.dataset.srcset;
        if (newSrcset) {
            if (this.element.dataset.sizes === "auto" && this.element.offsetWidth) this.element.sizes = `${this.element.offsetWidth}px`;
            this.element.srcset = newSrcset;
        }
        const newSrc = this.element.dataset.src;
        if (newSrc) this.element.src = newSrc;
    },
    onLoad () {
        if (this.element.classList.contains("lazyloading")) this.element.classList.replace("lazyloading", "lazyloaded");
    },
    onTriggerLoad () {
        const classList = this.element.classList;
        if (!classList.contains("lazyloading") && !classList.contains("lazyloaded")) this.loadImg();
    }
});



(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component="page-filter"]', {
    onChange () {
        window.GPLA_APP.go(this.element.value);
    }
});



(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component="page-toggle"]', {
    init () {
        this.$input = this.element.querySelector("input");
    },
    onChange () {
        console.log("onChange", this.$input.checked);
    // alert(this.$input.checked)
    // window.GPLA_APP.go(this.element.value)
    }
});



function $10f3b8d4eeecf51e$export$806d9a98fb0e6fd0(el, fn, options) {
    $10f3b8d4eeecf51e$var$ensureTabIndex(el);
    if ((options == null ? void 0 : options.focus) !== false) el.focus();
    const handler = $10f3b8d4eeecf51e$export$2f73f1395d62b6d4(fn);
    el.addEventListener("focusout", handler);
    return ()=>el.removeEventListener("focusout", handler);
}
function $10f3b8d4eeecf51e$export$2f73f1395d62b6d4(fn) {
    return (event)=>{
        const evt = event;
        if (!$10f3b8d4eeecf51e$var$focusLost(evt)) return;
        fn(evt.relatedTarget, evt);
    };
}
function $10f3b8d4eeecf51e$var$ensureTabIndex(el) {
    if (el.getAttribute("tabindex") === null) el.tabIndex = -1;
}
function $10f3b8d4eeecf51e$var$focusLost(event) {
    const { currentTarget: currentTarget, relatedTarget: relatedTarget } = event;
    if (!currentTarget) return false;
    if (!relatedTarget) return true;
    return currentTarget !== relatedTarget && !currentTarget.contains(relatedTarget);
}


(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component="navigation"]', {
    init () {
        this.$navMobile = this.element.querySelector("[data-nav-mobile]");
        this.$navToggle = this.element.querySelector("[data-nav-toggle]");
        this.$navMobileLinks = this.$navMobile.querySelector("ul");
        this.handleNavClick = this.handleNavClick.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.clickOutside = null;
    },
    connected () {
        this.$navToggle.addEventListener("click", this.handleNavClick);
        this.clickOutside = (0, $10f3b8d4eeecf51e$export$806d9a98fb0e6fd0)(this.element, this.handleClickOutside);
    },
    disconnected () {
        this.$navToggle.removeEventListener("click", this.handleNavClick);
        this.clickOutside();
    },
    handleNavClick () {
        if (this.$navMobile.classList.contains("nav-open")) {
            this.$navMobile.classList.remove("nav-open");
            this.$navMobileLinks.classList.add("hidden");
            this.$navMobileLinks.classList.remove("flex");
        } else {
            this.$navMobile.classList.add("nav-open");
            this.$navMobileLinks.classList.remove("hidden");
            this.$navMobileLinks.classList.add("flex");
        }
    },
    handleClickOutside (e) {
        this.$navMobile.classList.remove("nav-open");
        this.$navMobileLinks.classList.add("hidden");
        this.$navMobileLinks.classList.remove("flex");
    }
});


var $98045da6d83a0e2c$exports = {};

$parcel$export($98045da6d83a0e2c$exports, "balanceText", function () { return $98045da6d83a0e2c$export$fe7e2289b41760c9; }, function (v) { return $98045da6d83a0e2c$export$fe7e2289b41760c9 = v; });
/**
 * Modified version of NYT text balancer script
 * that allows tearing down the listeners for cleanup
 */ var $98045da6d83a0e2c$export$fe7e2289b41760c9;
var $98045da6d83a0e2c$var$candidates = [];
// pass in a string of selectors to be balanced.
// if you didnt specify any, thats ok! We'll just
// balance anything with the balance-text class
var $98045da6d83a0e2c$var$textBalancer = function(selectors) {
    if (!selectors) $98045da6d83a0e2c$var$candidates = document.querySelectorAll(".balance-text");
    else $98045da6d83a0e2c$var$createSelectors(selectors);
    $98045da6d83a0e2c$var$balanceText();
    var rebalanceText = $98045da6d83a0e2c$var$debounce(function() {
        $98045da6d83a0e2c$var$balanceText();
    }, 100);
    window.addEventListener("resize", rebalanceText);
    function destroy() {
        $98045da6d83a0e2c$var$candidates = [];
        window.removeEventListener("resize", rebalanceText);
    }
    return {
        destroy: destroy
    };
};
// this populates our candidates array with dom objects
// that need to be balanced
var $98045da6d83a0e2c$var$createSelectors = function(selectors) {
    selectorArray = selectors.split(",");
    for(var i = 0; i < selectorArray.length; i += 1){
        var currentSelectorElements = document.querySelectorAll(selectorArray[i].trim());
        for(var j = 0; j < currentSelectorElements.length; j += 1){
            var currentSelectorElement = currentSelectorElements[j];
            $98045da6d83a0e2c$var$candidates.push(currentSelectorElement);
        }
    }
};
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
var $98045da6d83a0e2c$var$debounce = function(func, wait, immediate) {
    var timeout;
    return function() {
        var context = this, args = arguments;
        var later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
// HELPER FUNCTION -- initializes recursive binary search
var $98045da6d83a0e2c$var$balanceText = function() {
    var element;
    var i;
    for(i = 0; i < $98045da6d83a0e2c$var$candidates.length; i += 1){
        element = $98045da6d83a0e2c$var$candidates[i];
        if ($98045da6d83a0e2c$var$textElementIsMultipleLines(element)) {
            element.style.maxWidth = "";
            $98045da6d83a0e2c$var$squeezeContainer(element, element.clientHeight, 0, element.clientWidth);
        }
    }
};
// Make the element as narrow as possible while maintaining its current height (number of lines). Binary search.
var $98045da6d83a0e2c$var$squeezeContainer = function(element, originalHeight, bottomRange, topRange) {
    var mid;
    if (bottomRange >= topRange) {
        element.style.maxWidth = topRange + "px";
        return;
    }
    mid = (bottomRange + topRange) / 2;
    element.style.maxWidth = mid + "px";
    if (element.clientHeight > originalHeight) // we've squoze too far and element has spilled onto an additional line; recurse on wider range
    $98045da6d83a0e2c$var$squeezeContainer(element, originalHeight, mid + 1, topRange);
    else // element has not wrapped to another line; keep squeezing!
    $98045da6d83a0e2c$var$squeezeContainer(element, originalHeight, bottomRange + 1, mid);
};
// function to see if a headline is multiple lines
// we only want to break if the headline is multiple lines
//
// We achieve this by turning the first word into a span
// and then we compare the height of that span to the height
// of the entire headline. If the headline is bigger than the
// span by 10px we balance the headline.
var $98045da6d83a0e2c$var$textElementIsMultipleLines = function(element) {
    var firstWordHeight;
    var elementHeight;
    var HEIGHT_OFFSET;
    var elementWords;
    var firstWord;
    var ORIGINAL_ELEMENT_TEXT;
    ORIGINAL_ELEMENT_TEXT = element.innerHTML;
    // usually there is around a 5px discrepency between
    // the first word and the height of the whole headline
    // so subtract the height of the headline by 10 px and
    // we should be good
    HEIGHT_OFFSET = 10;
    // get all the words in the headline as
    // an array -- will include punctuation
    //
    // this is used to put the headline back together
    elementWords = element.innerHTML.split(" ");
    // make span for first word and give it an id
    // so we can access it in le dom
    firstWord = document.createElement("span");
    firstWord.id = "element-first-word";
    firstWord.innerHTML = elementWords[0];
    // this is the entire headline
    // as an array except for first word
    //
    // we will append it to the headline after the span
    elementWords = elementWords.slice(1);
    // empty the headline and append the span to it
    element.innerHTML = "";
    element.appendChild(firstWord);
    // add the rest of the element back to it
    element.innerHTML += " " + elementWords.join(" ");
    // update the first word variable in the dom
    firstWord = document.getElementById("element-first-word");
    firstWordHeight = firstWord.offsetHeight;
    elementHeight = element.offsetHeight;
    // restore the original element text
    element.innerHTML = ORIGINAL_ELEMENT_TEXT;
    // compare the height of the element and the height of the first word
    return elementHeight - HEIGHT_OFFSET > firstWordHeight;
} // end headlineIsMultipleLines
;
$98045da6d83a0e2c$export$fe7e2289b41760c9 = $98045da6d83a0e2c$var$textBalancer;


var $4e844a93918b5e3a$var$balancer = (0, (/*@__PURE__*/$parcel$interopDefault($98045da6d83a0e2c$exports))).balanceText('[data-component~="balancer"]');
window.GPLA_APP.on("after", ()=>{
    if ($4e844a93918b5e3a$var$balancer) $4e844a93918b5e3a$var$balancer.destroy();
    $4e844a93918b5e3a$var$balancer = (0, (/*@__PURE__*/$parcel$interopDefault($98045da6d83a0e2c$exports))).balanceText('[data-component~="balancer"]');
});



var $4a25811ab293d597$exports = {};
"use strict";
Object.defineProperty($4a25811ab293d597$exports, "__esModule", {
    value: true
});
$4a25811ab293d597$exports["default"] = $4a25811ab293d597$var$typographicQuotes;
function $4a25811ab293d597$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $f406d379d7fc2e52$exports = {};
// Quotes              https://en.wikipedia.org/wiki/Quotation_mark
// Language codes:     https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
$f406d379d7fc2e52$exports = {
    "af": "\u201C\u201D\u2018\u2019",
    "sq": "\u201E\u201C\u2018\u2019",
    "az": "\xab\xbb\u2039\u203A",
    "eu": "\xab\xbb\u2039\u203A",
    "be": "\xab\xbb\u201C\u201D",
    "bg": "\u201E\u201C\u2019\u2019",
    "ca": "\xab\xbb\u201C\u201D",
    "zh-Hans": "\u201C\u201D\u2018\u2019",
    "hr": "\u201E\u201D\u2018\u2019",
    "cs": "\u201E\u201C\u201A\u2018",
    "da": "\xbb\xab\u203A\u2039",
    "nl": "\u2018\u2019\u201C\u201D",
    "en-uk": "\u2018\u2019\u201C\u201D",
    "en-us": "\u201C\u201D\u2018\u2019",
    "eo": "\u201C\u201D\u2018\u2019",
    "et": "\u201E\u201C\xab\xbb",
    "fil": "\u201C\u201D\u2018\u2019",
    "fi": "\u201D\u201D\u2019\u2019",
    "fr": "\xab\xbb\u201C\u201D",
    "fr-sw": "\xab\xbb\u2039\u203A",
    "ka": "\u201E\u201C\u201C\u201D",
    "de": "\u201E\u201C\u201A\u2018",
    "de-sw": "\xab\xbb\u2039\u203A",
    "el": "\xab\xbb\u201C\u201D",
    "he": "\"\"''",
    "hu": "\u201E\u201D\xbb\xab",
    "is": "\u201E\u201C\u201A\u2018",
    "id": "\u201C\u201D\u2018\u2019",
    "ga": "\u201C\u201D\u2018\u2019",
    "it": "\xab\xbb\u201C\u201D",
    "it-sw": "\xab\xbb\u2039\u203A",
    "ko": "\u201C\u201D\u2018\u2019",
    "lv": "\xab\xbb\u201E\u201C",
    "mk": "\u201E\u201C\u2019\u2018",
    "no": "\xab\xbb\u2019\u2019",
    "pl": "\u201E\u201D\xab\xbb",
    "pt-br": "\u201C\u201D\u2018\u2019",
    "pt-pl": "\xab\xbb\u201C\u201D",
    "ro": "\u201E\u201D\xab\xbb",
    "ru": "\xab\xbb\u201E\u201C",
    "sr": "\u201E\u201D\u2019\u2019",
    "sk": "\u201E\u201C\u201A\u2018",
    "sl": "\u201E\u201C\u201A\u2018",
    "es": "\xab\xbb\u201C\u201D",
    "sv": "\u201D\u201D\u2019\u2019",
    "th": "\u201C\u201D\u2018\u2019",
    "tr": "\u201C\u201D\u2018\u2019",
    "uk": "\xab\xbb\u201E\u201C",
    "cy": "\u2018\u2019\u201C\u201D" // Welsh
};


var $4a25811ab293d597$var$_typographicQuotesL10nDb2 = $4a25811ab293d597$var$_interopRequireDefault($f406d379d7fc2e52$exports);
function $4a25811ab293d597$var$typographicQuotes() {
    var input = arguments.length <= 0 || arguments[0] === undefined ? "" : arguments[0];
    var _ref = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
    var locale = _ref.locale;
    if (Object.keys($4a25811ab293d597$var$_typographicQuotesL10nDb2["default"]).indexOf(locale) === -1) return input;
    var localeQuotes = $4a25811ab293d597$var$_typographicQuotesL10nDb2["default"][locale];
    var separator = "";
    var pattern = /(^|\s)(?:"(.*?)"|'(.*?)')(\s|$|\.|,|\?|!)/gim;
    var handleQuotes = function handleQuotes(quotes, cb) {
        return function(match) {
            var before = arguments.length <= 1 || arguments[1] === undefined ? "" : arguments[1];
            var part1 = arguments.length <= 2 || arguments[2] === undefined ? "" : arguments[2];
            var part2 = arguments.length <= 3 || arguments[3] === undefined ? "" : arguments[3];
            var after = arguments.length <= 4 || arguments[4] === undefined ? "" : arguments[4];
            var text = part1 + part2;
            if (cb) text = text.replace(pattern, cb);
            if (locale === "fr") separator = "\xa0";
            return "" + before + quotes[0] + separator + text + separator + quotes[1] + after;
        };
    };
    return input.replace(pattern, handleQuotes(localeQuotes.slice(0, 2), handleQuotes(localeQuotes.slice(2, 4))));
}
$4a25811ab293d597$exports = $4a25811ab293d597$exports["default"];


var $943c7259ecb45427$exports = {};
"use strict";
$943c7259ecb45427$exports = function(input) {
    return input.replace(/ 'n' /gim, " \u2019n\u2019 ").replace(/'n'/gim, "\u2019n\u2019").replace(/(\S)'(\S)/gim, "$1\u2019$2").replace(/'(\d0s)/gim, "\u2019$1");
};


var $7a548a75532813b0$exports = {};
"use strict";
$7a548a75532813b0$exports = function(input) {
    return input.replace(/s'(\s|$)/gim, "s\u2019$1");
};


(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)("[data-typography]", {
    init () {
        this.element.textContent = (0, (/*@__PURE__*/$parcel$interopDefault($7a548a75532813b0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($4a25811ab293d597$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($943c7259ecb45427$exports)))(this.element.textContent)));
    }
});



var $dd3e7e5899799b71$var$e = 0;
function $dd3e7e5899799b71$export$2e2bcd8739ae039(n, t, o) {
    if (!n || !t) throw new Error("astrochimp requires both a URL and a data object");
    var r = document.createElement("script"), c = "__astrochimp" + $dd3e7e5899799b71$var$e++;
    function u() {
        window[c] = function() {}, document.head.removeChild(r);
    }
    return r.src = (n + "&" + function(e) {
        for(var n = Object.keys(e), t = [], o = 0; o < n.length; o++)t.push(encodeURIComponent(n[o]) + "=" + encodeURIComponent(e[n[o]]));
        return t.join("&");
    }(t) + "&c=" + c).replace(/post\?u=/, "post-json?u="), window[c] = function(e) {
        if (/[0-9]\s-/.test(e.msg) || "error" === e.result) return o(e, null);
        o(null, e), u();
    }, document.head.appendChild(r), function() {
        u();
    };
}


(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="mailchimp"]', {
    init () {
        this.$form = this.element.querySelector("form");
        this.$error = this.element.querySelector("[data-error]");
        this.$success = this.element.querySelector("[data-success]");
        this.resetTimeout = null;
        this.handleSubmit = this.handleSubmit.bind(this);
    },
    connected () {
        this.$form.addEventListener("submit", this.handleSubmit);
    },
    disconnected () {
        this.$form.removeEventListener("submit", this.handleSubmit);
        clearTimeout(this.resetTimeout);
    },
    async handleSubmit (e) {
        e.preventDefault();
        const formData = new FormData(this.$form);
        const data = Object.fromEntries(formData);
        (0, $dd3e7e5899799b71$export$2e2bcd8739ae039)(this.$form.action, data, (err, data)=>{
            this.$error.innerHTML = "";
            this.$success.innerHTML = "";
            err?.msg && (this.$error.innerHTML = err?.msg.replace("0 - ", ""));
            if (data?.msg) {
                this.$success.innerHTML = data?.msg;
                this.resetTimeout = setTimeout(()=>{
                    this.$form.reset();
                    this.$success.innerHTML = "";
                }, 5000);
            }
        });
    }
});



/**
 * Checks if cookie exists, removes if not
 */ (0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="cookie-banner"]', {
    init () {
        this.button = this.element.querySelector("button");
        if (-1 !== document.cookie.indexOf("cookie-note=1")) this.element.style.display = "none";
        else this.element.style.display = "flex";
        this.close = this.close.bind(this);
    },
    connected () {
        this.button.addEventListener("click", this.close);
    },
    disconnected () {
        this.button.removeEventListener("click", this.close);
    },
    close () {
        document.cookie = "cookie-note=1;path=/;max-age=864000";
        this.element.style.display = "none";
    }
});



/**
 * Replaces image with iframe on click
 */ (0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="video-switcher"]', {
    init () {
        this.imageElement = this.element.querySelector("img");
        this.templateElement = this.element.querySelector("template");
        this.swap = this.swap.bind(this);
    },
    connected () {
        this.imageElement.addEventListener("click", this.swap);
    },
    disconnected () {
        if (this.imageElement) this.imageElement.removeEventListener("click", this.swap);
    },
    swap () {
        this.imageElement.removeEventListener("click", this.swap);
        let iframe = this.templateElement.content.querySelector("iframe");
        if (iframe) this.element.appendChild(iframe);
        this.element.classList.add("played");
    }
});



class $21810d62a578f318$export$2e2bcd8739ae039 {
    constructor(element){
        this.element = element;
        this.items = [
            ...this.element.children
        ];
        this.render = this.render.bind(this);
        this.observer = new ResizeObserver(this.render);
    }
    observe() {
        this.render();
        this.observer.observe(this.element);
    }
    unobserve() {
        this.observer.disconnect();
    }
    clear() {
        this.items.forEach((item)=>item.style.transform = "");
    }
    getRows(items) {
        return items.reduce((obj, item)=>{
            if (!!item.offsetWidth) {
                if (!obj[item.offsetTop]) obj[item.offsetTop] = [];
                obj[item.offsetTop].push(item);
            }
            return obj;
        }, {});
    }
    getElementRight(element, withPadding = true) {
        let paddingRight = 0;
        if (!withPadding) {
            const computedStyles = window.getComputedStyle(element);
            paddingRight = parseInt(computedStyles.getPropertyValue("padding-right"), 10);
        }
        const rect = element.getBoundingClientRect();
        return rect.left + rect.width - paddingRight;
    }
    isAutoColumn(element) {
        const computedStyles = window.getComputedStyle(element);
        const columnStart = computedStyles.getPropertyValue("grid-column-start");
        return columnStart.indexOf("span") >= 0 || columnStart.indexOf("auto") >= 0;
    }
    sort(elements) {
        return elements.slice().sort((a, b)=>{
            return a.offsetLeft - b.offsetLeft;
        });
    }
    render() {
        this.clear();
        const gridRight = this.getElementRight(this.element, false);
        const rows = this.getRows(this.items);
        Object.keys(rows).forEach((key)=>{
            const row = this.sort(rows[key]);
            const [lastItem] = row.slice(-1);
            const [firstItem] = row.slice(0);
            const lastItemRight = this.getElementRight(lastItem);
            const isAutoColumn = this.isAutoColumn(firstItem);
            const shouldNudge = isAutoColumn && Math.abs(gridRight - lastItemRight) > 3;
            if (shouldNudge) {
                const offset = (gridRight - lastItemRight) / 2;
                row.forEach((item)=>item.style.transform = `translateX(${offset}px)`);
            }
        });
    }
}


(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="monogrid"]', {
    init () {
        this.grid = new (0, $21810d62a578f318$export$2e2bcd8739ae039)(this.element);
    },
    connected () {
        this.grid.observe();
    },
    disconnected () {
        this.grid.unobserve();
    }
});



var $8d6e5cc4100c0a2f$exports = {};
"use strict";
var $4af0ce7007c1045e$exports = {};
"use strict";

var $ckZZt = parcelRequire("ckZZt");

var $9nLII = parcelRequire("9nLII");

var $49sJb = parcelRequire("49sJb");

var $1B01c = parcelRequire("1B01c");
var $1e5f86523ec3c2c1$exports = {};
"use strict";

var $ckZZt = parcelRequire("ckZZt");

var $1B01c = parcelRequire("1B01c");
$1e5f86523ec3c2c1$exports = function shimAssign() {
    var polyfill = $1B01c();
    $ckZZt(Object, {
        assign: polyfill
    }, {
        assign: function() {
            return Object.assign !== polyfill;
        }
    });
    return polyfill;
};


var $4af0ce7007c1045e$var$polyfill = $9nLII.apply($1B01c());
// eslint-disable-next-line no-unused-vars
var $4af0ce7007c1045e$var$bound = function assign(target, source1) {
    return $4af0ce7007c1045e$var$polyfill(Object, arguments);
};
$ckZZt($4af0ce7007c1045e$var$bound, {
    getPolyfill: $1B01c,
    implementation: $49sJb,
    shim: $1e5f86523ec3c2c1$exports
});
$4af0ce7007c1045e$exports = $4af0ce7007c1045e$var$bound;



var $6YhGh = parcelRequire("6YhGh");
var $907d80f57f41ee3b$exports = {};
"use strict";

var $ckZZt = parcelRequire("ckZZt");

var $9nLII = parcelRequire("9nLII");
var $010e39d97664ff21$exports = {};
"use strict";
var $67b35136f3b694b6$exports = {};
"use strict";

var $64sl3 = parcelRequire("64sl3");

var $67b35136f3b694b6$var$hasDescriptors = (parcelRequire("juqCy"))();

var $67b35136f3b694b6$var$functionsHaveConfigurableNames = (parcelRequire("iabXK")).functionsHaveConfigurableNames();

var $gIo8M = parcelRequire("gIo8M");
/** @type {import('.')} */ $67b35136f3b694b6$exports = function setFunctionName(fn, name) {
    if (typeof fn !== "function") throw new $gIo8M("`fn` is not a function");
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $67b35136f3b694b6$var$functionsHaveConfigurableNames) {
        if ($67b35136f3b694b6$var$hasDescriptors) $64sl3(/** @type {Parameters<define>[0]} */ fn, "name", name, true, true);
        else $64sl3(/** @type {Parameters<define>[0]} */ fn, "name", name);
    }
    return fn;
};



var $gIo8M = parcelRequire("gIo8M");
var $010e39d97664ff21$var$$Object = Object;
$010e39d97664ff21$exports = $67b35136f3b694b6$exports(function flags() {
    if (this == null || this !== $010e39d97664ff21$var$$Object(this)) throw new $gIo8M("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.hasIndices) result += "d";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.unicodeSets) result += "v";
    if (this.sticky) result += "y";
    return result;
}, "get flags", true);


var $3a7b2e67c58ac9e9$exports = {};
"use strict";


var $ckZZt = parcelRequire("ckZZt");
var $3a7b2e67c58ac9e9$require$supportsDescriptors = $ckZZt.supportsDescriptors;
var $3a7b2e67c58ac9e9$var$$gOPD = Object.getOwnPropertyDescriptor;
$3a7b2e67c58ac9e9$exports = function getPolyfill() {
    if ($3a7b2e67c58ac9e9$require$supportsDescriptors && /a/mig.flags === "gim") {
        var descriptor = $3a7b2e67c58ac9e9$var$$gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
            /* eslint getter-return: 0 */ var calls = "";
            var o = {};
            Object.defineProperty(o, "hasIndices", {
                get: function() {
                    calls += "d";
                }
            });
            Object.defineProperty(o, "sticky", {
                get: function() {
                    calls += "y";
                }
            });
            if (calls === "dy") return descriptor.get;
        }
    }
    return $010e39d97664ff21$exports;
};


var $633ccff37403c780$exports = {};
"use strict";

var $ckZZt = parcelRequire("ckZZt");
var $633ccff37403c780$require$supportsDescriptors = $ckZZt.supportsDescriptors;

var $633ccff37403c780$var$gOPD = Object.getOwnPropertyDescriptor;
var $633ccff37403c780$var$defineProperty = Object.defineProperty;
var $633ccff37403c780$var$TypeErr = TypeError;
var $633ccff37403c780$var$getProto = Object.getPrototypeOf;
var $633ccff37403c780$var$regex = /a/;
$633ccff37403c780$exports = function shimFlags() {
    if (!$633ccff37403c780$require$supportsDescriptors || !$633ccff37403c780$var$getProto) throw new $633ccff37403c780$var$TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = $3a7b2e67c58ac9e9$exports();
    var proto = $633ccff37403c780$var$getProto($633ccff37403c780$var$regex);
    var descriptor = $633ccff37403c780$var$gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) $633ccff37403c780$var$defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};


var $907d80f57f41ee3b$var$flagsBound = $9nLII($3a7b2e67c58ac9e9$exports());
$ckZZt($907d80f57f41ee3b$var$flagsBound, {
    getPolyfill: $3a7b2e67c58ac9e9$exports,
    implementation: $010e39d97664ff21$exports,
    shim: $633ccff37403c780$exports
});
$907d80f57f41ee3b$exports = $907d80f57f41ee3b$var$flagsBound;



var $jL42x = parcelRequire("jL42x");
var $237dd48ae9b6ce07$exports = {};

var $jgs6G = parcelRequire("jgs6G");
"use strict";

var $a6Kf1 = parcelRequire("a6Kf1");
var $3e0fb115c6ce3262$exports = {};
"use strict";
var $7fa0be0689675281$exports = {};
"use strict";

var $deNME = parcelRequire("deNME");

var $7fa0be0689675281$var$channel = (parcelRequire("jfHx5"))();

var $gIo8M = parcelRequire("gIo8M");
var $7fa0be0689675281$var$SLOT = {
    assert: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $gIo8M("`O` is not an object");
        if (typeof slot !== "string") throw new $gIo8M("`slot` must be a string");
        $7fa0be0689675281$var$channel.assert(O);
        if (!$7fa0be0689675281$var$SLOT.has(O, slot)) throw new $gIo8M("`" + slot + "` is not present on `O`");
    },
    get: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $gIo8M("`O` is not an object");
        if (typeof slot !== "string") throw new $gIo8M("`slot` must be a string");
        var slots = $7fa0be0689675281$var$channel.get(O);
        return slots && slots["$" + slot];
    },
    has: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $gIo8M("`O` is not an object");
        if (typeof slot !== "string") throw new $gIo8M("`slot` must be a string");
        var slots = $7fa0be0689675281$var$channel.get(O);
        return !!slots && $deNME(slots, "$" + slot);
    },
    set: function(O, slot, V) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $gIo8M("`O` is not an object");
        if (typeof slot !== "string") throw new $gIo8M("`slot` must be a string");
        var slots = $7fa0be0689675281$var$channel.get(O);
        if (!slots) {
            slots = {};
            $7fa0be0689675281$var$channel.set(O, slots);
        }
        slots["$" + slot] = V;
    }
};
if (Object.freeze) Object.freeze($7fa0be0689675281$var$SLOT);
$7fa0be0689675281$exports = $7fa0be0689675281$var$SLOT;


var $3e0fb115c6ce3262$var$$SyntaxError = SyntaxError;
var $3e0fb115c6ce3262$var$$StopIteration = typeof StopIteration === "object" ? StopIteration : null;
$3e0fb115c6ce3262$exports = function getStopIterationIterator(origIterator) {
    if (!$3e0fb115c6ce3262$var$$StopIteration) throw new $3e0fb115c6ce3262$var$$SyntaxError("this environment lacks StopIteration");
    $7fa0be0689675281$exports.set(origIterator, "[[Done]]", false);
    var siIterator = {
        next: function next() {
            var iterator = $7fa0be0689675281$exports.get(this, "[[Iterator]]");
            var done = $7fa0be0689675281$exports.get(iterator, "[[Done]]");
            try {
                return {
                    done: done,
                    value: done ? void 0 : iterator.next()
                };
            } catch (e) {
                $7fa0be0689675281$exports.set(iterator, "[[Done]]", true);
                if (e !== $3e0fb115c6ce3262$var$$StopIteration) throw e;
                return {
                    done: true,
                    value: void 0
                };
            }
        }
    };
    $7fa0be0689675281$exports.set(siIterator, "[[Iterator]]", origIterator);
    return siIterator;
};










if ((parcelRequire("dwKXJ"))() || (parcelRequire("jgZd3"))()) {
    var $237dd48ae9b6ce07$var$$iterator = Symbol.iterator;
    // Symbol is available natively or shammed
    // natively:
    //  - Chrome >= 38
    //  - Edge 12-14?, Edge >= 15 for sure
    //  - FF >= 36
    //  - Safari >= 9
    //  - node >= 0.12
    $237dd48ae9b6ce07$exports = function getIterator(iterable) {
        // alternatively, `iterable[$iterator]?.()`
        if (iterable != null && typeof iterable[$237dd48ae9b6ce07$var$$iterator] !== "undefined") return iterable[$237dd48ae9b6ce07$var$$iterator]();
        if ($a6Kf1(iterable)) // arguments objects lack Symbol.iterator
        // - node 0.12
        return Array.prototype[$237dd48ae9b6ce07$var$$iterator].call(iterable);
    };
} else {
    // Symbol is not available, native or shammed
    var $237dd48ae9b6ce07$var$isArray = (parcelRequire("7s3wv"));
    var $237dd48ae9b6ce07$var$isString = (parcelRequire("35IUa"));
    var $237dd48ae9b6ce07$var$GetIntrinsic = (parcelRequire("jL42x"));
    var $237dd48ae9b6ce07$var$$Map = $237dd48ae9b6ce07$var$GetIntrinsic("%Map%", true);
    var $237dd48ae9b6ce07$var$$Set = $237dd48ae9b6ce07$var$GetIntrinsic("%Set%", true);
    var $237dd48ae9b6ce07$var$callBound = (parcelRequire("6YhGh"));
    var $237dd48ae9b6ce07$var$$arrayPush = $237dd48ae9b6ce07$var$callBound("Array.prototype.push");
    var $237dd48ae9b6ce07$var$$charCodeAt = $237dd48ae9b6ce07$var$callBound("String.prototype.charCodeAt");
    var $237dd48ae9b6ce07$var$$stringSlice = $237dd48ae9b6ce07$var$callBound("String.prototype.slice");
    var $237dd48ae9b6ce07$var$advanceStringIndex = function advanceStringIndex(S, index) {
        var length = S.length;
        if (index + 1 >= length) return index + 1;
        var first = $237dd48ae9b6ce07$var$$charCodeAt(S, index);
        if (first < 0xD800 || first > 0xDBFF) return index + 1;
        var second = $237dd48ae9b6ce07$var$$charCodeAt(S, index + 1);
        if (second < 0xDC00 || second > 0xDFFF) return index + 1;
        return index + 2;
    };
    var $237dd48ae9b6ce07$var$getArrayIterator = function getArrayIterator(arraylike) {
        var i = 0;
        return {
            next: function next() {
                var done = i >= arraylike.length;
                var value;
                if (!done) {
                    value = arraylike[i];
                    i += 1;
                }
                return {
                    done: done,
                    value: value
                };
            }
        };
    };
    var $237dd48ae9b6ce07$var$getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
        if ($237dd48ae9b6ce07$var$isArray(iterable) || $a6Kf1(iterable)) return $237dd48ae9b6ce07$var$getArrayIterator(iterable);
        if ($237dd48ae9b6ce07$var$isString(iterable)) {
            var i = 0;
            return {
                next: function next() {
                    var nextIndex = $237dd48ae9b6ce07$var$advanceStringIndex(iterable, i);
                    var value = $237dd48ae9b6ce07$var$$stringSlice(iterable, i, nextIndex);
                    i = nextIndex;
                    return {
                        done: nextIndex > iterable.length,
                        value: value
                    };
                }
            };
        }
        // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
        if (noPrimordialCollections && typeof iterable["_es6-shim iterator_"] !== "undefined") return iterable["_es6-shim iterator_"]();
    };
    if (!$237dd48ae9b6ce07$var$$Map && !$237dd48ae9b6ce07$var$$Set) // the only language iterables are Array, String, arguments
    // - Safari <= 6.0
    // - Chrome < 38
    // - node < 0.12
    // - FF < 13
    // - IE < 11
    // - Edge < 11
    $237dd48ae9b6ce07$exports = function getIterator(iterable) {
        if (iterable != null) return $237dd48ae9b6ce07$var$getNonCollectionIterator(iterable, true);
    };
    else {
        // either Map or Set are available, but Symbol is not
        // - es6-shim on an ES5 browser
        // - Safari 6.2 (maybe 6.1?)
        // - FF v[13, 36)
        // - IE 11
        // - Edge 11
        // - Safari v[6, 9)
        var $237dd48ae9b6ce07$var$isMap = (parcelRequire("iZ7CD"));
        var $237dd48ae9b6ce07$var$isSet = (parcelRequire("a1LoQ"));
        // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
        var $237dd48ae9b6ce07$var$$mapForEach = $237dd48ae9b6ce07$var$callBound("Map.prototype.forEach", true);
        var $237dd48ae9b6ce07$var$$setForEach = $237dd48ae9b6ce07$var$callBound("Set.prototype.forEach", true);
        if (typeof $jgs6G === "undefined" || !$jgs6G.versions || !$jgs6G.versions.node) {
            // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
            // returns a value, or throws a StopIteration object. These browsers
            // do not have any other mechanism for iteration.
            var $237dd48ae9b6ce07$var$$mapIterator = $237dd48ae9b6ce07$var$callBound("Map.prototype.iterator", true);
            var $237dd48ae9b6ce07$var$$setIterator = $237dd48ae9b6ce07$var$callBound("Set.prototype.iterator", true);
        }
        // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
        // this returns a proper iterator object, so we should use it instead of forEach.
        // newer es6-shim versions use a string "_es6-shim iterator_" property.
        var $237dd48ae9b6ce07$var$$mapAtAtIterator = $237dd48ae9b6ce07$var$callBound("Map.prototype.@@iterator", true) || $237dd48ae9b6ce07$var$callBound("Map.prototype._es6-shim iterator_", true);
        var $237dd48ae9b6ce07$var$$setAtAtIterator = $237dd48ae9b6ce07$var$callBound("Set.prototype.@@iterator", true) || $237dd48ae9b6ce07$var$callBound("Set.prototype._es6-shim iterator_", true);
        var $237dd48ae9b6ce07$var$getCollectionIterator = function getCollectionIterator(iterable) {
            if ($237dd48ae9b6ce07$var$isMap(iterable)) {
                if ($237dd48ae9b6ce07$var$$mapIterator) return $3e0fb115c6ce3262$exports($237dd48ae9b6ce07$var$$mapIterator(iterable));
                if ($237dd48ae9b6ce07$var$$mapAtAtIterator) return $237dd48ae9b6ce07$var$$mapAtAtIterator(iterable);
                if ($237dd48ae9b6ce07$var$$mapForEach) {
                    var entries = [];
                    $237dd48ae9b6ce07$var$$mapForEach(iterable, function(v, k) {
                        $237dd48ae9b6ce07$var$$arrayPush(entries, [
                            k,
                            v
                        ]);
                    });
                    return $237dd48ae9b6ce07$var$getArrayIterator(entries);
                }
            }
            if ($237dd48ae9b6ce07$var$isSet(iterable)) {
                if ($237dd48ae9b6ce07$var$$setIterator) return $3e0fb115c6ce3262$exports($237dd48ae9b6ce07$var$$setIterator(iterable));
                if ($237dd48ae9b6ce07$var$$setAtAtIterator) return $237dd48ae9b6ce07$var$$setAtAtIterator(iterable);
                if ($237dd48ae9b6ce07$var$$setForEach) {
                    var values = [];
                    $237dd48ae9b6ce07$var$$setForEach(iterable, function(v) {
                        $237dd48ae9b6ce07$var$$arrayPush(values, v);
                    });
                    return $237dd48ae9b6ce07$var$getArrayIterator(values);
                }
            }
        };
        $237dd48ae9b6ce07$exports = function getIterator(iterable) {
            return $237dd48ae9b6ce07$var$getCollectionIterator(iterable) || $237dd48ae9b6ce07$var$getNonCollectionIterator(iterable);
        };
    }
}



var $jfHx5 = parcelRequire("jfHx5");

var $UwsgQ = parcelRequire("UwsgQ");

var $a6Kf1 = parcelRequire("a6Kf1");

var $7s3wv = parcelRequire("7s3wv");
var $fd50a1ad109c6e3e$exports = {};
"use strict";

var $9nLII = parcelRequire("9nLII");

var $6YhGh = parcelRequire("6YhGh");

var $jL42x = parcelRequire("jL42x");
var $fd50a1ad109c6e3e$var$$ArrayBuffer = $jL42x("%ArrayBuffer%", true);
/** @type {undefined | ((receiver: ArrayBuffer) => number) | ((receiver: unknown) => never)} */ var $fd50a1ad109c6e3e$var$$byteLength = $6YhGh("ArrayBuffer.prototype.byteLength", true);
var $fd50a1ad109c6e3e$var$$toString = $6YhGh("Object.prototype.toString");
// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var $fd50a1ad109c6e3e$var$abSlice = !!$fd50a1ad109c6e3e$var$$ArrayBuffer && !$fd50a1ad109c6e3e$var$$byteLength && new $fd50a1ad109c6e3e$var$$ArrayBuffer(0).slice;
var $fd50a1ad109c6e3e$var$$abSlice = !!$fd50a1ad109c6e3e$var$abSlice && $9nLII($fd50a1ad109c6e3e$var$abSlice);
/** @type {import('.')} */ $fd50a1ad109c6e3e$exports = $fd50a1ad109c6e3e$var$$byteLength || $fd50a1ad109c6e3e$var$$abSlice ? function isArrayBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    try {
        if ($fd50a1ad109c6e3e$var$$byteLength) // @ts-expect-error no idea why TS can't handle the overload
        $fd50a1ad109c6e3e$var$$byteLength(obj);
        else // @ts-expect-error TS chooses not to type-narrow inside a closure
        $fd50a1ad109c6e3e$var$$abSlice(obj, 0);
        return true;
    } catch (e) {
        return false;
    }
} : $fd50a1ad109c6e3e$var$$ArrayBuffer ? function isArrayBuffer(obj) {
    return $fd50a1ad109c6e3e$var$$toString(obj) === "[object ArrayBuffer]";
} : function isArrayBuffer(obj) {
    return false;
};


var $5343ddfd74eacbac$exports = {};
"use strict";
var $5343ddfd74eacbac$var$getDay = Date.prototype.getDay;
var $5343ddfd74eacbac$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $5343ddfd74eacbac$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $5343ddfd74eacbac$var$toStr = Object.prototype.toString;
var $5343ddfd74eacbac$var$dateClass = "[object Date]";

var $5343ddfd74eacbac$var$hasToStringTag = (parcelRequire("4CtGg"))();
$5343ddfd74eacbac$exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return $5343ddfd74eacbac$var$hasToStringTag ? $5343ddfd74eacbac$var$tryDateObject(value) : $5343ddfd74eacbac$var$toStr.call(value) === $5343ddfd74eacbac$var$dateClass;
};


var $efd7827e31500eaf$exports = {};
"use strict";

var $6YhGh = parcelRequire("6YhGh");

var $efd7827e31500eaf$var$hasToStringTag = (parcelRequire("4CtGg"))();
var $efd7827e31500eaf$var$has;
var $efd7827e31500eaf$var$$exec;
var $efd7827e31500eaf$var$isRegexMarker;
var $efd7827e31500eaf$var$badStringifier;
if ($efd7827e31500eaf$var$hasToStringTag) {
    $efd7827e31500eaf$var$has = $6YhGh("Object.prototype.hasOwnProperty");
    $efd7827e31500eaf$var$$exec = $6YhGh("RegExp.prototype.exec");
    $efd7827e31500eaf$var$isRegexMarker = {};
    var $efd7827e31500eaf$var$throwRegexMarker = function() {
        throw $efd7827e31500eaf$var$isRegexMarker;
    };
    $efd7827e31500eaf$var$badStringifier = {
        toString: $efd7827e31500eaf$var$throwRegexMarker,
        valueOf: $efd7827e31500eaf$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") $efd7827e31500eaf$var$badStringifier[Symbol.toPrimitive] = $efd7827e31500eaf$var$throwRegexMarker;
}
var $efd7827e31500eaf$var$$toString = $6YhGh("Object.prototype.toString");
var $efd7827e31500eaf$var$gOPD = Object.getOwnPropertyDescriptor;
var $efd7827e31500eaf$var$regexClass = "[object RegExp]";
$efd7827e31500eaf$exports = $efd7827e31500eaf$var$hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = $efd7827e31500eaf$var$gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && $efd7827e31500eaf$var$has(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $efd7827e31500eaf$var$$exec(value, $efd7827e31500eaf$var$badStringifier);
    } catch (e) {
        return e === $efd7827e31500eaf$var$isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $efd7827e31500eaf$var$$toString(value) === $efd7827e31500eaf$var$regexClass;
};


var $e6bb752866180407$exports = {};
"use strict";

var $6YhGh = parcelRequire("6YhGh");
var $e6bb752866180407$var$$byteLength = $6YhGh("SharedArrayBuffer.prototype.byteLength", true);
/** @type {import('.')} */ $e6bb752866180407$exports = $e6bb752866180407$var$$byteLength ? function isSharedArrayBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    try {
        $e6bb752866180407$var$$byteLength(obj);
        return true;
    } catch (e) {
        return false;
    }
} : function isSharedArrayBuffer(obj) {
    return false;
};



var $1FrKZ = parcelRequire("1FrKZ");
var $791e39b89c1aa199$exports = {};
"use strict";

var $35IUa = parcelRequire("35IUa");
var $d804260454f0c41b$exports = {};
"use strict";
var $d804260454f0c41b$var$numToStr = Number.prototype.toString;
var $d804260454f0c41b$var$tryNumberObject = function tryNumberObject(value) {
    try {
        $d804260454f0c41b$var$numToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $d804260454f0c41b$var$toStr = Object.prototype.toString;
var $d804260454f0c41b$var$numClass = "[object Number]";

var $d804260454f0c41b$var$hasToStringTag = (parcelRequire("4CtGg"))();
$d804260454f0c41b$exports = function isNumberObject(value) {
    if (typeof value === "number") return true;
    if (typeof value !== "object") return false;
    return $d804260454f0c41b$var$hasToStringTag ? $d804260454f0c41b$var$tryNumberObject(value) : $d804260454f0c41b$var$toStr.call(value) === $d804260454f0c41b$var$numClass;
};


var $97eac26bb896ba7a$exports = {};
"use strict";

var $6YhGh = parcelRequire("6YhGh");
var $97eac26bb896ba7a$var$$boolToStr = $6YhGh("Boolean.prototype.toString");
var $97eac26bb896ba7a$var$$toString = $6YhGh("Object.prototype.toString");
var $97eac26bb896ba7a$var$tryBooleanObject = function booleanBrandCheck(value) {
    try {
        $97eac26bb896ba7a$var$$boolToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $97eac26bb896ba7a$var$boolClass = "[object Boolean]";

var $97eac26bb896ba7a$var$hasToStringTag = (parcelRequire("4CtGg"))();
$97eac26bb896ba7a$exports = function isBoolean(value) {
    if (typeof value === "boolean") return true;
    if (value === null || typeof value !== "object") return false;
    return $97eac26bb896ba7a$var$hasToStringTag && Symbol.toStringTag in value ? $97eac26bb896ba7a$var$tryBooleanObject(value) : $97eac26bb896ba7a$var$$toString(value) === $97eac26bb896ba7a$var$boolClass;
};


var $e44500b7bc67c6c9$exports = {};
"use strict";
var $e44500b7bc67c6c9$var$toStr = Object.prototype.toString;

var $e44500b7bc67c6c9$var$hasSymbols = (parcelRequire("dwKXJ"))();
if ($e44500b7bc67c6c9$var$hasSymbols) {
    var $e44500b7bc67c6c9$var$symToStr = Symbol.prototype.toString;
    var $e44500b7bc67c6c9$var$symStringRegex = /^Symbol\(.*\)$/;
    var $e44500b7bc67c6c9$var$isSymbolObject = function isRealSymbolObject(value) {
        if (typeof value.valueOf() !== "symbol") return false;
        return $e44500b7bc67c6c9$var$symStringRegex.test($e44500b7bc67c6c9$var$symToStr.call(value));
    };
    $e44500b7bc67c6c9$exports = function isSymbol(value) {
        if (typeof value === "symbol") return true;
        if ($e44500b7bc67c6c9$var$toStr.call(value) !== "[object Symbol]") return false;
        try {
            return $e44500b7bc67c6c9$var$isSymbolObject(value);
        } catch (e) {
            return false;
        }
    };
} else $e44500b7bc67c6c9$exports = function isSymbol(value) {
    // this environment does not support Symbols.
    return false;
};


var $0fb466870fed4610$exports = {};
"use strict";

var $0fb466870fed4610$var$hasBigInts = (parcelRequire("gpHnc"))();
if ($0fb466870fed4610$var$hasBigInts) {
    var $0fb466870fed4610$var$bigIntValueOf = BigInt.prototype.valueOf;
    var $0fb466870fed4610$var$tryBigInt = function tryBigIntObject(value) {
        try {
            $0fb466870fed4610$var$bigIntValueOf.call(value);
            return true;
        } catch (e) {}
        return false;
    };
    $0fb466870fed4610$exports = function isBigInt(value) {
        if (value === null || typeof value === "undefined" || typeof value === "boolean" || typeof value === "string" || typeof value === "number" || typeof value === "symbol" || typeof value === "function") return false;
        if (typeof value === "bigint") return true;
        return $0fb466870fed4610$var$tryBigInt(value);
    };
} else $0fb466870fed4610$exports = function isBigInt(value) {
    return false;
};


// eslint-disable-next-line consistent-return
$791e39b89c1aa199$exports = function whichBoxedPrimitive(value) {
    // eslint-disable-next-line eqeqeq
    if (value == null || typeof value !== "object" && typeof value !== "function") return null;
    if ($35IUa(value)) return "String";
    if ($d804260454f0c41b$exports(value)) return "Number";
    if ($97eac26bb896ba7a$exports(value)) return "Boolean";
    if ($e44500b7bc67c6c9$exports(value)) return "Symbol";
    if ($0fb466870fed4610$exports(value)) return "BigInt";
};


var $5eab6113d90429b4$exports = {};
"use strict";

var $iZ7CD = parcelRequire("iZ7CD");

var $a1LoQ = parcelRequire("a1LoQ");
var $4ee1b0602c6169ab$exports = {};
"use strict";
var $4ee1b0602c6169ab$var$$WeakMap = typeof WeakMap === "function" && WeakMap.prototype ? WeakMap : null;
var $4ee1b0602c6169ab$var$$WeakSet = typeof WeakSet === "function" && WeakSet.prototype ? WeakSet : null;
var $4ee1b0602c6169ab$var$exported;
if (!$4ee1b0602c6169ab$var$$WeakMap) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$4ee1b0602c6169ab$var$exported = function isWeakMap(x) {
    // `WeakMap` is not present in this environment.
    return false;
};
var $4ee1b0602c6169ab$var$$mapHas = $4ee1b0602c6169ab$var$$WeakMap ? $4ee1b0602c6169ab$var$$WeakMap.prototype.has : null;
var $4ee1b0602c6169ab$var$$setHas = $4ee1b0602c6169ab$var$$WeakSet ? $4ee1b0602c6169ab$var$$WeakSet.prototype.has : null;
if (!$4ee1b0602c6169ab$var$exported && !$4ee1b0602c6169ab$var$$mapHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$4ee1b0602c6169ab$var$exported = function isWeakMap(x) {
    // `WeakMap` does not have a `has` method
    return false;
};
/** @type {import('.')} */ $4ee1b0602c6169ab$exports = $4ee1b0602c6169ab$var$exported || function isWeakMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $4ee1b0602c6169ab$var$$mapHas.call(x, $4ee1b0602c6169ab$var$$mapHas);
        if ($4ee1b0602c6169ab$var$$setHas) try {
            $4ee1b0602c6169ab$var$$setHas.call(x, $4ee1b0602c6169ab$var$$setHas);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $WeakMap is always truthy here
        return x instanceof $4ee1b0602c6169ab$var$$WeakMap; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
};


var $7f25fc7eca05f0a2$exports = {};
"use strict";

var $jL42x = parcelRequire("jL42x");

var $6YhGh = parcelRequire("6YhGh");
var $7f25fc7eca05f0a2$var$$WeakSet = $jL42x("%WeakSet%", true);
var $7f25fc7eca05f0a2$var$$setHas = $6YhGh("WeakSet.prototype.has", true);
if ($7f25fc7eca05f0a2$var$$setHas) {
    var $7f25fc7eca05f0a2$var$$mapHas = $6YhGh("WeakMap.prototype.has", true);
    /** @type {import('.')} */ $7f25fc7eca05f0a2$exports = function isWeakSet(x) {
        if (!x || typeof x !== "object") return false;
        try {
            $7f25fc7eca05f0a2$var$$setHas(x, $7f25fc7eca05f0a2$var$$setHas);
            if ($7f25fc7eca05f0a2$var$$mapHas) try {
                $7f25fc7eca05f0a2$var$$mapHas(x, $7f25fc7eca05f0a2$var$$mapHas);
            } catch (e) {
                return true;
            }
            // @ts-expect-error TS can't figure out that $WeakSet is always truthy here
            return x instanceof $7f25fc7eca05f0a2$var$$WeakSet; // core-js workaround, pre-v3
        } catch (e) {}
        return false;
    };
} else /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$7f25fc7eca05f0a2$exports = function isWeakSet(x) {
    // `WeakSet` does not exist, or does not have a `has` method
    return false;
};


/** @type {import('.')} */ $5eab6113d90429b4$exports = function whichCollection(/** @type {unknown} */ value) {
    if (value && typeof value === "object") {
        if ($iZ7CD(value)) return "Map";
        if ($a1LoQ(value)) return "Set";
        if ($4ee1b0602c6169ab$exports(value)) return "WeakMap";
        if ($7f25fc7eca05f0a2$exports(value)) return "WeakSet";
    }
    return false;
};



var $af53G = parcelRequire("af53G");
var $ca067672fc48bcfd$exports = {};
"use strict";

var $6YhGh = parcelRequire("6YhGh");
var $ca067672fc48bcfd$var$$byteLength = $6YhGh("ArrayBuffer.prototype.byteLength", true);

/** @type {import('.')} */ $ca067672fc48bcfd$exports = function byteLength(ab) {
    if (!$fd50a1ad109c6e3e$exports(ab)) return NaN;
    return $ca067672fc48bcfd$var$$byteLength ? $ca067672fc48bcfd$var$$byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property


var $8d6e5cc4100c0a2f$var$sabByteLength = $6YhGh("SharedArrayBuffer.prototype.byteLength", true);
var $8d6e5cc4100c0a2f$var$$getTime = $6YhGh("Date.prototype.getTime");
var $8d6e5cc4100c0a2f$var$gPO = Object.getPrototypeOf;
var $8d6e5cc4100c0a2f$var$$objToString = $6YhGh("Object.prototype.toString");
var $8d6e5cc4100c0a2f$var$$Set = $jL42x("%Set%", true);
var $8d6e5cc4100c0a2f$var$$mapHas = $6YhGh("Map.prototype.has", true);
var $8d6e5cc4100c0a2f$var$$mapGet = $6YhGh("Map.prototype.get", true);
var $8d6e5cc4100c0a2f$var$$mapSize = $6YhGh("Map.prototype.size", true);
var $8d6e5cc4100c0a2f$var$$setAdd = $6YhGh("Set.prototype.add", true);
var $8d6e5cc4100c0a2f$var$$setDelete = $6YhGh("Set.prototype.delete", true);
var $8d6e5cc4100c0a2f$var$$setHas = $6YhGh("Set.prototype.has", true);
var $8d6e5cc4100c0a2f$var$$setSize = $6YhGh("Set.prototype.size", true);
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function $8d6e5cc4100c0a2f$var$setHasEqualElement(set, val1, opts, channel) {
    var i = $237dd48ae9b6ce07$exports(set);
    var result;
    while((result = i.next()) && !result.done)if ($8d6e5cc4100c0a2f$var$internalDeepEqual(val1, result.value, opts, channel)) {
        // Remove the matching element to make sure we do not check that again.
        $8d6e5cc4100c0a2f$var$$setDelete(set, result.value);
        return true;
    }
    return false;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function $8d6e5cc4100c0a2f$var$findLooseMatchingPrimitives(prim) {
    if (typeof prim === "undefined") return null;
    if (typeof prim === "object") return void 0;
    if (typeof prim === "symbol") return false;
    if (typeof prim === "string" || typeof prim === "number") // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
    return true;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function $8d6e5cc4100c0a2f$var$mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
    var altValue = $8d6e5cc4100c0a2f$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = $8d6e5cc4100c0a2f$var$$mapGet(b, altValue);
    var looseOpts = $4af0ce7007c1045e$exports({}, opts, {
        strict: false
    });
    if (typeof curB === "undefined" && !$8d6e5cc4100c0a2f$var$$mapHas(b, altValue) || !$8d6e5cc4100c0a2f$var$internalDeepEqual(item, curB, looseOpts, channel)) return false;
    // eslint-disable-next-line no-use-before-define
    return !$8d6e5cc4100c0a2f$var$$mapHas(a, altValue) && $8d6e5cc4100c0a2f$var$internalDeepEqual(item, curB, looseOpts, channel);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function $8d6e5cc4100c0a2f$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $8d6e5cc4100c0a2f$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return $8d6e5cc4100c0a2f$var$$setHas(b, altValue) && !$8d6e5cc4100c0a2f$var$$setHas(a, altValue);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function $8d6e5cc4100c0a2f$var$mapHasEqualEntry(set, map, key1, item1, opts, channel) {
    var i = $237dd48ae9b6ce07$exports(set);
    var result;
    var key2;
    while((result = i.next()) && !result.done){
        key2 = result.value;
        if (// eslint-disable-next-line no-use-before-define
        $8d6e5cc4100c0a2f$var$internalDeepEqual(key1, key2, opts, channel) && $8d6e5cc4100c0a2f$var$internalDeepEqual(item1, $8d6e5cc4100c0a2f$var$$mapGet(map, key2), opts, channel)) {
            $8d6e5cc4100c0a2f$var$$setDelete(set, key2);
            return true;
        }
    }
    return false;
}
function $8d6e5cc4100c0a2f$var$internalDeepEqual(actual, expected, options, channel) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $UwsgQ(actual, expected) : actual === expected) return true;
    var actualBoxed = $791e39b89c1aa199$exports(actual);
    var expectedBoxed = $791e39b89c1aa199$exports(expected);
    if (actualBoxed !== expectedBoxed) return false;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? $UwsgQ(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration
    var hasActual = channel.has(actual);
    var hasExpected = channel.has(expected);
    var sentinel;
    if (hasActual && hasExpected) {
        if (channel.get(actual) === channel.get(expected)) return true;
    } else sentinel = {};
    if (!hasActual) channel.set(actual, sentinel);
    if (!hasExpected) channel.set(expected, sentinel);
    // eslint-disable-next-line no-use-before-define
    return $8d6e5cc4100c0a2f$var$objEquiv(actual, expected, opts, channel);
}
function $8d6e5cc4100c0a2f$var$isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}
function $8d6e5cc4100c0a2f$var$setEquiv(a, b, opts, channel) {
    if ($8d6e5cc4100c0a2f$var$$setSize(a) !== $8d6e5cc4100c0a2f$var$$setSize(b)) return false;
    var iA = $237dd48ae9b6ce07$exports(a);
    var iB = $237dd48ae9b6ce07$exports(b);
    var resultA;
    var resultB;
    var set;
    while((resultA = iA.next()) && !resultA.done){
        if (resultA.value && typeof resultA.value === "object") {
            if (!set) set = new $8d6e5cc4100c0a2f$var$$Set();
            $8d6e5cc4100c0a2f$var$$setAdd(set, resultA.value);
        } else if (!$8d6e5cc4100c0a2f$var$$setHas(b, resultA.value)) {
            if (opts.strict) return false;
            if (!$8d6e5cc4100c0a2f$var$setMightHaveLoosePrim(a, b, resultA.value)) return false;
            if (!set) set = new $8d6e5cc4100c0a2f$var$$Set();
            $8d6e5cc4100c0a2f$var$$setAdd(set, resultA.value);
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
            if (resultB.value && typeof resultB.value === "object") {
                if (!$8d6e5cc4100c0a2f$var$setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
            } else if (!opts.strict && !$8d6e5cc4100c0a2f$var$$setHas(a, resultB.value) && !$8d6e5cc4100c0a2f$var$setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
        }
        return $8d6e5cc4100c0a2f$var$$setSize(set) === 0;
    }
    return true;
}
function $8d6e5cc4100c0a2f$var$mapEquiv(a, b, opts, channel) {
    if ($8d6e5cc4100c0a2f$var$$mapSize(a) !== $8d6e5cc4100c0a2f$var$$mapSize(b)) return false;
    var iA = $237dd48ae9b6ce07$exports(a);
    var iB = $237dd48ae9b6ce07$exports(b);
    var resultA;
    var resultB;
    var set;
    var key;
    var item1;
    var item2;
    while((resultA = iA.next()) && !resultA.done){
        key = resultA.value[0];
        item1 = resultA.value[1];
        if (key && typeof key === "object") {
            if (!set) set = new $8d6e5cc4100c0a2f$var$$Set();
            $8d6e5cc4100c0a2f$var$$setAdd(set, key);
        } else {
            item2 = $8d6e5cc4100c0a2f$var$$mapGet(b, key);
            if (typeof item2 === "undefined" && !$8d6e5cc4100c0a2f$var$$mapHas(b, key) || !$8d6e5cc4100c0a2f$var$internalDeepEqual(item1, item2, opts, channel)) {
                if (opts.strict) return false;
                if (!$8d6e5cc4100c0a2f$var$mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) return false;
                if (!set) set = new $8d6e5cc4100c0a2f$var$$Set();
                $8d6e5cc4100c0a2f$var$$setAdd(set, key);
            }
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            key = resultB.value[0];
            item2 = resultB.value[1];
            if (key && typeof key === "object") {
                if (!$8d6e5cc4100c0a2f$var$mapHasEqualEntry(set, a, key, item2, opts, channel)) return false;
            } else if (!opts.strict && (!a.has(key) || !$8d6e5cc4100c0a2f$var$internalDeepEqual($8d6e5cc4100c0a2f$var$$mapGet(a, key), item2, opts, channel)) && !$8d6e5cc4100c0a2f$var$mapHasEqualEntry(set, a, key, item2, $4af0ce7007c1045e$exports({}, opts, {
                strict: false
            }), channel)) return false;
        }
        return $8d6e5cc4100c0a2f$var$$setSize(set) === 0;
    }
    return true;
}
function $8d6e5cc4100c0a2f$var$objEquiv(a, b, opts, channel) {
    /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */ var i, key;
    if (typeof a !== typeof b) return false;
    if (a == null || b == null) return false;
    if ($8d6e5cc4100c0a2f$var$$objToString(a) !== $8d6e5cc4100c0a2f$var$$objToString(b)) return false;
    if ($a6Kf1(a) !== $a6Kf1(b)) return false;
    var aIsArray = $7s3wv(a);
    var bIsArray = $7s3wv(b);
    if (aIsArray !== bIsArray) return false;
    // TODO: replace when a cross-realm brand check is available
    var aIsError = a instanceof Error;
    var bIsError = b instanceof Error;
    if (aIsError !== bIsError) return false;
    if (aIsError || bIsError) {
        if (a.name !== b.name || a.message !== b.message) return false;
    }
    var aIsRegex = $efd7827e31500eaf$exports(a);
    var bIsRegex = $efd7827e31500eaf$exports(b);
    if (aIsRegex !== bIsRegex) return false;
    if ((aIsRegex || bIsRegex) && (a.source !== b.source || $907d80f57f41ee3b$exports(a) !== $907d80f57f41ee3b$exports(b))) return false;
    var aIsDate = $5343ddfd74eacbac$exports(a);
    var bIsDate = $5343ddfd74eacbac$exports(b);
    if (aIsDate !== bIsDate) return false;
    if (aIsDate || bIsDate) {
        if ($8d6e5cc4100c0a2f$var$$getTime(a) !== $8d6e5cc4100c0a2f$var$$getTime(b)) return false;
    }
    if (opts.strict && $8d6e5cc4100c0a2f$var$gPO && $8d6e5cc4100c0a2f$var$gPO(a) !== $8d6e5cc4100c0a2f$var$gPO(b)) return false;
    var aWhich = $af53G(a);
    var bWhich = $af53G(b);
    if (aWhich !== bWhich) return false;
    if (aWhich || bWhich) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    var aIsBuffer = $8d6e5cc4100c0a2f$var$isBuffer(a);
    var bIsBuffer = $8d6e5cc4100c0a2f$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    var aIsArrayBuffer = $fd50a1ad109c6e3e$exports(a);
    var bIsArrayBuffer = $fd50a1ad109c6e3e$exports(b);
    if (aIsArrayBuffer !== bIsArrayBuffer) return false;
    if (aIsArrayBuffer || bIsArrayBuffer) {
        if ($ca067672fc48bcfd$exports(a) !== $ca067672fc48bcfd$exports(b)) return false;
        return typeof Uint8Array === "function" && $8d6e5cc4100c0a2f$var$internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    var aIsSAB = $e6bb752866180407$exports(a);
    var bIsSAB = $e6bb752866180407$exports(b);
    if (aIsSAB !== bIsSAB) return false;
    if (aIsSAB || bIsSAB) {
        if ($8d6e5cc4100c0a2f$var$sabByteLength(a) !== $8d6e5cc4100c0a2f$var$sabByteLength(b)) return false;
        return typeof Uint8Array === "function" && $8d6e5cc4100c0a2f$var$internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    if (typeof a !== typeof b) return false;
    var ka = $1FrKZ(a);
    var kb = $1FrKZ(b);
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
         // eslint-disable-line eqeqeq
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$8d6e5cc4100c0a2f$var$internalDeepEqual(a[key], b[key], opts, channel)) return false;
    }
    var aCollection = $5eab6113d90429b4$exports(a);
    var bCollection = $5eab6113d90429b4$exports(b);
    if (aCollection !== bCollection) return false;
    if (aCollection === "Set" || bCollection === "Set") return $8d6e5cc4100c0a2f$var$setEquiv(a, b, opts, channel);
    if (aCollection === "Map") return $8d6e5cc4100c0a2f$var$mapEquiv(a, b, opts, channel);
    return true;
}
$8d6e5cc4100c0a2f$exports = function deepEqual(a, b, opts) {
    return $8d6e5cc4100c0a2f$var$internalDeepEqual(a, b, opts, $jfHx5());
};


var $7a948fb5587e6dac$var$__defProp = Object.defineProperty;
var $7a948fb5587e6dac$var$__name = (target, value)=>$7a948fb5587e6dac$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $7a948fb5587e6dac$var$_GeojsonEquality = class _GeojsonEquality {
    constructor(opts){
        this.direction = false;
        this.compareProperties = true;
        var _a, _b, _c;
        this.precision = 10 ** -((_a = opts == null ? void 0 : opts.precision) != null ? _a : 17);
        this.direction = (_b = opts == null ? void 0 : opts.direction) != null ? _b : false;
        this.compareProperties = (_c = opts == null ? void 0 : opts.compareProperties) != null ? _c : true;
    }
    compare(g1, g2) {
        if (g1.type !== g2.type) return false;
        if (!$7a948fb5587e6dac$var$sameLength(g1, g2)) return false;
        switch(g1.type){
            case "Point":
                return this.compareCoord(g1.coordinates, g2.coordinates);
            case "LineString":
                return this.compareLine(g1.coordinates, g2.coordinates);
            case "Polygon":
                return this.comparePolygon(g1, g2);
            case "GeometryCollection":
                return this.compareGeometryCollection(g1, g2);
            case "Feature":
                return this.compareFeature(g1, g2);
            case "FeatureCollection":
                return this.compareFeatureCollection(g1, g2);
            default:
                if (g1.type.startsWith("Multi")) {
                    const g1s = $7a948fb5587e6dac$var$explode(g1);
                    const g2s = $7a948fb5587e6dac$var$explode(g2);
                    return g1s.every((g1part)=>g2s.some((g2part)=>this.compare(g1part, g2part)));
                }
        }
        return false;
    }
    compareCoord(c1, c2) {
        return c1.length === c2.length && c1.every((c, i)=>Math.abs(c - c2[i]) < this.precision);
    }
    compareLine(path1, path2, ind = 0, isPoly = false) {
        if (!$7a948fb5587e6dac$var$sameLength(path1, path2)) return false;
        const p1 = path1;
        let p2 = path2;
        if (isPoly && !this.compareCoord(p1[0], p2[0])) {
            const startIndex = this.fixStartIndex(p2, p1);
            if (!startIndex) return false;
            else p2 = startIndex;
        }
        const sameDirection = this.compareCoord(p1[ind], p2[ind]);
        if (this.direction || sameDirection) return this.comparePath(p1, p2);
        else {
            if (this.compareCoord(p1[ind], p2[p2.length - (1 + ind)])) return this.comparePath(p1.slice().reverse(), p2);
            return false;
        }
    }
    fixStartIndex(sourcePath, targetPath) {
        let correctPath, ind = -1;
        for(let i = 0; i < sourcePath.length; i++)if (this.compareCoord(sourcePath[i], targetPath[0])) {
            ind = i;
            break;
        }
        if (ind >= 0) correctPath = [].concat(sourcePath.slice(ind, sourcePath.length), sourcePath.slice(1, ind + 1));
        return correctPath;
    }
    comparePath(p1, p2) {
        return p1.every((c, i)=>this.compareCoord(c, p2[i]));
    }
    comparePolygon(g1, g2) {
        if (this.compareLine(g1.coordinates[0], g2.coordinates[0], 1, true)) {
            const holes1 = g1.coordinates.slice(1, g1.coordinates.length);
            const holes2 = g2.coordinates.slice(1, g2.coordinates.length);
            return holes1.every((h1)=>holes2.some((h2)=>this.compareLine(h1, h2, 1, true)));
        }
        return false;
    }
    compareGeometryCollection(g1, g2) {
        return $7a948fb5587e6dac$var$sameLength(g1.geometries, g2.geometries) && this.compareBBox(g1, g2) && g1.geometries.every((g, i)=>this.compare(g, g2.geometries[i]));
    }
    compareFeature(g1, g2) {
        return g1.id === g2.id && (this.compareProperties ? (0, (/*@__PURE__*/$parcel$interopDefault($8d6e5cc4100c0a2f$exports)))(g1.properties, g2.properties) : true) && this.compareBBox(g1, g2) && this.compare(g1.geometry, g2.geometry);
    }
    compareFeatureCollection(g1, g2) {
        return $7a948fb5587e6dac$var$sameLength(g1.features, g2.features) && this.compareBBox(g1, g2) && g1.features.every((f, i)=>this.compare(f, g2.features[i]));
    }
    compareBBox(g1, g2) {
        return Boolean(!g1.bbox && !g2.bbox) || (g1.bbox && g2.bbox ? this.compareCoord(g1.bbox, g2.bbox) : false);
    }
};
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$var$_GeojsonEquality, "GeojsonEquality");
var $7a948fb5587e6dac$export$63730496493291e4 = $7a948fb5587e6dac$var$_GeojsonEquality;
function $7a948fb5587e6dac$var$sameLength(g1, g2) {
    return g1.coordinates ? g1.coordinates.length === g2.coordinates.length : g1.length === g2.length;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$var$sameLength, "sameLength");
function $7a948fb5587e6dac$var$explode(g) {
    return g.coordinates.map((part)=>({
            type: g.type.replace("Multi", ""),
            coordinates: part
        }));
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$var$explode, "explode");
// index.ts
var $7a948fb5587e6dac$export$e3a1ee0e9945697f = 63710088e-1;
var $7a948fb5587e6dac$export$f929e47acbed771a = {
    centimeters: $7a948fb5587e6dac$export$e3a1ee0e9945697f * 100,
    centimetres: $7a948fb5587e6dac$export$e3a1ee0e9945697f * 100,
    degrees: 360 / (2 * Math.PI),
    feet: $7a948fb5587e6dac$export$e3a1ee0e9945697f * 3.28084,
    inches: $7a948fb5587e6dac$export$e3a1ee0e9945697f * 39.37,
    kilometers: $7a948fb5587e6dac$export$e3a1ee0e9945697f / 1e3,
    kilometres: $7a948fb5587e6dac$export$e3a1ee0e9945697f / 1e3,
    meters: $7a948fb5587e6dac$export$e3a1ee0e9945697f,
    metres: $7a948fb5587e6dac$export$e3a1ee0e9945697f,
    miles: $7a948fb5587e6dac$export$e3a1ee0e9945697f / 1609.344,
    millimeters: $7a948fb5587e6dac$export$e3a1ee0e9945697f * 1e3,
    millimetres: $7a948fb5587e6dac$export$e3a1ee0e9945697f * 1e3,
    nauticalmiles: $7a948fb5587e6dac$export$e3a1ee0e9945697f / 1852,
    radians: 1,
    yards: $7a948fb5587e6dac$export$e3a1ee0e9945697f * 1.0936
};
var $7a948fb5587e6dac$export$44665ce4f7f4c82b = {
    acres: 247105e-9,
    centimeters: 1e4,
    centimetres: 1e4,
    feet: 10.763910417,
    hectares: 1e-4,
    inches: 1550.003100006,
    kilometers: 1e-6,
    kilometres: 1e-6,
    meters: 1,
    metres: 1,
    miles: 386e-9,
    nauticalmiles: 29155334959812285e-23,
    millimeters: 1e6,
    millimetres: 1e6,
    yards: 1.195990046
};
function $7a948fb5587e6dac$export$ced6ed16dfd6a264(geom, properties, options = {}) {
    const feat = {
        type: "Feature"
    };
    if (options.id === 0 || options.id) feat.id = options.id;
    if (options.bbox) feat.bbox = options.bbox;
    feat.properties = properties || {};
    feat.geometry = geom;
    return feat;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$ced6ed16dfd6a264, "feature");
function $7a948fb5587e6dac$export$42a7622cbf932bb(type, coordinates, _options = {}) {
    switch(type){
        case "Point":
            return $7a948fb5587e6dac$export$105684a3041cb6f3(coordinates).geometry;
        case "LineString":
            return $7a948fb5587e6dac$export$98ec381bb06902c3(coordinates).geometry;
        case "Polygon":
            return $7a948fb5587e6dac$export$b7b19aa0ee06c73(coordinates).geometry;
        case "MultiPoint":
            return $7a948fb5587e6dac$export$335fc20ed6b6dbb6(coordinates).geometry;
        case "MultiLineString":
            return $7a948fb5587e6dac$export$bd735230309493da(coordinates).geometry;
        case "MultiPolygon":
            return $7a948fb5587e6dac$export$79bd594da96638d3(coordinates).geometry;
        default:
            throw new Error(type + " is invalid");
    }
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$42a7622cbf932bb, "geometry");
function $7a948fb5587e6dac$export$105684a3041cb6f3(coordinates, properties, options = {}) {
    if (!coordinates) throw new Error("coordinates is required");
    if (!Array.isArray(coordinates)) throw new Error("coordinates must be an Array");
    if (coordinates.length < 2) throw new Error("coordinates must be at least 2 numbers long");
    if (!$7a948fb5587e6dac$export$7e4aa119212bc614(coordinates[0]) || !$7a948fb5587e6dac$export$7e4aa119212bc614(coordinates[1])) throw new Error("coordinates must contain numbers");
    const geom = {
        type: "Point",
        coordinates: coordinates
    };
    return $7a948fb5587e6dac$export$ced6ed16dfd6a264(geom, properties, options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$105684a3041cb6f3, "point");
function $7a948fb5587e6dac$export$9f048bf86ee2e9d2(coordinates, properties, options = {}) {
    return $7a948fb5587e6dac$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $7a948fb5587e6dac$export$105684a3041cb6f3(coords, properties);
    }), options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$9f048bf86ee2e9d2, "points");
function $7a948fb5587e6dac$export$b7b19aa0ee06c73(coordinates, properties, options = {}) {
    for (const ring of coordinates){
        if (ring.length < 4) throw new Error("Each LinearRing of a Polygon must have 4 or more Positions.");
        if (ring[ring.length - 1].length !== ring[0].length) throw new Error("First and last Position are not equivalent.");
        for(let j = 0; j < ring[ring.length - 1].length; j++){
            if (ring[ring.length - 1][j] !== ring[0][j]) throw new Error("First and last Position are not equivalent.");
        }
    }
    const geom = {
        type: "Polygon",
        coordinates: coordinates
    };
    return $7a948fb5587e6dac$export$ced6ed16dfd6a264(geom, properties, options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$b7b19aa0ee06c73, "polygon");
function $7a948fb5587e6dac$export$8869eb68a940f9c2(coordinates, properties, options = {}) {
    return $7a948fb5587e6dac$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $7a948fb5587e6dac$export$b7b19aa0ee06c73(coords, properties);
    }), options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$8869eb68a940f9c2, "polygons");
function $7a948fb5587e6dac$export$98ec381bb06902c3(coordinates, properties, options = {}) {
    if (coordinates.length < 2) throw new Error("coordinates must be an array of two or more positions");
    const geom = {
        type: "LineString",
        coordinates: coordinates
    };
    return $7a948fb5587e6dac$export$ced6ed16dfd6a264(geom, properties, options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$98ec381bb06902c3, "lineString");
function $7a948fb5587e6dac$export$74f7306c35db993f(coordinates, properties, options = {}) {
    return $7a948fb5587e6dac$export$4717c67ac3e5e04d(coordinates.map((coords)=>{
        return $7a948fb5587e6dac$export$98ec381bb06902c3(coords, properties);
    }), options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$74f7306c35db993f, "lineStrings");
function $7a948fb5587e6dac$export$4717c67ac3e5e04d(features, options = {}) {
    const fc = {
        type: "FeatureCollection"
    };
    if (options.id) fc.id = options.id;
    if (options.bbox) fc.bbox = options.bbox;
    fc.features = features;
    return fc;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$4717c67ac3e5e04d, "featureCollection");
function $7a948fb5587e6dac$export$bd735230309493da(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiLineString",
        coordinates: coordinates
    };
    return $7a948fb5587e6dac$export$ced6ed16dfd6a264(geom, properties, options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$bd735230309493da, "multiLineString");
function $7a948fb5587e6dac$export$335fc20ed6b6dbb6(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPoint",
        coordinates: coordinates
    };
    return $7a948fb5587e6dac$export$ced6ed16dfd6a264(geom, properties, options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$335fc20ed6b6dbb6, "multiPoint");
function $7a948fb5587e6dac$export$79bd594da96638d3(coordinates, properties, options = {}) {
    const geom = {
        type: "MultiPolygon",
        coordinates: coordinates
    };
    return $7a948fb5587e6dac$export$ced6ed16dfd6a264(geom, properties, options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$79bd594da96638d3, "multiPolygon");
function $7a948fb5587e6dac$export$9242f1e18250422a(geometries, properties, options = {}) {
    const geom = {
        type: "GeometryCollection",
        geometries: geometries
    };
    return $7a948fb5587e6dac$export$ced6ed16dfd6a264(geom, properties, options);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$9242f1e18250422a, "geometryCollection");
function $7a948fb5587e6dac$export$2077e0241d6afd3c(num, precision = 0) {
    if (precision && !(precision >= 0)) throw new Error("precision must be a positive number");
    const multiplier = Math.pow(10, precision || 0);
    return Math.round(num * multiplier) / multiplier;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$2077e0241d6afd3c, "round");
function $7a948fb5587e6dac$export$f234631d6a2eedf8(radians, units = "kilometers") {
    const factor = $7a948fb5587e6dac$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return radians * factor;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$f234631d6a2eedf8, "radiansToLength");
function $7a948fb5587e6dac$export$a2280f7debae8f10(distance, units = "kilometers") {
    const factor = $7a948fb5587e6dac$export$f929e47acbed771a[units];
    if (!factor) throw new Error(units + " units is invalid");
    return distance / factor;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$a2280f7debae8f10, "lengthToRadians");
function $7a948fb5587e6dac$export$c7a138e00a89bd01(distance, units) {
    return $7a948fb5587e6dac$export$c41dd2a8460d3196($7a948fb5587e6dac$export$a2280f7debae8f10(distance, units));
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$c7a138e00a89bd01, "lengthToDegrees");
function $7a948fb5587e6dac$export$f2077d29c73b33ec(bearing) {
    let angle = bearing % 360;
    if (angle < 0) angle += 360;
    return angle;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$f2077d29c73b33ec, "bearingToAzimuth");
function $7a948fb5587e6dac$export$c41dd2a8460d3196(radians) {
    const degrees = radians % (2 * Math.PI);
    return degrees * 180 / Math.PI;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$c41dd2a8460d3196, "radiansToDegrees");
function $7a948fb5587e6dac$export$c9fcf1a7df975d78(degrees) {
    const radians = degrees % 360;
    return radians * Math.PI / 180;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$c9fcf1a7df975d78, "degreesToRadians");
function $7a948fb5587e6dac$export$ea1536a749e80563(length, originalUnit = "kilometers", finalUnit = "kilometers") {
    if (!(length >= 0)) throw new Error("length must be a positive number");
    return $7a948fb5587e6dac$export$f234631d6a2eedf8($7a948fb5587e6dac$export$a2280f7debae8f10(length, originalUnit), finalUnit);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$ea1536a749e80563, "convertLength");
function $7a948fb5587e6dac$export$2e65e2c759f7e341(area, originalUnit = "meters", finalUnit = "kilometers") {
    if (!(area >= 0)) throw new Error("area must be a positive number");
    const startFactor = $7a948fb5587e6dac$export$44665ce4f7f4c82b[originalUnit];
    if (!startFactor) throw new Error("invalid original units");
    const finalFactor = $7a948fb5587e6dac$export$44665ce4f7f4c82b[finalUnit];
    if (!finalFactor) throw new Error("invalid final units");
    return area / startFactor * finalFactor;
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$2e65e2c759f7e341, "convertArea");
function $7a948fb5587e6dac$export$7e4aa119212bc614(num) {
    return !isNaN(num) && num !== null && !Array.isArray(num);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$7e4aa119212bc614, "isNumber");
function $7a948fb5587e6dac$export$a6cdc56e425d0d0a(input) {
    return input !== null && typeof input === "object" && !Array.isArray(input);
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$a6cdc56e425d0d0a, "isObject");
function $7a948fb5587e6dac$export$28ac7bb8f5309bea(bbox) {
    if (!bbox) throw new Error("bbox is required");
    if (!Array.isArray(bbox)) throw new Error("bbox must be an Array");
    if (bbox.length !== 4 && bbox.length !== 6) throw new Error("bbox must be an Array of 4 or 6 numbers");
    bbox.forEach((num)=>{
        if (!$7a948fb5587e6dac$export$7e4aa119212bc614(num)) throw new Error("bbox must only contain numbers");
    });
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$28ac7bb8f5309bea, "validateBBox");
function $7a948fb5587e6dac$export$f35f128fd59ea256(id) {
    if (!id) throw new Error("id is required");
    if ([
        "string",
        "number"
    ].indexOf(typeof id) === -1) throw new Error("id must be a number or a string");
}
$7a948fb5587e6dac$var$__name($7a948fb5587e6dac$export$f35f128fd59ea256, "validateId");


var $cc43fd3480f22a83$var$__defProp = Object.defineProperty;
var $cc43fd3480f22a83$var$__name = (target, value)=>$cc43fd3480f22a83$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $cc43fd3480f22a83$export$6e011439fde007ae(geojson, callback, excludeWrapCoord) {
    if (geojson === null) return;
    var j, k, l, geometry, stopG, coords, geometryMaybeCollection, wrapShrink = 0, coordIndex = 0, isGeometryCollection, type = geojson.type, isFeatureCollection = type === "FeatureCollection", isFeature = type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(var featureIndex = 0; featureIndex < stop; featureIndex++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[featureIndex].geometry : isFeature ? geojson.geometry : geojson;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(var geomIndex = 0; geomIndex < stopG; geomIndex++){
            var multiFeatureIndex = 0;
            var geometryIndex = 0;
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[geomIndex] : geometryMaybeCollection;
            if (geometry === null) continue;
            coords = geometry.coordinates;
            var geomType = geometry.type;
            wrapShrink = excludeWrapCoord && (geomType === "Polygon" || geomType === "MultiPolygon") ? 1 : 0;
            switch(geomType){
                case null:
                    break;
                case "Point":
                    if (callback(coords, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                    coordIndex++;
                    multiFeatureIndex++;
                    break;
                case "LineString":
                case "MultiPoint":
                    for(j = 0; j < coords.length; j++){
                        if (callback(coords[j], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                        coordIndex++;
                        if (geomType === "MultiPoint") multiFeatureIndex++;
                    }
                    if (geomType === "LineString") multiFeatureIndex++;
                    break;
                case "Polygon":
                case "MultiLineString":
                    for(j = 0; j < coords.length; j++){
                        for(k = 0; k < coords[j].length - wrapShrink; k++){
                            if (callback(coords[j][k], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                            coordIndex++;
                        }
                        if (geomType === "MultiLineString") multiFeatureIndex++;
                        if (geomType === "Polygon") geometryIndex++;
                    }
                    if (geomType === "Polygon") multiFeatureIndex++;
                    break;
                case "MultiPolygon":
                    for(j = 0; j < coords.length; j++){
                        geometryIndex = 0;
                        for(k = 0; k < coords[j].length; k++){
                            for(l = 0; l < coords[j][k].length - wrapShrink; l++){
                                if (callback(coords[j][k][l], coordIndex, featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                                coordIndex++;
                            }
                            geometryIndex++;
                        }
                        multiFeatureIndex++;
                    }
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++)if ($cc43fd3480f22a83$export$6e011439fde007ae(geometry.geometries[j], callback, excludeWrapCoord) === false) return false;
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
    }
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$6e011439fde007ae, "coordEach");
function $cc43fd3480f22a83$export$6f96eac39184ffe9(geojson, callback, initialValue, excludeWrapCoord) {
    var previousValue = initialValue;
    $cc43fd3480f22a83$export$6e011439fde007ae(geojson, function(currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex) {
        if (coordIndex === 0 && initialValue === void 0) previousValue = currentCoord;
        else previousValue = callback(previousValue, currentCoord, coordIndex, featureIndex, multiFeatureIndex, geometryIndex);
    }, excludeWrapCoord);
    return previousValue;
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$6f96eac39184ffe9, "coordReduce");
function $cc43fd3480f22a83$export$9d63c695566dbaa3(geojson, callback) {
    var i;
    switch(geojson.type){
        case "FeatureCollection":
            for(i = 0; i < geojson.features.length; i++){
                if (callback(geojson.features[i].properties, i) === false) break;
            }
            break;
        case "Feature":
            callback(geojson.properties, 0);
            break;
    }
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$9d63c695566dbaa3, "propEach");
function $cc43fd3480f22a83$export$7ff6f75e5ef85a65(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $cc43fd3480f22a83$export$9d63c695566dbaa3(geojson, function(currentProperties, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentProperties;
        else previousValue = callback(previousValue, currentProperties, featureIndex);
    });
    return previousValue;
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$7ff6f75e5ef85a65, "propReduce");
function $cc43fd3480f22a83$export$45a31c4de8035258(geojson, callback) {
    if (geojson.type === "Feature") callback(geojson, 0);
    else if (geojson.type === "FeatureCollection") for(var i = 0; i < geojson.features.length; i++){
        if (callback(geojson.features[i], i) === false) break;
    }
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$45a31c4de8035258, "featureEach");
function $cc43fd3480f22a83$export$b18fee751b10b055(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $cc43fd3480f22a83$export$45a31c4de8035258(geojson, function(currentFeature, featureIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex);
    });
    return previousValue;
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$b18fee751b10b055, "featureReduce");
function $cc43fd3480f22a83$export$5485820fc560fe4e(geojson) {
    var coords = [];
    $cc43fd3480f22a83$export$6e011439fde007ae(geojson, function(coord) {
        coords.push(coord);
    });
    return coords;
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$5485820fc560fe4e, "coordAll");
function $cc43fd3480f22a83$export$d2d248a56672ab3d(geojson, callback) {
    var i, j, g, geometry, stopG, geometryMaybeCollection, isGeometryCollection, featureProperties, featureBBox, featureId, featureIndex = 0, isFeatureCollection = geojson.type === "FeatureCollection", isFeature = geojson.type === "Feature", stop = isFeatureCollection ? geojson.features.length : 1;
    for(i = 0; i < stop; i++){
        geometryMaybeCollection = isFeatureCollection ? geojson.features[i].geometry : isFeature ? geojson.geometry : geojson;
        featureProperties = isFeatureCollection ? geojson.features[i].properties : isFeature ? geojson.properties : {};
        featureBBox = isFeatureCollection ? geojson.features[i].bbox : isFeature ? geojson.bbox : void 0;
        featureId = isFeatureCollection ? geojson.features[i].id : isFeature ? geojson.id : void 0;
        isGeometryCollection = geometryMaybeCollection ? geometryMaybeCollection.type === "GeometryCollection" : false;
        stopG = isGeometryCollection ? geometryMaybeCollection.geometries.length : 1;
        for(g = 0; g < stopG; g++){
            geometry = isGeometryCollection ? geometryMaybeCollection.geometries[g] : geometryMaybeCollection;
            if (geometry === null) {
                if (callback(null, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                continue;
            }
            switch(geometry.type){
                case "Point":
                case "LineString":
                case "MultiPoint":
                case "Polygon":
                case "MultiLineString":
                case "MultiPolygon":
                    if (callback(geometry, featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    break;
                case "GeometryCollection":
                    for(j = 0; j < geometry.geometries.length; j++){
                        if (callback(geometry.geometries[j], featureIndex, featureProperties, featureBBox, featureId) === false) return false;
                    }
                    break;
                default:
                    throw new Error("Unknown Geometry Type");
            }
        }
        featureIndex++;
    }
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$d2d248a56672ab3d, "geomEach");
function $cc43fd3480f22a83$export$30055ae7bd157809(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $cc43fd3480f22a83$export$d2d248a56672ab3d(geojson, function(currentGeometry, featureIndex, featureProperties, featureBBox, featureId) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentGeometry;
        else previousValue = callback(previousValue, currentGeometry, featureIndex, featureProperties, featureBBox, featureId);
    });
    return previousValue;
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$30055ae7bd157809, "geomReduce");
function $cc43fd3480f22a83$export$12cba8b31beb353b(geojson, callback) {
    $cc43fd3480f22a83$export$d2d248a56672ab3d(geojson, function(geometry, featureIndex, properties, bbox, id) {
        var type = geometry === null ? null : geometry.type;
        switch(type){
            case null:
            case "Point":
            case "LineString":
            case "Polygon":
                if (callback((0, $7a948fb5587e6dac$export$ced6ed16dfd6a264)(geometry, properties, {
                    bbox: bbox,
                    id: id
                }), featureIndex, 0) === false) return false;
                return;
        }
        var geomType;
        switch(type){
            case "MultiPoint":
                geomType = "Point";
                break;
            case "MultiLineString":
                geomType = "LineString";
                break;
            case "MultiPolygon":
                geomType = "Polygon";
                break;
        }
        for(var multiFeatureIndex = 0; multiFeatureIndex < geometry.coordinates.length; multiFeatureIndex++){
            var coordinate = geometry.coordinates[multiFeatureIndex];
            var geom = {
                type: geomType,
                coordinates: coordinate
            };
            if (callback((0, $7a948fb5587e6dac$export$ced6ed16dfd6a264)(geom, properties), featureIndex, multiFeatureIndex) === false) return false;
        }
    });
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$12cba8b31beb353b, "flattenEach");
function $cc43fd3480f22a83$export$af6f15fec62b5d18(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $cc43fd3480f22a83$export$12cba8b31beb353b(geojson, function(currentFeature, featureIndex, multiFeatureIndex) {
        if (featureIndex === 0 && multiFeatureIndex === 0 && initialValue === void 0) previousValue = currentFeature;
        else previousValue = callback(previousValue, currentFeature, featureIndex, multiFeatureIndex);
    });
    return previousValue;
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$af6f15fec62b5d18, "flattenReduce");
function $cc43fd3480f22a83$export$d3ecc1efb2be121e(geojson, callback) {
    $cc43fd3480f22a83$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        var segmentIndex = 0;
        if (!feature2.geometry) return;
        var type = feature2.geometry.type;
        if (type === "Point" || type === "MultiPoint") return;
        var previousCoords;
        var previousFeatureIndex = 0;
        var previousMultiIndex = 0;
        var prevGeomIndex = 0;
        if ($cc43fd3480f22a83$export$6e011439fde007ae(feature2, function(currentCoord, coordIndex, featureIndexCoord, multiPartIndexCoord, geometryIndex) {
            if (previousCoords === void 0 || featureIndex > previousFeatureIndex || multiPartIndexCoord > previousMultiIndex || geometryIndex > prevGeomIndex) {
                previousCoords = currentCoord;
                previousFeatureIndex = featureIndex;
                previousMultiIndex = multiPartIndexCoord;
                prevGeomIndex = geometryIndex;
                segmentIndex = 0;
                return;
            }
            var currentSegment = (0, $7a948fb5587e6dac$export$98ec381bb06902c3)([
                previousCoords,
                currentCoord
            ], feature2.properties);
            if (callback(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) === false) return false;
            segmentIndex++;
            previousCoords = currentCoord;
        }) === false) return false;
    });
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$d3ecc1efb2be121e, "segmentEach");
function $cc43fd3480f22a83$export$eec78cdd4d343a79(geojson, callback, initialValue) {
    var previousValue = initialValue;
    var started = false;
    $cc43fd3480f22a83$export$d3ecc1efb2be121e(geojson, function(currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex) {
        if (started === false && initialValue === void 0) previousValue = currentSegment;
        else previousValue = callback(previousValue, currentSegment, featureIndex, multiFeatureIndex, geometryIndex, segmentIndex);
        started = true;
    });
    return previousValue;
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$eec78cdd4d343a79, "segmentReduce");
function $cc43fd3480f22a83$export$985a91771cfc783d(geojson, callback) {
    if (!geojson) throw new Error("geojson is required");
    $cc43fd3480f22a83$export$12cba8b31beb353b(geojson, function(feature2, featureIndex, multiFeatureIndex) {
        if (feature2.geometry === null) return;
        var type = feature2.geometry.type;
        var coords = feature2.geometry.coordinates;
        switch(type){
            case "LineString":
                if (callback(feature2, featureIndex, multiFeatureIndex, 0, 0) === false) return false;
                break;
            case "Polygon":
                for(var geometryIndex = 0; geometryIndex < coords.length; geometryIndex++){
                    if (callback((0, $7a948fb5587e6dac$export$98ec381bb06902c3)(coords[geometryIndex], feature2.properties), featureIndex, multiFeatureIndex, geometryIndex) === false) return false;
                }
                break;
        }
    });
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$985a91771cfc783d, "lineEach");
function $cc43fd3480f22a83$export$a150e51c8ec9198a(geojson, callback, initialValue) {
    var previousValue = initialValue;
    $cc43fd3480f22a83$export$985a91771cfc783d(geojson, function(currentLine, featureIndex, multiFeatureIndex, geometryIndex) {
        if (featureIndex === 0 && initialValue === void 0) previousValue = currentLine;
        else previousValue = callback(previousValue, currentLine, featureIndex, multiFeatureIndex, geometryIndex);
    });
    return previousValue;
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$a150e51c8ec9198a, "lineReduce");
function $cc43fd3480f22a83$export$2b6ba91fd8680d67(geojson, options) {
    options = options || {};
    if (!(0, $7a948fb5587e6dac$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var segmentIndex = options.segmentIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
            if (segmentIndex < 0) segmentIndex = coords.length + segmentIndex - 1;
            return (0, $7a948fb5587e6dac$export$98ec381bb06902c3)([
                coords[segmentIndex],
                coords[segmentIndex + 1]
            ], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[geometryIndex].length + segmentIndex - 1;
            return (0, $7a948fb5587e6dac$export$98ec381bb06902c3)([
                coords[geometryIndex][segmentIndex],
                coords[geometryIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex].length + segmentIndex - 1;
            return (0, $7a948fb5587e6dac$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][segmentIndex],
                coords[multiFeatureIndex][segmentIndex + 1]
            ], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (segmentIndex < 0) segmentIndex = coords[multiFeatureIndex][geometryIndex].length - segmentIndex - 1;
            return (0, $7a948fb5587e6dac$export$98ec381bb06902c3)([
                coords[multiFeatureIndex][geometryIndex][segmentIndex],
                coords[multiFeatureIndex][geometryIndex][segmentIndex + 1]
            ], properties, options);
    }
    throw new Error("geojson is invalid");
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$2b6ba91fd8680d67, "findSegment");
function $cc43fd3480f22a83$export$ed60ae5df1bac687(geojson, options) {
    options = options || {};
    if (!(0, $7a948fb5587e6dac$export$a6cdc56e425d0d0a)(options)) throw new Error("options is invalid");
    var featureIndex = options.featureIndex || 0;
    var multiFeatureIndex = options.multiFeatureIndex || 0;
    var geometryIndex = options.geometryIndex || 0;
    var coordIndex = options.coordIndex || 0;
    var properties = options.properties;
    var geometry;
    switch(geojson.type){
        case "FeatureCollection":
            if (featureIndex < 0) featureIndex = geojson.features.length + featureIndex;
            properties = properties || geojson.features[featureIndex].properties;
            geometry = geojson.features[featureIndex].geometry;
            break;
        case "Feature":
            properties = properties || geojson.properties;
            geometry = geojson.geometry;
            break;
        case "Point":
        case "MultiPoint":
            return null;
        case "LineString":
        case "Polygon":
        case "MultiLineString":
        case "MultiPolygon":
            geometry = geojson;
            break;
        default:
            throw new Error("geojson is invalid");
    }
    if (geometry === null) return null;
    var coords = geometry.coordinates;
    switch(geometry.type){
        case "Point":
            return (0, $7a948fb5587e6dac$export$105684a3041cb6f3)(coords, properties, options);
        case "MultiPoint":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            return (0, $7a948fb5587e6dac$export$105684a3041cb6f3)(coords[multiFeatureIndex], properties, options);
        case "LineString":
            if (coordIndex < 0) coordIndex = coords.length + coordIndex;
            return (0, $7a948fb5587e6dac$export$105684a3041cb6f3)(coords[coordIndex], properties, options);
        case "Polygon":
            if (geometryIndex < 0) geometryIndex = coords.length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[geometryIndex].length + coordIndex;
            return (0, $7a948fb5587e6dac$export$105684a3041cb6f3)(coords[geometryIndex][coordIndex], properties, options);
        case "MultiLineString":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex].length + coordIndex;
            return (0, $7a948fb5587e6dac$export$105684a3041cb6f3)(coords[multiFeatureIndex][coordIndex], properties, options);
        case "MultiPolygon":
            if (multiFeatureIndex < 0) multiFeatureIndex = coords.length + multiFeatureIndex;
            if (geometryIndex < 0) geometryIndex = coords[multiFeatureIndex].length + geometryIndex;
            if (coordIndex < 0) coordIndex = coords[multiFeatureIndex][geometryIndex].length - coordIndex;
            return (0, $7a948fb5587e6dac$export$105684a3041cb6f3)(coords[multiFeatureIndex][geometryIndex][coordIndex], properties, options);
    }
    throw new Error("geojson is invalid");
}
$cc43fd3480f22a83$var$__name($cc43fd3480f22a83$export$ed60ae5df1bac687, "findPoint");


var $aa8e38ff8e47137a$var$__defProp = Object.defineProperty;
var $aa8e38ff8e47137a$var$__name = (target, value)=>$aa8e38ff8e47137a$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $aa8e38ff8e47137a$export$bf67010aacbe66fa(geojson, options = {}) {
    if (geojson.bbox != null && true !== options.recompute) return geojson.bbox;
    const result = [
        Infinity,
        Infinity,
        -Infinity,
        -Infinity
    ];
    (0, $cc43fd3480f22a83$export$6e011439fde007ae)(geojson, (coord)=>{
        if (result[0] > coord[0]) result[0] = coord[0];
        if (result[1] > coord[1]) result[1] = coord[1];
        if (result[2] < coord[0]) result[2] = coord[0];
        if (result[3] < coord[1]) result[3] = coord[1];
    });
    return result;
}
$aa8e38ff8e47137a$var$__name($aa8e38ff8e47137a$export$bf67010aacbe66fa, "bbox");
var $aa8e38ff8e47137a$export$2e2bcd8739ae039 = $aa8e38ff8e47137a$export$bf67010aacbe66fa;



var $67c15e7241fce3d4$var$__defProp = Object.defineProperty;
var $67c15e7241fce3d4$var$__name = (target, value)=>$67c15e7241fce3d4$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $67c15e7241fce3d4$export$b8b8bb64565c10e(bbox, options = {}) {
    const west = Number(bbox[0]);
    const south = Number(bbox[1]);
    const east = Number(bbox[2]);
    const north = Number(bbox[3]);
    if (bbox.length === 6) throw new Error("@turf/bbox-polygon does not support BBox with 6 positions");
    const lowLeft = [
        west,
        south
    ];
    const topLeft = [
        west,
        north
    ];
    const topRight = [
        east,
        north
    ];
    const lowRight = [
        east,
        south
    ];
    return (0, $7a948fb5587e6dac$export$b7b19aa0ee06c73)([
        [
            lowLeft,
            lowRight,
            topRight,
            topLeft,
            lowLeft
        ]
    ], options.properties, {
        bbox: bbox,
        id: options.id
    });
}
$67c15e7241fce3d4$var$__name($67c15e7241fce3d4$export$b8b8bb64565c10e, "bboxPolygon");
var $67c15e7241fce3d4$export$2e2bcd8739ae039 = $67c15e7241fce3d4$export$b8b8bb64565c10e;




var $7971cbca28e1a848$var$__defProp = Object.defineProperty;
var $7971cbca28e1a848$var$__name = (target, value)=>$7971cbca28e1a848$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $7971cbca28e1a848$export$bb3edc44842b5f2e(geojson) {
    return (0, $cc43fd3480f22a83$export$30055ae7bd157809)(geojson, (value, geom)=>{
        return value + $7971cbca28e1a848$var$calculateArea(geom);
    }, 0);
}
$7971cbca28e1a848$var$__name($7971cbca28e1a848$export$bb3edc44842b5f2e, "area");
function $7971cbca28e1a848$var$calculateArea(geom) {
    let total = 0;
    let i;
    switch(geom.type){
        case "Polygon":
            return $7971cbca28e1a848$var$polygonArea(geom.coordinates);
        case "MultiPolygon":
            for(i = 0; i < geom.coordinates.length; i++)total += $7971cbca28e1a848$var$polygonArea(geom.coordinates[i]);
            return total;
        case "Point":
        case "MultiPoint":
        case "LineString":
        case "MultiLineString":
            return 0;
    }
    return 0;
}
$7971cbca28e1a848$var$__name($7971cbca28e1a848$var$calculateArea, "calculateArea");
function $7971cbca28e1a848$var$polygonArea(coords) {
    let total = 0;
    if (coords && coords.length > 0) {
        total += Math.abs($7971cbca28e1a848$var$ringArea(coords[0]));
        for(let i = 1; i < coords.length; i++)total -= Math.abs($7971cbca28e1a848$var$ringArea(coords[i]));
    }
    return total;
}
$7971cbca28e1a848$var$__name($7971cbca28e1a848$var$polygonArea, "polygonArea");
var $7971cbca28e1a848$var$FACTOR = (0, $7a948fb5587e6dac$export$e3a1ee0e9945697f) * (0, $7a948fb5587e6dac$export$e3a1ee0e9945697f) / 2;
var $7971cbca28e1a848$var$PI_OVER_180 = Math.PI / 180;
function $7971cbca28e1a848$var$ringArea(coords) {
    const coordsLength = coords.length;
    if (coordsLength <= 2) return 0;
    let total = 0;
    let i = 0;
    while(i < coordsLength){
        const lower = coords[i];
        const middle = coords[i + 1 === coordsLength ? 0 : i + 1];
        const upper = coords[i + 2 >= coordsLength ? (i + 2) % coordsLength : i + 2];
        const lowerX = lower[0] * $7971cbca28e1a848$var$PI_OVER_180;
        const middleY = middle[1] * $7971cbca28e1a848$var$PI_OVER_180;
        const upperX = upper[0] * $7971cbca28e1a848$var$PI_OVER_180;
        total += (upperX - lowerX) * Math.sin(middleY);
        i++;
    }
    return total * $7971cbca28e1a848$var$FACTOR;
}
$7971cbca28e1a848$var$__name($7971cbca28e1a848$var$ringArea, "ringArea");
var $7971cbca28e1a848$export$2e2bcd8739ae039 = $7971cbca28e1a848$export$bb3edc44842b5f2e;




var $32c9121f8cfac973$var$__defProp = Object.defineProperty;
var $32c9121f8cfac973$var$__name = (target, value)=>$32c9121f8cfac973$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $32c9121f8cfac973$export$3481c78889e8fbe8(geojson, options = {}) {
    const ext = (0, $aa8e38ff8e47137a$export$bf67010aacbe66fa)(geojson);
    const x = (ext[0] + ext[2]) / 2;
    const y = (ext[1] + ext[3]) / 2;
    return (0, $7a948fb5587e6dac$export$105684a3041cb6f3)([
        x,
        y
    ], options.properties, options);
}
$32c9121f8cfac973$var$__name($32c9121f8cfac973$export$3481c78889e8fbe8, "center");
var $32c9121f8cfac973$export$2e2bcd8739ae039 = $32c9121f8cfac973$export$3481c78889e8fbe8;







class $8a8fefd6e83d476d$export$2e2bcd8739ae039 {
    constructor(name, map){
        this.name = name;
        this.map = map;
        this.defaultGeojson = {
            "type": "FeatureCollection",
            "features": []
        };
        this.handleClusterClick = this.handleClusterClick.bind(this);
        this.handleMarkerClick = this.handleMarkerClick.bind(this);
        this.handleMarkerMouseenter = this.handleMarkerMouseenter.bind(this);
        this.handleMarkerMouseleave = this.handleMarkerMouseleave.bind(this);
        this.setActive = this.setActive.bind(this);
        this.clearActive = this.clearActive.bind(this);
        this.flyTo = this.flyTo.bind(this);
        // Add listeners to set/unset active markers from other components
        (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).on("map:setactive", this.setActive);
        (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).on("map:clearactive", this.clearActive);
        (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).on("map:flyto", this.flyTo);
    }
    create(geojson) {
        this.map.addSource(this.name, {
            type: "geojson",
            data: geojson,
            cluster: true,
            clusterRadius: 30,
            clusterMaxZoom: 13
        });
        this.map.addLayer({
            id: `${this.name}-clusters`,
            type: "circle",
            source: this.name,
            filter: [
                "has",
                "point_count"
            ],
            paint: {
                "circle-color": "#fff",
                "circle-stroke-color": "#000",
                "circle-radius": 12,
                "circle-stroke-width": 1
            }
        });
        this.map.addLayer({
            id: `${this.name}-cluster-count`,
            type: "symbol",
            source: this.name,
            filter: [
                "has",
                "point_count"
            ],
            layout: {
                "text-field": "{point_count_abbreviated}",
                "text-font": [
                    "Theinhardt Bold"
                ],
                "text-size": 13,
                "text-offset": [
                    -0.03,
                    -0.06
                ],
                "text-allow-overlap": true
            },
            paint: {
                "text-color": "#000"
            }
        });
        this.map.addLayer({
            id: `${this.name}-markers`,
            type: "symbol",
            source: this.name,
            filter: [
                "!has",
                "point_count"
            ],
            layout: {
                // Set icon image based on property.color value
                "icon-image": [
                    "match",
                    [
                        "get",
                        "color"
                    ],
                    "red",
                    "map-marker_red",
                    "blue",
                    "map-marker_blue",
                    "green",
                    "map-marker_green",
                    "yellow",
                    "map-marker_yellow",
                    "tan",
                    "map-marker_tan",
                    "accent",
                    "map-marker_accent",
                    "muted",
                    "map-marker_muted",
                    "map-marker_white"
                ],
                "icon-size": 1,
                "icon-allow-overlap": true
            }
        });
        this.map.addLayer({
            id: `${this.name}-markers-hover`,
            type: "symbol",
            source: this.name,
            filter: false,
            layout: {
                "icon-image": "map-marker_red",
                "icon-size": 1,
                "icon-allow-overlap": true
            }
        });
        // Separate active marker source/layer that does not cluster.
        // This is used to highlight markers from within the dom, such
        // as in guides or when hovering over grid items.
        this.map.addSource(`${this.name}-active`, {
            type: "geojson",
            data: geojson,
            cluster: false
        });
        this.map.addLayer({
            id: `${this.name}-markers-active`,
            type: "symbol",
            source: `${this.name}-active`,
            filter: false,
            layout: {
                "icon-image": "map-marker_red",
                "icon-size": 1,
                "icon-allow-overlap": true
            }
        });
        this.map.on("click", `${this.name}-clusters`, this.handleClusterClick);
        if ((0, $6999c02c9fa8589c$export$81bfe36fdbf6f8bf).matches) this.map.on("click", `${this.name}-markers`, this.handleMarkerClick);
        this.map.on("mousemove", `${this.name}-markers`, this.handleMarkerMouseenter);
        this.map.on("mouseleave", `${this.name}-markers`, this.handleMarkerMouseleave);
        this.map.on("mouseenter", `${this.name}-clusters`, this.handleMarkerMouseenter);
        this.map.on("mouseleave", `${this.name}-clusters`, this.handleMarkerMouseleave);
    }
    handleClusterClick(e) {
        const features = this.map.queryRenderedFeatures(e.point, {
            layers: [
                `${this.name}-clusters`
            ]
        });
        const clusterId = features[0].properties.cluster_id;
        this.map.getSource(this.name).getClusterExpansionZoom(clusterId, (err, zoom)=>{
            if (err) return;
            this.map.flyTo({
                center: features[0].geometry.coordinates,
                zoom: zoom
            });
        });
    }
    handleMarkerClick(e) {
        if (e.features.length > 0) {
            const linkTo = e.features[0]?.properties?.linkTo;
            if (linkTo) {
                window.GPLA_APP.go((0, $6999c02c9fa8589c$export$8f10f63063da874a)(linkTo));
                return;
            }
            const scrollTo = e.features[0]?.properties?.scrollTo;
            if (scrollTo && document.getElementById(scrollTo)) document.getElementById(scrollTo).scrollIntoView({
                behavior: "smooth"
            });
        }
    }
    handleMarkerMouseenter(e) {
        this.map.getCanvas().style.cursor = "pointer";
        // Set hover feature state
        const uuid = e?.features?.[0]?.properties?.uuid;
        this.setHover(uuid);
    }
    handleMarkerMouseleave(e) {
        this.map.getCanvas().style.cursor = "";
        this.clearHover();
    }
    setHover(uuid) {
        if (!uuid || !this.map.getLayer(`${this.name}-markers-hover`)) return;
        this.map.setFilter(`${this.name}-markers-hover`, [
            "==",
            "uuid",
            uuid
        ]);
    }
    clearHover() {
        if (!this.map.getLayer(`${this.name}-markers-hover`)) return;
        this.map.setFilter(`${this.name}-markers-hover`, false);
    }
    setActive(uuids) {
        if (!uuids || !this.map.getLayer(`${this.name}-markers-active`)) return;
        this.map.setFilter(`${this.name}-markers-active`, [
            "in",
            "uuid",
            ...uuids
        ]);
    }
    clearActive() {
        if (!this.map.getLayer(`${this.name}-markers-active`)) return;
        this.map.setFilter(`${this.name}-markers-active`, false);
    }
    flyTo(uuids = []) {
        const features = (this.map.getSource(this.name)?._data?.features || []).filter((feature)=>uuids.includes(feature.properties.uuid));
        if (features.length === 0) return;
        const geoCenter = (0, $32c9121f8cfac973$export$2e2bcd8739ae039)({
            type: "FeatureCollection",
            features: features
        });
        (0, $6999c02c9fa8589c$export$33a2cf1bd0f02582)(geoCenter?.geometry?.coordinates, this.map);
    }
    update(geojson, placement) {
        const transformedGeojson = (0, $6999c02c9fa8589c$export$9975f96781720201)(geojson);
        if (!this.map.getSource(this.name)) {
            this.create(transformedGeojson, placement);
            return;
        }
        this.map.getSource(this.name).setData(transformedGeojson);
        // Also pass data to active source
        this.map.getSource(`${this.name}-active`).setData(transformedGeojson);
    }
}


// import booleanPointInPolygon from '@turf/boolean-point-in-polygon'

class $8542af7a6ff96e69$export$2e2bcd8739ae039 {
    constructor(name, map, before = null){
        this.name = name;
        this.map = map;
        this.layer = `${this.name}-markers`;
        this.before = before;
    }
    create() {
        fetch(`${window.SITE_BASE}/places.json`).then((response)=>response.json()).then((data)=>{
            let { geojson: geojson } = data;
            if (geojson) {
                this.map.addSource("site-places", {
                    type: "geojson",
                    data: geojson,
                    cluster: false
                });
                const layerOptions = {
                    id: this.layer,
                    type: "symbol",
                    source: this.name,
                    layout: {
                        "icon-image": "place-marker_tan_50",
                        "icon-size": 1
                    }
                };
                // Add layer before another layer if specified
                if (this.before && this.map.getLayer(this.before)) this.map.addLayer(layerOptions, this.before);
                else this.map.addLayer(layerOptions);
                this.handleInitialLoad();
            }
        });
    }
    hide() {
        if (this.map.getLayer(this.layer) && this.map.getLayoutProperty(this.layer, "visibility") !== "none") this.map.setLayoutProperty(this.layer, "visibility", "none");
    }
    show() {
        if (this.map.getLayer(this.layer) && this.map.getLayoutProperty(this.layer, "visibility") !== "visible") this.map.setLayoutProperty(this.layer, "visibility", "visible");
    }
    handleInitialLoad() {
        const uri = (0, $6999c02c9fa8589c$export$6483924f57bebc09)(window.GPLA_APP.state.location);
        if (uri.startsWith("guides")) this.hide();
    }
}


/* eslint-disable unicorn/prefer-spread */ const $2504f0b3cca4f51e$export$f8bb2f9f4607ed91 = ".";
const $2504f0b3cca4f51e$export$9cb8e7b38dc3cece = Symbol("target");
const $2504f0b3cca4f51e$export$881b71df7abed909 = Symbol("unsubscribe");


function $d4c4991060a66864$export$2191e61a810db5fc(value) {
    return value instanceof Date || value instanceof Set || value instanceof Map || value instanceof WeakSet || value instanceof WeakMap || ArrayBuffer.isView(value);
}
function $d4c4991060a66864$export$281bb0ec97352a76(value) {
    return (typeof value === "object" ? value === null : typeof value !== "function") || value instanceof RegExp;
}



var $427bc11931a03951$export$2e2bcd8739ae039 = Array.isArray;


function $cf15889158c239e3$export$2e2bcd8739ae039(value) {
    return typeof value === "symbol";
}


const $b805bfc4fb7b5554$var$path = {
    after (path, subPath) {
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(path)) return path.slice(subPath.length);
        if (subPath === "") return path;
        return path.slice(subPath.length + 1);
    },
    concat (path, key) {
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(path)) {
            path = [
                ...path
            ];
            if (key) path.push(key);
            return path;
        }
        if (key && key.toString !== undefined) {
            if (path !== "") path += (0, $2504f0b3cca4f51e$export$f8bb2f9f4607ed91);
            if ((0, $cf15889158c239e3$export$2e2bcd8739ae039)(key)) return path + key.toString();
            return path + key;
        }
        return path;
    },
    initial (path) {
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(path)) return path.slice(0, -1);
        if (path === "") return path;
        const index = path.lastIndexOf((0, $2504f0b3cca4f51e$export$f8bb2f9f4607ed91));
        if (index === -1) return "";
        return path.slice(0, index);
    },
    last (path) {
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(path)) return path.at(-1) ?? "";
        if (path === "") return path;
        const index = path.lastIndexOf((0, $2504f0b3cca4f51e$export$f8bb2f9f4607ed91));
        if (index === -1) return path;
        return path.slice(index + 1);
    },
    walk (path, callback) {
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(path)) for (const key of path)callback(key);
        else if (path !== "") {
            let position = 0;
            let index = path.indexOf((0, $2504f0b3cca4f51e$export$f8bb2f9f4607ed91));
            if (index === -1) callback(path);
            else while(position < path.length){
                if (index === -1) index = path.length;
                callback(path.slice(position, index));
                position = index + 1;
                index = path.indexOf((0, $2504f0b3cca4f51e$export$f8bb2f9f4607ed91), position);
            }
        }
    },
    get (object, path) {
        this.walk(path, (key)=>{
            if (object) object = object[key];
        });
        return object;
    },
    isSubPath (path, subPath) {
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(path)) {
            if (path.length < subPath.length) return false;
            // eslint-disable-next-line unicorn/no-for-loop
            for(let i = 0; i < subPath.length; i++){
                if (path[i] !== subPath[i]) return false;
            }
            return true;
        }
        if (path.length < subPath.length) return false;
        if (path === subPath) return true;
        if (path.startsWith(subPath)) return path[subPath.length] === (0, $2504f0b3cca4f51e$export$f8bb2f9f4607ed91);
        return false;
    },
    isRootPath (path) {
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(path)) return path.length === 0;
        return path === "";
    }
};
var $b805bfc4fb7b5554$export$2e2bcd8739ae039 = $b805bfc4fb7b5554$var$path;




function $520e0cce96600b4d$export$2e2bcd8739ae039(value) {
    return typeof value === "object" && typeof value.next === "function";
}



function $9fa21708f3ea0624$export$2e2bcd8739ae039(iterator, target, thisArgument, applyPath, prepareValue) {
    const originalNext = iterator.next;
    if (target.name === "entries") iterator.next = function() {
        const result = originalNext.call(this);
        if (result.done === false) {
            result.value[0] = prepareValue(result.value[0], target, result.value[0], applyPath);
            result.value[1] = prepareValue(result.value[1], target, result.value[0], applyPath);
        }
        return result;
    };
    else if (target.name === "values") {
        const keyIterator = thisArgument[0, $2504f0b3cca4f51e$export$9cb8e7b38dc3cece].keys();
        iterator.next = function() {
            const result = originalNext.call(this);
            if (result.done === false) result.value = prepareValue(result.value, target, keyIterator.next().value, applyPath);
            return result;
        };
    } else iterator.next = function() {
        const result = originalNext.call(this);
        if (result.done === false) result.value = prepareValue(result.value, target, result.value, applyPath);
        return result;
    };
    return iterator;
}



function $c605e9f8a54fbec0$export$2e2bcd8739ae039(cache, options, property) {
    return cache.isUnsubscribed || options.ignoreSymbols && (0, $cf15889158c239e3$export$2e2bcd8739ae039)(property) || options.ignoreUnderscores && property.charAt(0) === "_" || "ignoreKeys" in options && options.ignoreKeys.includes(property);
}



class $5060998ea41e747b$export$2e2bcd8739ae039 {
    constructor(equals){
        this._equals = equals;
        this._proxyCache = new WeakMap();
        this._pathCache = new WeakMap();
        this.isUnsubscribed = false;
    }
    _getDescriptorCache() {
        if (this._descriptorCache === undefined) this._descriptorCache = new WeakMap();
        return this._descriptorCache;
    }
    _getProperties(target) {
        const descriptorCache = this._getDescriptorCache();
        let properties = descriptorCache.get(target);
        if (properties === undefined) {
            properties = {};
            descriptorCache.set(target, properties);
        }
        return properties;
    }
    _getOwnPropertyDescriptor(target, property) {
        if (this.isUnsubscribed) return Reflect.getOwnPropertyDescriptor(target, property);
        const properties = this._getProperties(target);
        let descriptor = properties[property];
        if (descriptor === undefined) {
            descriptor = Reflect.getOwnPropertyDescriptor(target, property);
            properties[property] = descriptor;
        }
        return descriptor;
    }
    getProxy(target, path, handler, proxyTarget) {
        if (this.isUnsubscribed) return target;
        const reflectTarget = target[proxyTarget];
        const source = reflectTarget ?? target;
        this._pathCache.set(source, path);
        let proxy = this._proxyCache.get(source);
        if (proxy === undefined) {
            proxy = reflectTarget === undefined ? new Proxy(target, handler) : target;
            this._proxyCache.set(source, proxy);
        }
        return proxy;
    }
    getPath(target) {
        return this.isUnsubscribed ? undefined : this._pathCache.get(target);
    }
    isDetached(target, object) {
        return !Object.is(target, (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).get(object, this.getPath(target)));
    }
    defineProperty(target, property, descriptor) {
        if (!Reflect.defineProperty(target, property, descriptor)) return false;
        if (!this.isUnsubscribed) this._getProperties(target)[property] = descriptor;
        return true;
    }
    setProperty(target, property, value, receiver, previous) {
        if (!this._equals(previous, value) || !(property in target)) {
            const descriptor = this._getOwnPropertyDescriptor(target, property);
            if (descriptor !== undefined && "set" in descriptor) return Reflect.set(target, property, value, receiver);
            return Reflect.set(target, property, value);
        }
        return true;
    }
    deleteProperty(target, property, previous) {
        if (Reflect.deleteProperty(target, property)) {
            if (!this.isUnsubscribed) {
                const properties = this._getDescriptorCache().get(target);
                if (properties) {
                    delete properties[property];
                    this._pathCache.delete(previous);
                }
            }
            return true;
        }
        return false;
    }
    isSameDescriptor(a, target, property) {
        const b = this._getOwnPropertyDescriptor(target, property);
        return a !== undefined && b !== undefined && Object.is(a.value, b.value) && (a.writable || false) === (b.writable || false) && (a.enumerable || false) === (b.enumerable || false) && (a.configurable || false) === (b.configurable || false) && a.get === b.get && a.set === b.set;
    }
    isGetInvariant(target, property) {
        const descriptor = this._getOwnPropertyDescriptor(target, property);
        return descriptor !== undefined && descriptor.configurable !== true && descriptor.writable !== true;
    }
    unsubscribe() {
        this._descriptorCache = null;
        this._pathCache = null;
        this._proxyCache = null;
        this.isUnsubscribed = true;
    }
}




function $b0e33d9da7a6a05d$export$2e2bcd8739ae039(value) {
    return toString.call(value) === "[object Object]";
}





function $dd9de01dfe36a10e$export$2e2bcd8739ae039() {
    return true;
}


function $8e7e96dff31eed51$export$2e2bcd8739ae039(clone, value) {
    return clone.length !== value.length || clone.some((item, index)=>value[index] !== item);
}


const $bc54f2e3850e245d$export$87ab45442debb687 = new Set([
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
]);


const $fe79f1539b81300e$var$IMMUTABLE_ARRAY_METHODS = new Set([
    "concat",
    "includes",
    "indexOf",
    "join",
    "keys",
    "lastIndexOf"
]);
const $fe79f1539b81300e$export$4e33e1ac2be38fa3 = {
    push: (0, $dd9de01dfe36a10e$export$2e2bcd8739ae039),
    pop: (0, $dd9de01dfe36a10e$export$2e2bcd8739ae039),
    shift: (0, $dd9de01dfe36a10e$export$2e2bcd8739ae039),
    unshift: (0, $dd9de01dfe36a10e$export$2e2bcd8739ae039),
    copyWithin: (0, $8e7e96dff31eed51$export$2e2bcd8739ae039),
    reverse: (0, $8e7e96dff31eed51$export$2e2bcd8739ae039),
    sort: (0, $8e7e96dff31eed51$export$2e2bcd8739ae039),
    splice: (0, $8e7e96dff31eed51$export$2e2bcd8739ae039),
    flat: (0, $8e7e96dff31eed51$export$2e2bcd8739ae039),
    fill: (0, $8e7e96dff31eed51$export$2e2bcd8739ae039)
};
const $fe79f1539b81300e$export$157c4abf6d17869e = new Set([
    ...(0, $bc54f2e3850e245d$export$87ab45442debb687),
    ...$fe79f1539b81300e$var$IMMUTABLE_ARRAY_METHODS,
    ...Object.keys($fe79f1539b81300e$export$4e33e1ac2be38fa3)
]);


function $7b50ded1488669a7$export$2e2bcd8739ae039(clone, value) {
    if (clone.size !== value.size) return true;
    for (const element of clone){
        if (!value.has(element)) return true;
    }
    return false;
}


const $51d8929f1af0165f$export$fc33389dd13370bf = [
    "keys",
    "values",
    "entries"
];
const $51d8929f1af0165f$export$917446fc33e7cb53 = new Set([
    "has",
    "toString"
]);
const $51d8929f1af0165f$export$1b750ad9668ebc59 = {
    add: (0, $7b50ded1488669a7$export$2e2bcd8739ae039),
    clear: (0, $7b50ded1488669a7$export$2e2bcd8739ae039),
    delete: (0, $7b50ded1488669a7$export$2e2bcd8739ae039),
    forEach: (0, $7b50ded1488669a7$export$2e2bcd8739ae039)
};
const $51d8929f1af0165f$export$31c36d107390313f = new Set([
    ...$51d8929f1af0165f$export$917446fc33e7cb53,
    ...Object.keys($51d8929f1af0165f$export$1b750ad9668ebc59),
    ...$51d8929f1af0165f$export$fc33389dd13370bf
]);


function $b08bc72ecac2f6a0$export$2e2bcd8739ae039(clone, value) {
    if (clone.size !== value.size) return true;
    let bValue;
    for (const [key, aValue] of clone){
        bValue = value.get(key);
        if (bValue !== aValue || bValue === undefined && !value.has(key)) return true;
    }
    return false;
}



const $c8be411b49d01572$var$IMMUTABLE_MAP_METHODS = new Set([
    ...(0, $51d8929f1af0165f$export$917446fc33e7cb53),
    "get"
]);
const $c8be411b49d01572$export$5e358a2f59cad3d0 = {
    set: (0, $b08bc72ecac2f6a0$export$2e2bcd8739ae039),
    clear: (0, $b08bc72ecac2f6a0$export$2e2bcd8739ae039),
    delete: (0, $b08bc72ecac2f6a0$export$2e2bcd8739ae039),
    forEach: (0, $b08bc72ecac2f6a0$export$2e2bcd8739ae039)
};
const $c8be411b49d01572$export$424149ce245f02b7 = new Set([
    ...$c8be411b49d01572$var$IMMUTABLE_MAP_METHODS,
    ...Object.keys($c8be411b49d01572$export$5e358a2f59cad3d0),
    ...(0, $51d8929f1af0165f$export$fc33389dd13370bf)
]);



class $69c07f1be55c49a6$export$2e2bcd8739ae039 {
    constructor(value, path, argumentsList, hasOnValidate){
        this._path = path;
        this._isChanged = false;
        this._clonedCache = new Set();
        this._hasOnValidate = hasOnValidate;
        this._changes = hasOnValidate ? [] : null;
        this.clone = path === undefined ? value : this._shallowClone(value);
    }
    static isHandledMethod(name) {
        return (0, $bc54f2e3850e245d$export$87ab45442debb687).has(name);
    }
    _shallowClone(value) {
        let clone = value;
        if ((0, $b0e33d9da7a6a05d$export$2e2bcd8739ae039)(value)) clone = {
            ...value
        };
        else if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(value) || ArrayBuffer.isView(value)) clone = [
            ...value
        ];
        else if (value instanceof Date) clone = new Date(value);
        else if (value instanceof Set) clone = new Set([
            ...value
        ].map((item)=>this._shallowClone(item)));
        else if (value instanceof Map) {
            clone = new Map();
            for (const [key, item] of value.entries())clone.set(key, this._shallowClone(item));
        }
        this._clonedCache.add(clone);
        return clone;
    }
    preferredThisArg(isHandledMethod, name, thisArgument, thisProxyTarget) {
        if (isHandledMethod) {
            if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(thisProxyTarget)) this._onIsChanged = (0, $fe79f1539b81300e$export$4e33e1ac2be38fa3)[name];
            else if (thisProxyTarget instanceof Set) this._onIsChanged = (0, $51d8929f1af0165f$export$1b750ad9668ebc59)[name];
            else if (thisProxyTarget instanceof Map) this._onIsChanged = (0, $c8be411b49d01572$export$5e358a2f59cad3d0)[name];
            return thisProxyTarget;
        }
        return thisArgument;
    }
    update(fullPath, property, value) {
        const changePath = (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).after(fullPath, this._path);
        if (property !== "length") {
            let object = this.clone;
            (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).walk(changePath, (key)=>{
                if (object?.[key]) {
                    if (!this._clonedCache.has(object[key])) object[key] = this._shallowClone(object[key]);
                    object = object[key];
                }
            });
            if (this._hasOnValidate) this._changes.push({
                path: changePath,
                property: property,
                previous: value
            });
            if (object?.[property]) object[property] = value;
        }
        this._isChanged = true;
    }
    undo(object) {
        let change;
        for(let index = this._changes.length - 1; index !== -1; index--){
            change = this._changes[index];
            (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).get(object, change.path)[change.property] = change.previous;
        }
    }
    isChanged(value) {
        return this._onIsChanged === undefined ? this._isChanged : this._onIsChanged(this.clone, value);
    }
    isPathApplicable(changePath) {
        return (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).isRootPath(this._path) || (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).isSubPath(changePath, this._path);
    }
}




class $568407bf90f81faf$export$2e2bcd8739ae039 extends (0, $69c07f1be55c49a6$export$2e2bcd8739ae039) {
    static isHandledMethod(name) {
        return (0, $fe79f1539b81300e$export$157c4abf6d17869e).has(name);
    }
}



class $64011fa3fc2b6891$export$2e2bcd8739ae039 extends (0, $69c07f1be55c49a6$export$2e2bcd8739ae039) {
    undo(object) {
        object.setTime(this.clone.getTime());
    }
    isChanged(value, equals) {
        return !equals(this.clone.valueOf(), value.valueOf());
    }
}




class $809f53ee52d97457$export$2e2bcd8739ae039 extends (0, $69c07f1be55c49a6$export$2e2bcd8739ae039) {
    static isHandledMethod(name) {
        return (0, $51d8929f1af0165f$export$31c36d107390313f).has(name);
    }
    undo(object) {
        for (const value of this.clone)object.add(value);
        for (const value of object)if (!this.clone.has(value)) object.delete(value);
    }
}




class $d54391ca0afd2089$export$2e2bcd8739ae039 extends (0, $69c07f1be55c49a6$export$2e2bcd8739ae039) {
    static isHandledMethod(name) {
        return (0, $c8be411b49d01572$export$424149ce245f02b7).has(name);
    }
    undo(object) {
        for (const [key, value] of this.clone.entries())object.set(key, value);
        for (const key of object.keys())if (!this.clone.has(key)) object.delete(key);
    }
}



class $9670988049c6626f$export$2e2bcd8739ae039 extends (0, $69c07f1be55c49a6$export$2e2bcd8739ae039) {
    constructor(value, path, argumentsList, hasOnValidate){
        super(undefined, path, argumentsList, hasOnValidate);
        this._argument1 = argumentsList[0];
        this._weakValue = value.has(this._argument1);
    }
    isChanged(value) {
        return this._weakValue !== value.has(this._argument1);
    }
    undo(object) {
        if (this._weakValue && !object.has(this._argument1)) object.add(this._argument1);
        else object.delete(this._argument1);
    }
}



class $3e8b9993508133ed$export$2e2bcd8739ae039 extends (0, $69c07f1be55c49a6$export$2e2bcd8739ae039) {
    constructor(value, path, argumentsList, hasOnValidate){
        super(undefined, path, argumentsList, hasOnValidate);
        this._weakKey = argumentsList[0];
        this._weakHas = value.has(this._weakKey);
        this._weakValue = value.get(this._weakKey);
    }
    isChanged(value) {
        return this._weakValue !== value.get(this._weakKey);
    }
    undo(object) {
        const weakHas = object.has(this._weakKey);
        if (this._weakHas && !weakHas) object.set(this._weakKey, this._weakValue);
        else if (!this._weakHas && weakHas) object.delete(this._weakKey);
        else if (this._weakValue !== object.get(this._weakKey)) object.set(this._weakKey, this._weakValue);
    }
}


class $02919eed18394599$export$2e2bcd8739ae039 {
    constructor(hasOnValidate){
        this._stack = [];
        this._hasOnValidate = hasOnValidate;
    }
    static isHandledType(value) {
        return (0, $b0e33d9da7a6a05d$export$2e2bcd8739ae039)(value) || (0, $427bc11931a03951$export$2e2bcd8739ae039)(value) || (0, $d4c4991060a66864$export$2191e61a810db5fc)(value);
    }
    static isHandledMethod(target, name) {
        if ((0, $b0e33d9da7a6a05d$export$2e2bcd8739ae039)(target)) return (0, $69c07f1be55c49a6$export$2e2bcd8739ae039).isHandledMethod(name);
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(target)) return (0, $568407bf90f81faf$export$2e2bcd8739ae039).isHandledMethod(name);
        if (target instanceof Set) return (0, $809f53ee52d97457$export$2e2bcd8739ae039).isHandledMethod(name);
        if (target instanceof Map) return (0, $d54391ca0afd2089$export$2e2bcd8739ae039).isHandledMethod(name);
        return (0, $d4c4991060a66864$export$2191e61a810db5fc)(target);
    }
    get isCloning() {
        return this._stack.length > 0;
    }
    start(value, path, argumentsList) {
        let CloneClass = (0, $69c07f1be55c49a6$export$2e2bcd8739ae039);
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(value)) CloneClass = (0, $568407bf90f81faf$export$2e2bcd8739ae039);
        else if (value instanceof Date) CloneClass = (0, $64011fa3fc2b6891$export$2e2bcd8739ae039);
        else if (value instanceof Set) CloneClass = (0, $809f53ee52d97457$export$2e2bcd8739ae039);
        else if (value instanceof Map) CloneClass = (0, $d54391ca0afd2089$export$2e2bcd8739ae039);
        else if (value instanceof WeakSet) CloneClass = (0, $9670988049c6626f$export$2e2bcd8739ae039);
        else if (value instanceof WeakMap) CloneClass = (0, $3e8b9993508133ed$export$2e2bcd8739ae039);
        this._stack.push(new CloneClass(value, path, argumentsList, this._hasOnValidate));
    }
    update(fullPath, property, value) {
        this._stack.at(-1).update(fullPath, property, value);
    }
    preferredThisArg(target, thisArgument, thisProxyTarget) {
        const { name: name } = target;
        const isHandledMethod = $02919eed18394599$export$2e2bcd8739ae039.isHandledMethod(thisProxyTarget, name);
        return this._stack.at(-1).preferredThisArg(isHandledMethod, name, thisArgument, thisProxyTarget);
    }
    isChanged(isMutable, value, equals) {
        return this._stack.at(-1).isChanged(isMutable, value, equals);
    }
    isPartOfClone(changePath) {
        return this._stack.at(-1).isPathApplicable(changePath);
    }
    undo(object) {
        if (this._previousClone !== undefined) this._previousClone.undo(object);
    }
    stop() {
        this._previousClone = this._stack.pop();
        return this._previousClone.clone;
    }
}


const $4653b9b2e4d265d3$var$defaultOptions = {
    equals: Object.is,
    isShallow: false,
    pathAsArray: false,
    ignoreSymbols: false,
    ignoreUnderscores: false,
    ignoreDetached: false,
    details: false
};
const $4653b9b2e4d265d3$var$onChange = (object, onChange, options = {})=>{
    options = {
        ...$4653b9b2e4d265d3$var$defaultOptions,
        ...options
    };
    const proxyTarget = Symbol("ProxyTarget");
    const { equals: equals, isShallow: isShallow, ignoreDetached: ignoreDetached, details: details } = options;
    const cache = new (0, $5060998ea41e747b$export$2e2bcd8739ae039)(equals);
    const hasOnValidate = typeof options.onValidate === "function";
    const smartClone = new (0, $02919eed18394599$export$2e2bcd8739ae039)(hasOnValidate);
    // eslint-disable-next-line max-params
    const validate = (target, property, value, previous, applyData)=>!hasOnValidate || smartClone.isCloning || options.onValidate((0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).concat(cache.getPath(target), property), value, previous, applyData) === true;
    const handleChangeOnTarget = (target, property, value, previous)=>{
        if (!(0, $c605e9f8a54fbec0$export$2e2bcd8739ae039)(cache, options, property) && !(ignoreDetached && cache.isDetached(target, object))) handleChange(cache.getPath(target), property, value, previous);
    };
    // eslint-disable-next-line max-params
    const handleChange = (changePath, property, value, previous, applyData)=>{
        if (smartClone.isCloning && smartClone.isPartOfClone(changePath)) smartClone.update(changePath, property, previous);
        else onChange((0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).concat(changePath, property), value, previous, applyData);
    };
    const getProxyTarget = (value)=>value ? value[proxyTarget] ?? value : value;
    const prepareValue = (value, target, property, basePath)=>{
        if ((0, $d4c4991060a66864$export$281bb0ec97352a76)(value) || property === "constructor" || isShallow && !(0, $02919eed18394599$export$2e2bcd8739ae039).isHandledMethod(target, property) || (0, $c605e9f8a54fbec0$export$2e2bcd8739ae039)(cache, options, property) || cache.isGetInvariant(target, property) || ignoreDetached && cache.isDetached(target, object)) return value;
        if (basePath === undefined) basePath = cache.getPath(target);
        /*
  		Check for circular references.

  		If the value already has a corresponding path/proxy,
		and if the path corresponds to one of the parents,
		then we are on a circular case, where the child is pointing to their parent.
		In this case we return the proxy object with the shortest path.
  		*/ const childPath = (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).concat(basePath, property);
        const existingPath = cache.getPath(value);
        if (existingPath && isSameObjectTree(childPath, existingPath)) // We are on the same object tree but deeper, so we use the parent path.
        return cache.getProxy(value, existingPath, handler, proxyTarget);
        return cache.getProxy(value, childPath, handler, proxyTarget);
    };
    /*
	Returns true if `childPath` is a subpath of `existingPath`
	(if childPath starts with existingPath). Otherwise, it returns false.

 	It also returns false if the 2 paths are identical.

 	For example:
	- childPath    = group.layers.0.parent.layers.0.value
	- existingPath = group.layers.0.parent
	*/ const isSameObjectTree = (childPath, existingPath)=>{
        if ((0, $cf15889158c239e3$export$2e2bcd8739ae039)(childPath) || childPath.length <= existingPath.length) return false;
        if ((0, $427bc11931a03951$export$2e2bcd8739ae039)(existingPath) && existingPath.length === 0) return false;
        const childParts = (0, $427bc11931a03951$export$2e2bcd8739ae039)(childPath) ? childPath : childPath.split((0, $2504f0b3cca4f51e$export$f8bb2f9f4607ed91));
        const existingParts = (0, $427bc11931a03951$export$2e2bcd8739ae039)(existingPath) ? existingPath : existingPath.split((0, $2504f0b3cca4f51e$export$f8bb2f9f4607ed91));
        if (childParts.length <= existingParts.length) return false;
        return !existingParts.some((part, index)=>part !== childParts[index]);
    };
    const handler = {
        get (target, property, receiver) {
            if ((0, $cf15889158c239e3$export$2e2bcd8739ae039)(property)) {
                if (property === proxyTarget || property === (0, $2504f0b3cca4f51e$export$9cb8e7b38dc3cece)) return target;
                if (property === (0, $2504f0b3cca4f51e$export$881b71df7abed909) && !cache.isUnsubscribed && cache.getPath(target).length === 0) {
                    cache.unsubscribe();
                    return target;
                }
            }
            const value = (0, $d4c4991060a66864$export$2191e61a810db5fc)(target) ? Reflect.get(target, property) : Reflect.get(target, property, receiver);
            return prepareValue(value, target, property);
        },
        set (target, property, value, receiver) {
            value = getProxyTarget(value);
            const reflectTarget = target[proxyTarget] ?? target;
            const previous = reflectTarget[property];
            if (equals(previous, value) && property in target) return true;
            const isValid = validate(target, property, value, previous);
            if (isValid && cache.setProperty(reflectTarget, property, value, receiver, previous)) {
                handleChangeOnTarget(target, property, target[property], previous);
                return true;
            }
            return !isValid;
        },
        defineProperty (target, property, descriptor) {
            if (!cache.isSameDescriptor(descriptor, target, property)) {
                const previous = target[property];
                if (validate(target, property, descriptor.value, previous) && cache.defineProperty(target, property, descriptor, previous)) handleChangeOnTarget(target, property, descriptor.value, previous);
            }
            return true;
        },
        deleteProperty (target, property) {
            if (!Reflect.has(target, property)) return true;
            const previous = Reflect.get(target, property);
            const isValid = validate(target, property, undefined, previous);
            if (isValid && cache.deleteProperty(target, property, previous)) {
                handleChangeOnTarget(target, property, undefined, previous);
                return true;
            }
            return !isValid;
        },
        apply (target, thisArg, argumentsList) {
            const thisProxyTarget = thisArg[proxyTarget] ?? thisArg;
            if (cache.isUnsubscribed) return Reflect.apply(target, thisProxyTarget, argumentsList);
            if ((details === false || details !== true && !details.includes(target.name)) && (0, $02919eed18394599$export$2e2bcd8739ae039).isHandledType(thisProxyTarget)) {
                let applyPath = (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).initial(cache.getPath(target));
                const isHandledMethod = (0, $02919eed18394599$export$2e2bcd8739ae039).isHandledMethod(thisProxyTarget, target.name);
                smartClone.start(thisProxyTarget, applyPath, argumentsList);
                let result = Reflect.apply(target, smartClone.preferredThisArg(target, thisArg, thisProxyTarget), isHandledMethod ? argumentsList.map((argument)=>getProxyTarget(argument)) : argumentsList);
                const isChanged = smartClone.isChanged(thisProxyTarget, equals);
                const previous = smartClone.stop();
                if ((0, $02919eed18394599$export$2e2bcd8739ae039).isHandledType(result) && isHandledMethod) {
                    if (thisArg instanceof Map && target.name === "get") applyPath = (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).concat(applyPath, argumentsList[0]);
                    result = cache.getProxy(result, applyPath, handler);
                }
                if (isChanged) {
                    const applyData = {
                        name: target.name,
                        args: argumentsList,
                        result: result
                    };
                    const changePath = smartClone.isCloning ? (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).initial(applyPath) : applyPath;
                    const property = smartClone.isCloning ? (0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).last(applyPath) : "";
                    if (validate((0, $b805bfc4fb7b5554$export$2e2bcd8739ae039).get(object, changePath), property, thisProxyTarget, previous, applyData)) handleChange(changePath, property, thisProxyTarget, previous, applyData);
                    else smartClone.undo(thisProxyTarget);
                }
                if ((thisArg instanceof Map || thisArg instanceof Set) && (0, $520e0cce96600b4d$export$2e2bcd8739ae039)(result)) return (0, $9fa21708f3ea0624$export$2e2bcd8739ae039)(result, target, thisArg, applyPath, prepareValue);
                return result;
            }
            return Reflect.apply(target, thisArg, argumentsList);
        }
    };
    const proxy = cache.getProxy(object, options.pathAsArray ? [] : "", handler);
    onChange = onChange.bind(proxy);
    if (hasOnValidate) options.onValidate = options.onValidate.bind(proxy);
    return proxy;
};
$4653b9b2e4d265d3$var$onChange.target = (proxy)=>proxy?.[0, $2504f0b3cca4f51e$export$9cb8e7b38dc3cece] ?? proxy;
$4653b9b2e4d265d3$var$onChange.unsubscribe = (proxy)=>proxy?.[0, $2504f0b3cca4f51e$export$881b71df7abed909] ?? proxy;
var $4653b9b2e4d265d3$export$2e2bcd8739ae039 = $4653b9b2e4d265d3$var$onChange;



class $67c80ffebb6601ac$export$2e2bcd8739ae039 {
    constructor(layers, map, mapState){
        // Initialize properties
        this.layers = layers;
        this.map = map;
        this.mapState = mapState;
        // Create a reactive state object with onChange library
        this.state = (0, $4653b9b2e4d265d3$export$2e2bcd8739ae039)({
            currentFeature: null
        }, this.handleStateChange.bind(this), {
            equals: (a, b)=>a?.uuid === b?.uuid // Compare features by UUID to avoid unnecessary updates
        });
        // Initialize a Mapbox GL Popup
        this.popup = new mapboxgl.Popup({
            closeButton: false,
            closeOnClick: false,
            offset: [
                0,
                -22
            ],
            maxWidth: "300px"
        });
        // Bind event handlers to the instance
        this.handleFeatureMousemove = this.handleFeatureMousemove.bind(this);
        this.handleFeatureMouseleave = this.handleFeatureMouseleave.bind(this);
        this.handleFeatureMouseclick = this.handleFeatureMouseclick.bind(this);
        this.handleFeatureTap = this.handleFeatureTap.bind(this);
        this.handleFeatureUntap = this.handleFeatureUntap.bind(this);
        // Add event listeners based on hover support
        if ((0, $6999c02c9fa8589c$export$81bfe36fdbf6f8bf).matches) {
            this.map.on("mousemove", this.layers, this.handleFeatureMousemove);
            this.map.on("mouseleave", this.layers, this.handleFeatureMouseleave);
            this.map.on("click", this.layers, this.handleFeatureMouseclick);
        } else {
            this.map.on("click", this.layers, this.handleFeatureTap);
            this.map.on("click", this.handleFeatureUntap);
        }
    }
    // Extract relevant feature data
    getFeatureData(feature) {
        return {
            uuid: feature?.properties?.uuid,
            source: feature?.source,
            tooltip: feature?.properties?.tooltip,
            coordinates: feature?.geometry?.coordinates
        };
    }
    // Handle mouse move over a feature
    handleFeatureMousemove(e) {
        if (e.features.length > 0) this.state.currentFeature = this.getFeatureData(e.features[0]);
        else this.state.currentFeature = null;
    }
    // Handle mouse leaving a feature
    handleFeatureMouseleave(e) {
        this.state.currentFeature = null;
    }
    // Handle mouse click on a feature
    handleFeatureMouseclick(e) {
        if (e.features.length > 0) {
            const linkTo = e.features[0]?.properties?.linkTo;
            if (linkTo) // Only close the popup on click if the feature has a linkTo property
            this.state.currentFeature = null;
        }
    }
    // Handle touch tap on a feature
    handleFeatureTap(e) {
        e.preventDefault() // Prevent default to avoid firing Untap event simultaneously
        ;
        if (e.features.length > 0) this.state.currentFeature = this.getFeatureData(e.features[0]);
    }
    // Handle touch untap on a feature
    handleFeatureUntap(e) {
        if (e.defaultPrevented === false) this.state.currentFeature = null;
    }
    // Handle state changes
    handleStateChange(path, feature, previousFeature) {
        if (feature) {
            const { source: source, tooltip: tooltip, coordinates: coordinates } = feature;
            this.popup.setLngLat(coordinates).setOffset([
                0,
                source === "site-places" ? -16 : -22
            ]) // Shift place down
            .setHTML(tooltip).addTo(this.map);
        } else this.popup.remove();
    }
}


// import PopupsPlaces from './PopupsPlaces'
// import PopupsPermanent from './PopupsPermanent'
// import ContentSync from './ContentSync'
mapboxgl.accessToken = window.MBAT;
(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)('[data-component~="map"]', {
    init () {
        this.state = {
            initialCenter: [
                -118.41177918139562,
                34.02107469934661
            ],
            mapData: {},
            initialZoomDesktop: 10,
            initialZoomMobile: 8.5,
            initialMinZoom: 8.5,
            permanentPopup: false
        };
        this.map = new mapboxgl.Map({
            container: this.element,
            style: window.MBSU,
            center: this.state.initialCenter,
            zoom: this.getInitialZoom(),
            minZoom: this.state.initialMinZoom,
            logoPosition: "bottom-right",
            attributionControl: false,
            cooperativeGestures: (0, $6999c02c9fa8589c$export$d0a8044dce8ff2fc)
        });
        this.handlePage = this.handlePage.bind(this);
        this.handleResize = this.handleResize.bind(this);
    },
    connected () {
        this.map.on("load", ()=>{
            this.addControls();
            // Plugins
            this.geojsonLayer = new (0, $8a8fefd6e83d476d$export$2e2bcd8739ae039)("site-geojson", this.map);
            this.PopupsMarkers = new (0, $67c80ffebb6601ac$export$2e2bcd8739ae039)([
                "site-geojson-markers",
                "site-places-markers"
            ], this.map, this.state);
            // this.PopupsPlaces = new PopupsPlaces(['site-places-markers'], this.map, this.state)
            // this.PopupsPermanent = new PopupsPermanent('site-geojson-circles', this.map, this.state)
            // this.ContentSync = new ContentSync('site-geojson-circles', 'site-geojson', this.map)
            this.LayerPlaces = new (0, $8542af7a6ff96e69$export$2e2bcd8739ae039)("site-places", this.map, "site-geojson-clusters");
            this.LayerPlaces.create();
            this.handleInitialPage();
            this.map.touchZoomRotate._tapDragZoom.disable();
            this.resizeObserver = new ResizeObserver(this.handleResize);
            this.resizeObserver.observe(this.element);
            (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:ready");
        });
        (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).on("map:page", this.handlePage);
    },
    disconnected () {
        this.resizeObserver.disconnect();
        this.map.remove();
        this.map = null;
        (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).removeListener("map:page", this.handlePage);
    },
    getInitialZoom () {
        return window.innerWidth > 1024 ? this.state.initialZoomDesktop : this.state.initialZoomMobile;
    },
    getPadding () {
        return window.innerWidth > 1024 ? 100 : 60;
    },
    getCenter (center) {
        if (center) return center;
        else return this.state.initialCenter;
    },
    addControls () {
        this.map.addControl(new mapboxgl.NavigationControl({
            showCompass: false
        }), "bottom-left");
        this.map.addControl(new mapboxgl.AttributionControl({
            compact: true
        }), "bottom-right");
    },
    updateMap (uri) {
        const { geojson: geojson, label: label } = this.state.mapData[uri];
        if (geojson) {
            this.geojsonLayer.update(geojson);
            // Fit geojson, unless points are near each other
            // in which case zoom to the center of the points
            const geoBounds = (0, $aa8e38ff8e47137a$export$2e2bcd8739ae039)(geojson);
            const geoArea = (0, $7971cbca28e1a848$export$2e2bcd8739ae039)((0, $67c15e7241fce3d4$export$2e2bcd8739ae039)(geoBounds));
            if (geoArea > 10000) this.map.fitBounds(geoBounds, {
                padding: this.getPadding()
            });
            else {
                const geoCenter = (0, $32c9121f8cfac973$export$2e2bcd8739ae039)(geojson);
                (0, $6999c02c9fa8589c$export$33a2cf1bd0f02582)(geoCenter?.geometry?.coordinates, this.map);
            }
        }
        // If this is a guides route hide/show the POI layer
        if (uri.startsWith("guides")) this.LayerPlaces.hide();
        else this.LayerPlaces.show();
        // Clear active markers
        (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:clearactive");
    // if (label) {
    //   this.PopupsPermanent.open(geojson)
    // } else {
    //   this.PopupsPermanent.close()
    // }
    },
    async handlePage (uri) {
        if (this.state.mapData[uri] === undefined) try {
            const response = await fetch((0, $6999c02c9fa8589c$export$8f10f63063da874a)(uri), {
                method: "GET"
            });
            const pagedata = await response.json();
            this.state.mapData[uri] = pagedata;
            this.updateMap(uri);
        } catch (e) {}
        else this.updateMap(uri);
    },
    handleInitialPage () {
        this.handlePage((0, $6999c02c9fa8589c$export$fbeb6c75aea2f573)(window.GPLA_APP.state.location));
    },
    handleResize () {
        this.map.resize();
    }
});




(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)("[data-map-hovers]", {
    init () {
        this.children = [
            ...this.element.querySelectorAll("[data-uuid]")
        ];
        this.handleMouseenter = this.handleMouseenter.bind(this);
        this.handleMouseleave = this.handleMouseleave.bind(this);
    },
    connected () {
        this.children.forEach((element)=>{
            element.addEventListener("mouseenter", this.handleMouseenter);
            element.addEventListener("mouseleave", this.handleMouseleave);
        });
    },
    disconnected () {
        this.children.forEach((element)=>{
            element.removeEventListener("mouseenter", this.handleMouseenter);
            element.removeEventListener("mouseleave", this.handleMouseleave);
        });
    },
    handleMouseenter (e) {
        const uuid = e.currentTarget?.dataset?.uuid?.trim();
        if (uuid) (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:setactive", [
            uuid
        ]);
    },
    handleMouseleave () {
        (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:clearactive");
    }
});




(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)("[data-map-click]", {
    init () {
        this.children = [
            ...this.element.querySelectorAll("[data-uuid]")
        ];
        this.handleClick = this.handleClick.bind(this);
    },
    connected () {
        this.children.forEach((element)=>{
            element.addEventListener("click", this.handleClick);
        });
    },
    disconnected () {
        this.children.forEach((element)=>{
            element.removeEventListener("click", this.handleClick);
        });
    },
    handleClick (e) {
        const uuid = e.currentTarget?.dataset?.uuid?.trim();
        if (uuid) {
            (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:setactive", [
                uuid
            ]);
            (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:flyto", [
                uuid
            ]);
        }
    }
});



/**
 * Returns the visible height of an element.
 *
 * @param {HTMLElement} element Element to check the visibility of.
 * @param {number}      offset
 * @param {boolean}     percentage
 *
 * @returns {number}    Visible height of the element in pixels or a percentage of the element's total height.
 */ function $ac666a698b7a7068$export$2e2bcd8739ae039(element, offset, percentage) {
    const viewportHeight = document.documentElement.clientHeight;
    const rect = element.getBoundingClientRect();
    const rectTopOffset = rect.top - offset;
    const rectBottomOffset = rect.bottom - offset;
    const height = rect.bottom - rect.top;
    const visibleTop = rectTopOffset >= 0 && rectTopOffset < viewportHeight;
    const visibleBottom = rectBottomOffset > 0 && rectBottomOffset < viewportHeight;
    const visiblePx = (()=>{
        if (visibleTop) // If both the top and bottom are visible, the whole element is visible
        return visibleBottom ? height : viewportHeight - rect.top;
        if (visibleBottom) return rectBottomOffset;
        if (height > viewportHeight && rectTopOffset < 0) {
            const absTop = Math.abs(rectTopOffset);
            if (absTop < height) // Part of the element is visible
            return height - absTop;
        }
        return 0;
    })();
    if (percentage) return visiblePx / height * 100;
    return visiblePx;
}


/**
 * Returns the most visible element from the instance's NodeList.
 *
 * @param {NodeList<HTMLElement>|string} elements
 * @param {mostVisibleConfig} userOptions
 * @returns {HTMLElement} Most visible element.
 */ function $89dd79db5670a977$var$mostVisible(elements, userOptions) {
    if (typeof elements === "string") // eslint-disable-next-line no-param-reassign
    elements = document.querySelectorAll(elements);
    /** @type {mostVisibleConfig} options * */ const options = {
        ...$89dd79db5670a977$var$mostVisible.defaults,
        ...userOptions
    };
    return Array.from(elements).reduce(([accValue, accElement], element)=>{
        const value = (0, $ac666a698b7a7068$export$2e2bcd8739ae039)(element, options.offset, options.percentage);
        return value > accValue ? [
            value,
            element
        ] : [
            accValue,
            accElement
        ];
    }, [
        0,
        null
    ])[1];
}
/**
 * @typedef {Object} mostVisibleConfig
 * @property {boolean} percentage  Whether to calculate visibility as a percentage of height.
 * @property {number}  offset      An offset to take into account when calculating visibility.
 */ /**
 * @type {mostVisibleConfig}
 */ $89dd79db5670a977$var$mostVisible.defaults = {
    percentage: false,
    offset: 0
};
var $89dd79db5670a977$export$2e2bcd8739ae039 = $89dd79db5670a977$var$mostVisible;



(0, $8f89c991f8e64093$export$f36d6a7a5c09a23e)("[data-map-scroll]", {
    init () {
        this.$elements = [
            ...this.element.querySelectorAll("[data-uuid]")
        ];
        this.handleScroll = this.handleScroll.bind(this);
    },
    connected () {
        window.addEventListener("scroll", this.handleScroll);
    },
    disconnected () {
        window.removeEventListener("scroll", this.handleScroll);
    },
    handleScroll () {
        const visibleLocation = (0, $89dd79db5670a977$export$2e2bcd8739ae039)(this.$elements);
        if (visibleLocation) {
            const uuid = visibleLocation?.dataset?.uuid?.trim();
            if (uuid) (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:setactive", [
                uuid
            ]);
        } else (0, $3104dd1e56b57153$export$ff7a4086e1ae6cb5).emit("map:clearactive");
    }
});


(0, $65b4de7ca7b2ca88$export$2e2bcd8739ae039)();
(0, $0bbedd1cf2657f4d$export$2e2bcd8739ae039)();
(0, $0ffb30c7ca5554ae$export$2e2bcd8739ae039)();
(0, $ad4b2b72846e4da5$export$2e2bcd8739ae039)();
(0, (/*@__PURE__*/$parcel$interopDefault($93307c02d3900b6f$exports)))();
 // import './components/map/ContentSyncComponent'




})();
//# sourceMappingURL=bundle.js.map
